/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.0.3.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import axios, { AxiosError, AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios';

interface ExtendedAxiosRequestConfig extends AxiosRequestConfig, Record<string, any> {};

export class AlertClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    static readonly getAlertTypesPath = "/api/v1/Alert/types";
    static readonly getAlertsPath = "/api/v1/Alert";
    static readonly createAlertPath = "/api/v1/Alert";
    static readonly updateAlertPath = "/api/v1/Alert";
    static readonly deleteAlertsPath = "/api/v1/Alert";
    static readonly getAlertDetailsPath = "/api/v1/Alert/details";
    static readonly activateAlertsPath = "/api/v1/Alert/activate";
    static readonly deactivateAlertsPath = "/api/v1/Alert/deactivate";
    
    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    getAlertTypes(  requestConfig?: ExtendedAxiosRequestConfig | undefined): Promise<FleetResponseOfEnvelopedModelOfAlertTypeVM> {
        let url_ = `${this.baseUrl}${ AlertClient.getAlertTypesPath }`;
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <ExtendedAxiosRequestConfig>{
            ...requestConfig,
            method: "GET",
            url: url_,
            headers: {
                ...requestConfig?.headers,
                "Accept": "application/json"
            },
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAlertTypes(_response);
        });
    }

    protected processGetAlertTypes(response: AxiosResponse): Promise<FleetResponseOfEnvelopedModelOfAlertTypeVM> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FleetResponseOfEnvelopedModelOfAlertTypeVM.fromJS(resultData200);
            return Promise.resolve<FleetResponseOfEnvelopedModelOfAlertTypeVM>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FleetResponseOfEnvelopedModelOfAlertTypeVM>(null as any);
    }

    getAlerts(page: number | undefined , requestConfig?: ExtendedAxiosRequestConfig | undefined): Promise<FleetResponseOfPaginatedModelOfAlertGetVM> {
        let url_ = `${this.baseUrl}${ AlertClient.getAlertsPath }?`;
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <ExtendedAxiosRequestConfig>{
            ...requestConfig,
            method: "GET",
            url: url_,
            headers: {
                ...requestConfig?.headers,
                "Accept": "application/json"
            },
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAlerts(_response);
        });
    }

    protected processGetAlerts(response: AxiosResponse): Promise<FleetResponseOfPaginatedModelOfAlertGetVM> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FleetResponseOfPaginatedModelOfAlertGetVM.fromJS(resultData200);
            return Promise.resolve<FleetResponseOfPaginatedModelOfAlertGetVM>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FleetResponseOfPaginatedModelOfAlertGetVM>(null as any);
    }

    createAlert(alert: AlertCreateVM | null , requestConfig?: ExtendedAxiosRequestConfig | undefined): Promise<FleetResponseOfAlertDetailsGetVM> {
        let url_ = `${this.baseUrl}${ AlertClient.createAlertPath }`;
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(alert);

        let options_ = <ExtendedAxiosRequestConfig>{
            ...requestConfig,
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                ...requestConfig?.headers,
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateAlert(_response);
        });
    }

    protected processCreateAlert(response: AxiosResponse): Promise<FleetResponseOfAlertDetailsGetVM> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FleetResponseOfAlertDetailsGetVM.fromJS(resultData200);
            return Promise.resolve<FleetResponseOfAlertDetailsGetVM>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FleetResponseOfAlertDetailsGetVM>(null as any);
    }

    updateAlert(alert: AlertUpdateVM | null , requestConfig?: ExtendedAxiosRequestConfig | undefined): Promise<FleetResponseOfAlertDetailsGetVM> {
        let url_ = `${this.baseUrl}${ AlertClient.updateAlertPath }`;
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(alert);

        let options_ = <ExtendedAxiosRequestConfig>{
            ...requestConfig,
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                ...requestConfig?.headers,
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateAlert(_response);
        });
    }

    protected processUpdateAlert(response: AxiosResponse): Promise<FleetResponseOfAlertDetailsGetVM> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FleetResponseOfAlertDetailsGetVM.fromJS(resultData200);
            return Promise.resolve<FleetResponseOfAlertDetailsGetVM>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FleetResponseOfAlertDetailsGetVM>(null as any);
    }

    deleteAlerts(alertIds: IdsVM | null , requestConfig?: ExtendedAxiosRequestConfig | undefined): Promise<BaseResponse> {
        let url_ = `${this.baseUrl}${ AlertClient.deleteAlertsPath }`;
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(alertIds);

        let options_ = <ExtendedAxiosRequestConfig>{
            ...requestConfig,
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                ...requestConfig?.headers,
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteAlerts(_response);
        });
    }

    protected processDeleteAlerts(response: AxiosResponse): Promise<BaseResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = BaseResponse.fromJS(resultData200);
            return Promise.resolve<BaseResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BaseResponse>(null as any);
    }

    getAlertDetails(alertId: number , requestConfig?: ExtendedAxiosRequestConfig | undefined): Promise<FleetResponseOfAlertDetailsGetVM> {
        let url_ = `${this.baseUrl}${ AlertClient.getAlertDetailsPath }?`;
        if (alertId === undefined || alertId === null)
            throw new Error("The parameter 'alertId' must be defined and cannot be null.");
        else
            url_ += "alertId=" + encodeURIComponent("" + alertId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <ExtendedAxiosRequestConfig>{
            ...requestConfig,
            method: "GET",
            url: url_,
            headers: {
                ...requestConfig?.headers,
                "Accept": "application/json"
            },
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAlertDetails(_response);
        });
    }

    protected processGetAlertDetails(response: AxiosResponse): Promise<FleetResponseOfAlertDetailsGetVM> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FleetResponseOfAlertDetailsGetVM.fromJS(resultData200);
            return Promise.resolve<FleetResponseOfAlertDetailsGetVM>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FleetResponseOfAlertDetailsGetVM>(null as any);
    }

    activateAlerts(alertIds: IdsVM | null , requestConfig?: ExtendedAxiosRequestConfig | undefined): Promise<BaseResponse> {
        let url_ = `${this.baseUrl}${ AlertClient.activateAlertsPath }`;
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(alertIds);

        let options_ = <ExtendedAxiosRequestConfig>{
            ...requestConfig,
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                ...requestConfig?.headers,
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processActivateAlerts(_response);
        });
    }

    protected processActivateAlerts(response: AxiosResponse): Promise<BaseResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = BaseResponse.fromJS(resultData200);
            return Promise.resolve<BaseResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BaseResponse>(null as any);
    }

    deactivateAlerts(alertIds: IdsVM | null , requestConfig?: ExtendedAxiosRequestConfig | undefined): Promise<BaseResponse> {
        let url_ = `${this.baseUrl}${ AlertClient.deactivateAlertsPath }`;
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(alertIds);

        let options_ = <ExtendedAxiosRequestConfig>{
            ...requestConfig,
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                ...requestConfig?.headers,
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeactivateAlerts(_response);
        });
    }

    protected processDeactivateAlerts(response: AxiosResponse): Promise<BaseResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = BaseResponse.fromJS(resultData200);
            return Promise.resolve<BaseResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BaseResponse>(null as any);
    }
}

export class CameraVideoClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    static readonly getAllVideosPath = "/api/v1/CameraVideo";
    static readonly getByIdPath = "/api/v1/CameraVideo/{videoId}";
    static readonly getCameraEventTypeNamesPath = "/api/v1/CameraVideo/eventTypes";
    static readonly requestVideoPath = "/api/v1/CameraVideo/request";
    static readonly cancelVideoRequestPath = "/api/v1/CameraVideo/request/{videoId}";
    static readonly getAllVideos2Path = "/api/v2/CameraVideo";
    static readonly deleteVideoRequestPath = "/api/v2/CameraVideo";
    static readonly createVideoRequestPath = "/api/v2/CameraVideo/request";
    static readonly getById2Path = "/api/v2/CameraVideo/{videoId}";
    static readonly getVideoFragmentsPath = "/api/v2/CameraVideo/{videoId}/fragments";
    
    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    getAllVideos(filter: CameraVideoFilterVM | null , requestConfig?: ExtendedAxiosRequestConfig | undefined): Promise<FleetResponseOfEnvelopedModelOfCameraVideoVM> {
        let url_ = `${this.baseUrl}${ CameraVideoClient.getAllVideosPath }`;
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filter);

        let options_ = <ExtendedAxiosRequestConfig>{
            ...requestConfig,
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                ...requestConfig?.headers,
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllVideos(_response);
        });
    }

    protected processGetAllVideos(response: AxiosResponse): Promise<FleetResponseOfEnvelopedModelOfCameraVideoVM> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FleetResponseOfEnvelopedModelOfCameraVideoVM.fromJS(resultData200);
            return Promise.resolve<FleetResponseOfEnvelopedModelOfCameraVideoVM>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FleetResponseOfEnvelopedModelOfCameraVideoVM>(null as any);
    }

    getById(videoId: string , requestConfig?: ExtendedAxiosRequestConfig | undefined): Promise<FleetResponseOfCameraVideoVM> {
        let url_ = `${this.baseUrl}${ CameraVideoClient.getByIdPath }`;
        if (videoId === undefined || videoId === null)
            throw new Error("The parameter 'videoId' must be defined.");
        url_ = url_.replace("{videoId}", encodeURIComponent("" + videoId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <ExtendedAxiosRequestConfig>{
            ...requestConfig,
            method: "GET",
            url: url_,
            headers: {
                ...requestConfig?.headers,
                "Accept": "application/json"
            },
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: AxiosResponse): Promise<FleetResponseOfCameraVideoVM> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FleetResponseOfCameraVideoVM.fromJS(resultData200);
            return Promise.resolve<FleetResponseOfCameraVideoVM>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FleetResponseOfCameraVideoVM>(null as any);
    }

    getCameraEventTypeNames(  requestConfig?: ExtendedAxiosRequestConfig | undefined): Promise<FleetResponseOfIReadOnlyDictionaryOfCameraEventTypeAndString> {
        let url_ = `${this.baseUrl}${ CameraVideoClient.getCameraEventTypeNamesPath }`;
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <ExtendedAxiosRequestConfig>{
            ...requestConfig,
            method: "GET",
            url: url_,
            headers: {
                ...requestConfig?.headers,
                "Accept": "application/json"
            },
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCameraEventTypeNames(_response);
        });
    }

    protected processGetCameraEventTypeNames(response: AxiosResponse): Promise<FleetResponseOfIReadOnlyDictionaryOfCameraEventTypeAndString> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FleetResponseOfIReadOnlyDictionaryOfCameraEventTypeAndString.fromJS(resultData200);
            return Promise.resolve<FleetResponseOfIReadOnlyDictionaryOfCameraEventTypeAndString>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FleetResponseOfIReadOnlyDictionaryOfCameraEventTypeAndString>(null as any);
    }

    requestVideo(videoRequest: CameraVideoRequestVM | null , requestConfig?: ExtendedAxiosRequestConfig | undefined): Promise<FleetResponseOfString> {
        let url_ = `${this.baseUrl}${ CameraVideoClient.requestVideoPath }`;
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(videoRequest);

        let options_ = <ExtendedAxiosRequestConfig>{
            ...requestConfig,
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                ...requestConfig?.headers,
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRequestVideo(_response);
        });
    }

    protected processRequestVideo(response: AxiosResponse): Promise<FleetResponseOfString> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FleetResponseOfString.fromJS(resultData200);
            return Promise.resolve<FleetResponseOfString>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FleetResponseOfString>(null as any);
    }

    cancelVideoRequest(videoId: string , requestConfig?: ExtendedAxiosRequestConfig | undefined): Promise<BaseResponse> {
        let url_ = `${this.baseUrl}${ CameraVideoClient.cancelVideoRequestPath }`;
        if (videoId === undefined || videoId === null)
            throw new Error("The parameter 'videoId' must be defined.");
        url_ = url_.replace("{videoId}", encodeURIComponent("" + videoId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <ExtendedAxiosRequestConfig>{
            ...requestConfig,
            method: "DELETE",
            url: url_,
            headers: {
                ...requestConfig?.headers,
                "Accept": "application/json"
            },
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCancelVideoRequest(_response);
        });
    }

    protected processCancelVideoRequest(response: AxiosResponse): Promise<BaseResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = BaseResponse.fromJS(resultData200);
            return Promise.resolve<BaseResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BaseResponse>(null as any);
    }

    getAllVideos2(filter: CameraVideoFilterVM | null , requestConfig?: ExtendedAxiosRequestConfig | undefined): Promise<UiDataResponseOfEnvelopedModelOfCameraVideoGridVM> {
        let url_ = `${this.baseUrl}${ CameraVideoClient.getAllVideos2Path }`;
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filter);

        let options_ = <ExtendedAxiosRequestConfig>{
            ...requestConfig,
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                ...requestConfig?.headers,
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllVideos2(_response);
        });
    }

    protected processGetAllVideos2(response: AxiosResponse): Promise<UiDataResponseOfEnvelopedModelOfCameraVideoGridVM> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UiDataResponseOfEnvelopedModelOfCameraVideoGridVM.fromJS(resultData200);
            return Promise.resolve<UiDataResponseOfEnvelopedModelOfCameraVideoGridVM>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UiDataResponseOfEnvelopedModelOfCameraVideoGridVM>(null as any);
    }

    deleteVideoRequest(requestId: number | undefined , requestConfig?: ExtendedAxiosRequestConfig | undefined): Promise<UiResponse> {
        let url_ = `${this.baseUrl}${ CameraVideoClient.deleteVideoRequestPath }?`;
        if (requestId === null)
            throw new Error("The parameter 'requestId' cannot be null.");
        else if (requestId !== undefined)
            url_ += "requestId=" + encodeURIComponent("" + requestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <ExtendedAxiosRequestConfig>{
            ...requestConfig,
            method: "DELETE",
            url: url_,
            headers: {
                ...requestConfig?.headers,
                "Accept": "application/json"
            },
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteVideoRequest(_response);
        });
    }

    protected processDeleteVideoRequest(response: AxiosResponse): Promise<UiResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UiResponse.fromJS(resultData200);
            return Promise.resolve<UiResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UiResponse>(null as any);
    }

    createVideoRequest(videoRequest: CameraVideoRequestCreateVM | null , requestConfig?: ExtendedAxiosRequestConfig | undefined): Promise<UiDataResponseOfRequestedCameraVideoVM> {
        let url_ = `${this.baseUrl}${ CameraVideoClient.createVideoRequestPath }`;
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(videoRequest);

        let options_ = <ExtendedAxiosRequestConfig>{
            ...requestConfig,
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                ...requestConfig?.headers,
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateVideoRequest(_response);
        });
    }

    protected processCreateVideoRequest(response: AxiosResponse): Promise<UiDataResponseOfRequestedCameraVideoVM> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UiDataResponseOfRequestedCameraVideoVM.fromJS(resultData200);
            return Promise.resolve<UiDataResponseOfRequestedCameraVideoVM>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UiDataResponseOfRequestedCameraVideoVM>(null as any);
    }

    getById2(videoId: string , requestConfig?: ExtendedAxiosRequestConfig | undefined): Promise<UiDataResponseOfCameraVideoGridVM> {
        let url_ = `${this.baseUrl}${ CameraVideoClient.getById2Path }`;
        if (videoId === undefined || videoId === null)
            throw new Error("The parameter 'videoId' must be defined.");
        url_ = url_.replace("{videoId}", encodeURIComponent("" + videoId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <ExtendedAxiosRequestConfig>{
            ...requestConfig,
            method: "GET",
            url: url_,
            headers: {
                ...requestConfig?.headers,
                "Accept": "application/json"
            },
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetById2(_response);
        });
    }

    protected processGetById2(response: AxiosResponse): Promise<UiDataResponseOfCameraVideoGridVM> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UiDataResponseOfCameraVideoGridVM.fromJS(resultData200);
            return Promise.resolve<UiDataResponseOfCameraVideoGridVM>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UiDataResponseOfCameraVideoGridVM>(null as any);
    }

    getVideoFragments(videoId: number , requestConfig?: ExtendedAxiosRequestConfig | undefined): Promise<UiDataResponseOfEnvelopedModelOfCameraVideoFragmentVM> {
        let url_ = `${this.baseUrl}${ CameraVideoClient.getVideoFragmentsPath }`;
        if (videoId === undefined || videoId === null)
            throw new Error("The parameter 'videoId' must be defined.");
        url_ = url_.replace("{videoId}", encodeURIComponent("" + videoId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <ExtendedAxiosRequestConfig>{
            ...requestConfig,
            method: "GET",
            url: url_,
            headers: {
                ...requestConfig?.headers,
                "Accept": "application/json"
            },
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetVideoFragments(_response);
        });
    }

    protected processGetVideoFragments(response: AxiosResponse): Promise<UiDataResponseOfEnvelopedModelOfCameraVideoFragmentVM> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UiDataResponseOfEnvelopedModelOfCameraVideoFragmentVM.fromJS(resultData200);
            return Promise.resolve<UiDataResponseOfEnvelopedModelOfCameraVideoFragmentVM>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UiDataResponseOfEnvelopedModelOfCameraVideoFragmentVM>(null as any);
    }
}

export class ContextClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    static readonly getCurrentPartitionPath = "/api/v1/Context/partition";
    static readonly getCurrentUserPath = "/api/v1/Context/user";
    static readonly getUserAssignedPartitionsPath = "/api/v1/Context/user-partitions";
    static readonly getAvailableFeaturesPath = "/api/v1/Context/available-features";
    
    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    getCurrentPartition(  requestConfig?: ExtendedAxiosRequestConfig | undefined): Promise<FleetResponseOfPartitionVm> {
        let url_ = `${this.baseUrl}${ ContextClient.getCurrentPartitionPath }`;
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <ExtendedAxiosRequestConfig>{
            ...requestConfig,
            method: "GET",
            url: url_,
            headers: {
                ...requestConfig?.headers,
                "Accept": "application/json"
            },
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCurrentPartition(_response);
        });
    }

    protected processGetCurrentPartition(response: AxiosResponse): Promise<FleetResponseOfPartitionVm> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FleetResponseOfPartitionVm.fromJS(resultData200);
            return Promise.resolve<FleetResponseOfPartitionVm>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FleetResponseOfPartitionVm>(null as any);
    }

    getCurrentUser(  requestConfig?: ExtendedAxiosRequestConfig | undefined): Promise<FleetResponseOfApiUserVm> {
        let url_ = `${this.baseUrl}${ ContextClient.getCurrentUserPath }`;
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <ExtendedAxiosRequestConfig>{
            ...requestConfig,
            method: "GET",
            url: url_,
            headers: {
                ...requestConfig?.headers,
                "Accept": "application/json"
            },
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCurrentUser(_response);
        });
    }

    protected processGetCurrentUser(response: AxiosResponse): Promise<FleetResponseOfApiUserVm> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FleetResponseOfApiUserVm.fromJS(resultData200);
            return Promise.resolve<FleetResponseOfApiUserVm>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FleetResponseOfApiUserVm>(null as any);
    }

    getUserAssignedPartitions(  requestConfig?: ExtendedAxiosRequestConfig | undefined): Promise<FleetResponseOfListOfPartitionVm> {
        let url_ = `${this.baseUrl}${ ContextClient.getUserAssignedPartitionsPath }`;
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <ExtendedAxiosRequestConfig>{
            ...requestConfig,
            method: "GET",
            url: url_,
            headers: {
                ...requestConfig?.headers,
                "Accept": "application/json"
            },
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserAssignedPartitions(_response);
        });
    }

    protected processGetUserAssignedPartitions(response: AxiosResponse): Promise<FleetResponseOfListOfPartitionVm> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FleetResponseOfListOfPartitionVm.fromJS(resultData200);
            return Promise.resolve<FleetResponseOfListOfPartitionVm>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FleetResponseOfListOfPartitionVm>(null as any);
    }

    getAvailableFeatures(  requestConfig?: ExtendedAxiosRequestConfig | undefined): Promise<FleetResponseOfFeatureVmOf> {
        let url_ = `${this.baseUrl}${ ContextClient.getAvailableFeaturesPath }`;
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <ExtendedAxiosRequestConfig>{
            ...requestConfig,
            method: "GET",
            url: url_,
            headers: {
                ...requestConfig?.headers,
                "Accept": "application/json"
            },
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAvailableFeatures(_response);
        });
    }

    protected processGetAvailableFeatures(response: AxiosResponse): Promise<FleetResponseOfFeatureVmOf> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FleetResponseOfFeatureVmOf.fromJS(resultData200);
            return Promise.resolve<FleetResponseOfFeatureVmOf>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FleetResponseOfFeatureVmOf>(null as any);
    }
}

export class DeviceClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    static readonly getCameraDevicesPath = "/api/v1/Device/camera";
    static readonly getSummaryPath = "/api/v2/Device/summary";
    static readonly getDataLoggersPath = "/api/v2/Device/dataLogger";
    static readonly getAssetTrackersPath = "/api/v2/Device/assetTracker";
    static readonly getAiCamerasPath = "/api/v2/Device/ai-camera";
    static readonly getCamerasPath = "/api/v2/Device/camera";
    static readonly getCamerasMinimalDataPath = "/api/v2/Device/camera/minimal";
    static readonly calibrateAiCameraPath = "/api/v2/Device/ai-camera/calibrate/{id}";
    static readonly rebootAiCameraPath = "/api/v2/Device/ai-camera/reboot/{id}";
    static readonly formatAiCameraSdCardPath = "/api/v2/Device/ai-camera/formatSdCard/{id}";
    
    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @deprecated
     */
    getCameraDevices(  requestConfig?: ExtendedAxiosRequestConfig | undefined): Promise<FleetResponseOfEnvelopedModelOfCameraDeviceVM> {
        let url_ = `${this.baseUrl}${ DeviceClient.getCameraDevicesPath }`;
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <ExtendedAxiosRequestConfig>{
            ...requestConfig,
            method: "GET",
            url: url_,
            headers: {
                ...requestConfig?.headers,
                "Accept": "application/json"
            },
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCameraDevices(_response);
        });
    }

    protected processGetCameraDevices(response: AxiosResponse): Promise<FleetResponseOfEnvelopedModelOfCameraDeviceVM> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FleetResponseOfEnvelopedModelOfCameraDeviceVM.fromJS(resultData200);
            return Promise.resolve<FleetResponseOfEnvelopedModelOfCameraDeviceVM>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FleetResponseOfEnvelopedModelOfCameraDeviceVM>(null as any);
    }

    getSummary(  requestConfig?: ExtendedAxiosRequestConfig | undefined): Promise<UiDataResponseOfDevicesSummaryVM> {
        let url_ = `${this.baseUrl}${ DeviceClient.getSummaryPath }`;
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <ExtendedAxiosRequestConfig>{
            ...requestConfig,
            method: "GET",
            url: url_,
            headers: {
                ...requestConfig?.headers,
                "Accept": "application/json"
            },
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSummary(_response);
        });
    }

    protected processGetSummary(response: AxiosResponse): Promise<UiDataResponseOfDevicesSummaryVM> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UiDataResponseOfDevicesSummaryVM.fromJS(resultData200);
            return Promise.resolve<UiDataResponseOfDevicesSummaryVM>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UiDataResponseOfDevicesSummaryVM>(null as any);
    }

    getDataLoggers(  requestConfig?: ExtendedAxiosRequestConfig | undefined): Promise<UiDataResponseOfEnvelopedModelOfDataLoggerVM> {
        let url_ = `${this.baseUrl}${ DeviceClient.getDataLoggersPath }`;
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <ExtendedAxiosRequestConfig>{
            ...requestConfig,
            method: "GET",
            url: url_,
            headers: {
                ...requestConfig?.headers,
                "Accept": "application/json"
            },
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDataLoggers(_response);
        });
    }

    protected processGetDataLoggers(response: AxiosResponse): Promise<UiDataResponseOfEnvelopedModelOfDataLoggerVM> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UiDataResponseOfEnvelopedModelOfDataLoggerVM.fromJS(resultData200);
            return Promise.resolve<UiDataResponseOfEnvelopedModelOfDataLoggerVM>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UiDataResponseOfEnvelopedModelOfDataLoggerVM>(null as any);
    }

    getAssetTrackers(  requestConfig?: ExtendedAxiosRequestConfig | undefined): Promise<UiDataResponseOfEnvelopedModelOfAssetTrackerVM> {
        let url_ = `${this.baseUrl}${ DeviceClient.getAssetTrackersPath }`;
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <ExtendedAxiosRequestConfig>{
            ...requestConfig,
            method: "GET",
            url: url_,
            headers: {
                ...requestConfig?.headers,
                "Accept": "application/json"
            },
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAssetTrackers(_response);
        });
    }

    protected processGetAssetTrackers(response: AxiosResponse): Promise<UiDataResponseOfEnvelopedModelOfAssetTrackerVM> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UiDataResponseOfEnvelopedModelOfAssetTrackerVM.fromJS(resultData200);
            return Promise.resolve<UiDataResponseOfEnvelopedModelOfAssetTrackerVM>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UiDataResponseOfEnvelopedModelOfAssetTrackerVM>(null as any);
    }

    getAiCameras(  requestConfig?: ExtendedAxiosRequestConfig | undefined): Promise<UiDataResponseOfEnvelopedModelOfAiCameraVM> {
        let url_ = `${this.baseUrl}${ DeviceClient.getAiCamerasPath }`;
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <ExtendedAxiosRequestConfig>{
            ...requestConfig,
            method: "GET",
            url: url_,
            headers: {
                ...requestConfig?.headers,
                "Accept": "application/json"
            },
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAiCameras(_response);
        });
    }

    protected processGetAiCameras(response: AxiosResponse): Promise<UiDataResponseOfEnvelopedModelOfAiCameraVM> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UiDataResponseOfEnvelopedModelOfAiCameraVM.fromJS(resultData200);
            return Promise.resolve<UiDataResponseOfEnvelopedModelOfAiCameraVM>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UiDataResponseOfEnvelopedModelOfAiCameraVM>(null as any);
    }

    getCameras(  requestConfig?: ExtendedAxiosRequestConfig | undefined): Promise<UiDataResponseOfEnvelopedModelOfCameraVM> {
        let url_ = `${this.baseUrl}${ DeviceClient.getCamerasPath }`;
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <ExtendedAxiosRequestConfig>{
            ...requestConfig,
            method: "GET",
            url: url_,
            headers: {
                ...requestConfig?.headers,
                "Accept": "application/json"
            },
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCameras(_response);
        });
    }

    protected processGetCameras(response: AxiosResponse): Promise<UiDataResponseOfEnvelopedModelOfCameraVM> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UiDataResponseOfEnvelopedModelOfCameraVM.fromJS(resultData200);
            return Promise.resolve<UiDataResponseOfEnvelopedModelOfCameraVM>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UiDataResponseOfEnvelopedModelOfCameraVM>(null as any);
    }

    getCamerasMinimalData(  requestConfig?: ExtendedAxiosRequestConfig | undefined): Promise<UiDataResponseOfEnvelopedModelOfCameraMinimalVM> {
        let url_ = `${this.baseUrl}${ DeviceClient.getCamerasMinimalDataPath }`;
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <ExtendedAxiosRequestConfig>{
            ...requestConfig,
            method: "GET",
            url: url_,
            headers: {
                ...requestConfig?.headers,
                "Accept": "application/json"
            },
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCamerasMinimalData(_response);
        });
    }

    protected processGetCamerasMinimalData(response: AxiosResponse): Promise<UiDataResponseOfEnvelopedModelOfCameraMinimalVM> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UiDataResponseOfEnvelopedModelOfCameraMinimalVM.fromJS(resultData200);
            return Promise.resolve<UiDataResponseOfEnvelopedModelOfCameraMinimalVM>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UiDataResponseOfEnvelopedModelOfCameraMinimalVM>(null as any);
    }

    calibrateAiCamera(id: number , requestConfig?: ExtendedAxiosRequestConfig | undefined): Promise<UiResponse> {
        let url_ = `${this.baseUrl}${ DeviceClient.calibrateAiCameraPath }`;
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <ExtendedAxiosRequestConfig>{
            ...requestConfig,
            method: "POST",
            url: url_,
            headers: {
                ...requestConfig?.headers,
                "Accept": "application/json"
            },
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCalibrateAiCamera(_response);
        });
    }

    protected processCalibrateAiCamera(response: AxiosResponse): Promise<UiResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UiResponse.fromJS(resultData200);
            return Promise.resolve<UiResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UiResponse>(null as any);
    }

    rebootAiCamera(id: number , requestConfig?: ExtendedAxiosRequestConfig | undefined): Promise<UiResponse> {
        let url_ = `${this.baseUrl}${ DeviceClient.rebootAiCameraPath }`;
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <ExtendedAxiosRequestConfig>{
            ...requestConfig,
            method: "POST",
            url: url_,
            headers: {
                ...requestConfig?.headers,
                "Accept": "application/json"
            },
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRebootAiCamera(_response);
        });
    }

    protected processRebootAiCamera(response: AxiosResponse): Promise<UiResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UiResponse.fromJS(resultData200);
            return Promise.resolve<UiResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UiResponse>(null as any);
    }

    formatAiCameraSdCard(id: number , requestConfig?: ExtendedAxiosRequestConfig | undefined): Promise<UiResponse> {
        let url_ = `${this.baseUrl}${ DeviceClient.formatAiCameraSdCardPath }`;
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <ExtendedAxiosRequestConfig>{
            ...requestConfig,
            method: "POST",
            url: url_,
            headers: {
                ...requestConfig?.headers,
                "Accept": "application/json"
            },
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFormatAiCameraSdCard(_response);
        });
    }

    protected processFormatAiCameraSdCard(response: AxiosResponse): Promise<UiResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UiResponse.fromJS(resultData200);
            return Promise.resolve<UiResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UiResponse>(null as any);
    }
}

export class EventExportCsvClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    static readonly exportToCsvPath = "/api/v1/event/export/csv";
    
    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    exportToCsv(eventFilter: EventReportExportModel | null , requestConfig?: ExtendedAxiosRequestConfig | undefined): Promise<void> {
        let url_ = `${this.baseUrl}${ EventExportCsvClient.exportToCsvPath }`;
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(eventFilter);

        let options_ = <ExtendedAxiosRequestConfig>{
            ...requestConfig,
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                ...requestConfig?.headers,
                "Content-Type": "application/json",
            },
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportToCsv(_response);
        });
    }

    protected processExportToCsv(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class EventStorageClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    static readonly getGpsDataPath = "/api/v1/EventStorage/gps/search";
    static readonly getGpsDataByIdPath = "/api/v1/EventStorage/gps/{id}";
    static readonly getEventFiltersDataPrecalculatedPath = "/api/v1/EventStorage/events/filtersData/precalculated";
    static readonly getAllEventsPath = "/api/v1/EventStorage/events/search";
    static readonly getEventByIdPath = "/api/v1/EventStorage/events/{id}";
    static readonly getLatestVehicleLocationsPath = "/api/v1/EventStorage/locations/vehicles/latest";
    static readonly getVehicleLocationsPath = "/api/v1/EventStorage/locations/vehicles";
    static readonly getLatestTrackedResourceLocationsPath = "/api/v1/EventStorage/locations/latestTrackedResources";
    static readonly getTrackedResourceLocationsPath = "/api/v1/EventStorage/locations/trackedResources";
    
    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    getGpsData(inputModel: EventFilterVm | null , requestConfig?: ExtendedAxiosRequestConfig | undefined): Promise<FleetResponseOfPaginatedModelOfEventVm> {
        let url_ = `${this.baseUrl}${ EventStorageClient.getGpsDataPath }`;
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(inputModel);

        let options_ = <ExtendedAxiosRequestConfig>{
            ...requestConfig,
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                ...requestConfig?.headers,
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetGpsData(_response);
        });
    }

    protected processGetGpsData(response: AxiosResponse): Promise<FleetResponseOfPaginatedModelOfEventVm> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FleetResponseOfPaginatedModelOfEventVm.fromJS(resultData200);
            return Promise.resolve<FleetResponseOfPaginatedModelOfEventVm>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FleetResponseOfPaginatedModelOfEventVm>(null as any);
    }

    getGpsDataById(id: string , requestConfig?: ExtendedAxiosRequestConfig | undefined): Promise<FleetResponseOfEventVm> {
        let url_ = `${this.baseUrl}${ EventStorageClient.getGpsDataByIdPath }`;
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <ExtendedAxiosRequestConfig>{
            ...requestConfig,
            method: "GET",
            url: url_,
            headers: {
                ...requestConfig?.headers,
                "Accept": "application/json"
            },
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetGpsDataById(_response);
        });
    }

    protected processGetGpsDataById(response: AxiosResponse): Promise<FleetResponseOfEventVm> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FleetResponseOfEventVm.fromJS(resultData200);
            return Promise.resolve<FleetResponseOfEventVm>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FleetResponseOfEventVm>(null as any);
    }

    getEventFiltersDataPrecalculated(dateTimeFilterModel: DateTimeFilterModel | null , requestConfig?: ExtendedAxiosRequestConfig | undefined): Promise<FleetResponseOfEventFilterDataVM> {
        let url_ = `${this.baseUrl}${ EventStorageClient.getEventFiltersDataPrecalculatedPath }`;
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dateTimeFilterModel);

        let options_ = <ExtendedAxiosRequestConfig>{
            ...requestConfig,
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                ...requestConfig?.headers,
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetEventFiltersDataPrecalculated(_response);
        });
    }

    protected processGetEventFiltersDataPrecalculated(response: AxiosResponse): Promise<FleetResponseOfEventFilterDataVM> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FleetResponseOfEventFilterDataVM.fromJS(resultData200);
            return Promise.resolve<FleetResponseOfEventFilterDataVM>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FleetResponseOfEventFilterDataVM>(null as any);
    }

    getAllEvents(inputModel: EventFilterVm | null , requestConfig?: ExtendedAxiosRequestConfig | undefined): Promise<FleetResponseOfPaginatedModelOfEventVm> {
        let url_ = `${this.baseUrl}${ EventStorageClient.getAllEventsPath }`;
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(inputModel);

        let options_ = <ExtendedAxiosRequestConfig>{
            ...requestConfig,
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                ...requestConfig?.headers,
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllEvents(_response);
        });
    }

    protected processGetAllEvents(response: AxiosResponse): Promise<FleetResponseOfPaginatedModelOfEventVm> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FleetResponseOfPaginatedModelOfEventVm.fromJS(resultData200);
            return Promise.resolve<FleetResponseOfPaginatedModelOfEventVm>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FleetResponseOfPaginatedModelOfEventVm>(null as any);
    }

    getEventById(id: string , requestConfig?: ExtendedAxiosRequestConfig | undefined): Promise<FleetResponseOfEventVm> {
        let url_ = `${this.baseUrl}${ EventStorageClient.getEventByIdPath }`;
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <ExtendedAxiosRequestConfig>{
            ...requestConfig,
            method: "GET",
            url: url_,
            headers: {
                ...requestConfig?.headers,
                "Accept": "application/json"
            },
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetEventById(_response);
        });
    }

    protected processGetEventById(response: AxiosResponse): Promise<FleetResponseOfEventVm> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FleetResponseOfEventVm.fromJS(resultData200);
            return Promise.resolve<FleetResponseOfEventVm>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FleetResponseOfEventVm>(null as any);
    }

    getLatestVehicleLocations(  requestConfig?: ExtendedAxiosRequestConfig | undefined): Promise<FleetResponseOfEnvelopedModelOfVehicleLocationVM> {
        let url_ = `${this.baseUrl}${ EventStorageClient.getLatestVehicleLocationsPath }`;
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <ExtendedAxiosRequestConfig>{
            ...requestConfig,
            method: "GET",
            url: url_,
            headers: {
                ...requestConfig?.headers,
                "Accept": "application/json"
            },
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLatestVehicleLocations(_response);
        });
    }

    protected processGetLatestVehicleLocations(response: AxiosResponse): Promise<FleetResponseOfEnvelopedModelOfVehicleLocationVM> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FleetResponseOfEnvelopedModelOfVehicleLocationVM.fromJS(resultData200);
            return Promise.resolve<FleetResponseOfEnvelopedModelOfVehicleLocationVM>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FleetResponseOfEnvelopedModelOfVehicleLocationVM>(null as any);
    }

    getVehicleLocations(requestVm: VehicleLocationsRequestVM | null , requestConfig?: ExtendedAxiosRequestConfig | undefined): Promise<FleetResponseOfEnvelopedModelOfVehicleLocationVM> {
        let url_ = `${this.baseUrl}${ EventStorageClient.getVehicleLocationsPath }`;
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requestVm);

        let options_ = <ExtendedAxiosRequestConfig>{
            ...requestConfig,
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                ...requestConfig?.headers,
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetVehicleLocations(_response);
        });
    }

    protected processGetVehicleLocations(response: AxiosResponse): Promise<FleetResponseOfEnvelopedModelOfVehicleLocationVM> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FleetResponseOfEnvelopedModelOfVehicleLocationVM.fromJS(resultData200);
            return Promise.resolve<FleetResponseOfEnvelopedModelOfVehicleLocationVM>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FleetResponseOfEnvelopedModelOfVehicleLocationVM>(null as any);
    }

    getLatestTrackedResourceLocations(  requestConfig?: ExtendedAxiosRequestConfig | undefined): Promise<FleetResponseOfEnvelopedModelOfTrackedResourceLocationVM> {
        let url_ = `${this.baseUrl}${ EventStorageClient.getLatestTrackedResourceLocationsPath }`;
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <ExtendedAxiosRequestConfig>{
            ...requestConfig,
            method: "GET",
            url: url_,
            headers: {
                ...requestConfig?.headers,
                "Accept": "application/json"
            },
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLatestTrackedResourceLocations(_response);
        });
    }

    protected processGetLatestTrackedResourceLocations(response: AxiosResponse): Promise<FleetResponseOfEnvelopedModelOfTrackedResourceLocationVM> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FleetResponseOfEnvelopedModelOfTrackedResourceLocationVM.fromJS(resultData200);
            return Promise.resolve<FleetResponseOfEnvelopedModelOfTrackedResourceLocationVM>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FleetResponseOfEnvelopedModelOfTrackedResourceLocationVM>(null as any);
    }

    getTrackedResourceLocations(requestVm: TrackedResourceLocationsRequestVM | null , requestConfig?: ExtendedAxiosRequestConfig | undefined): Promise<FleetResponseOfEnvelopedModelOfTrackedResourceLocationVM> {
        let url_ = `${this.baseUrl}${ EventStorageClient.getTrackedResourceLocationsPath }`;
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requestVm);

        let options_ = <ExtendedAxiosRequestConfig>{
            ...requestConfig,
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                ...requestConfig?.headers,
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTrackedResourceLocations(_response);
        });
    }

    protected processGetTrackedResourceLocations(response: AxiosResponse): Promise<FleetResponseOfEnvelopedModelOfTrackedResourceLocationVM> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FleetResponseOfEnvelopedModelOfTrackedResourceLocationVM.fromJS(resultData200);
            return Promise.resolve<FleetResponseOfEnvelopedModelOfTrackedResourceLocationVM>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FleetResponseOfEnvelopedModelOfTrackedResourceLocationVM>(null as any);
    }
}

export class FeatureFlagClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    static readonly getContextPath = "/api/v1/FeatureFlag/context";
    
    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    getContext(  requestConfig?: ExtendedAxiosRequestConfig | undefined): Promise<FleetResponseOfIReadOnlyDictionaryOfStringAndString> {
        let url_ = `${this.baseUrl}${ FeatureFlagClient.getContextPath }`;
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <ExtendedAxiosRequestConfig>{
            ...requestConfig,
            method: "GET",
            url: url_,
            headers: {
                ...requestConfig?.headers,
                "Accept": "application/json"
            },
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetContext(_response);
        });
    }

    protected processGetContext(response: AxiosResponse): Promise<FleetResponseOfIReadOnlyDictionaryOfStringAndString> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FleetResponseOfIReadOnlyDictionaryOfStringAndString.fromJS(resultData200);
            return Promise.resolve<FleetResponseOfIReadOnlyDictionaryOfStringAndString>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FleetResponseOfIReadOnlyDictionaryOfStringAndString>(null as any);
    }
}

export class FleetAssetClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    static readonly getAssetsPath = "/api/v1/FleetAsset";
    static readonly updateAssetPath = "/api/v1/FleetAsset";
    static readonly getAssetPath = "/api/v1/FleetAsset/{id}";
    
    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    getAssets(  requestConfig?: ExtendedAxiosRequestConfig | undefined): Promise<FleetResponseOfEnvelopedModelOfFleetAssetLightVm> {
        let url_ = `${this.baseUrl}${ FleetAssetClient.getAssetsPath }`;
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <ExtendedAxiosRequestConfig>{
            ...requestConfig,
            method: "GET",
            url: url_,
            headers: {
                ...requestConfig?.headers,
                "Accept": "application/json"
            },
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAssets(_response);
        });
    }

    protected processGetAssets(response: AxiosResponse): Promise<FleetResponseOfEnvelopedModelOfFleetAssetLightVm> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FleetResponseOfEnvelopedModelOfFleetAssetLightVm.fromJS(resultData200);
            return Promise.resolve<FleetResponseOfEnvelopedModelOfFleetAssetLightVm>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FleetResponseOfEnvelopedModelOfFleetAssetLightVm>(null as any);
    }

    updateAsset(asset: FleetAssetUpdateVm | null , requestConfig?: ExtendedAxiosRequestConfig | undefined): Promise<FleetResponseOfFleetAssetVm> {
        let url_ = `${this.baseUrl}${ FleetAssetClient.updateAssetPath }`;
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(asset);

        let options_ = <ExtendedAxiosRequestConfig>{
            ...requestConfig,
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                ...requestConfig?.headers,
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateAsset(_response);
        });
    }

    protected processUpdateAsset(response: AxiosResponse): Promise<FleetResponseOfFleetAssetVm> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FleetResponseOfFleetAssetVm.fromJS(resultData200);
            return Promise.resolve<FleetResponseOfFleetAssetVm>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FleetResponseOfFleetAssetVm>(null as any);
    }

    getAsset(id: number , requestConfig?: ExtendedAxiosRequestConfig | undefined): Promise<FleetResponseOfFleetAssetVm> {
        let url_ = `${this.baseUrl}${ FleetAssetClient.getAssetPath }`;
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <ExtendedAxiosRequestConfig>{
            ...requestConfig,
            method: "GET",
            url: url_,
            headers: {
                ...requestConfig?.headers,
                "Accept": "application/json"
            },
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAsset(_response);
        });
    }

    protected processGetAsset(response: AxiosResponse): Promise<FleetResponseOfFleetAssetVm> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FleetResponseOfFleetAssetVm.fromJS(resultData200);
            return Promise.resolve<FleetResponseOfFleetAssetVm>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FleetResponseOfFleetAssetVm>(null as any);
    }
}

export class FleetUserClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    static readonly getFleetUsersPath = "/api/v1/FleetUser";
    static readonly getUsersByRolePath = "/api/v1/FleetUser/group-by-role";
    static readonly updateUserPath = "/api/v1/FleetUser/user";
    static readonly saveUserMappingsPath = "/api/v1/FleetUser/mapping";
    
    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    getFleetUsers(userType: string | null | undefined , requestConfig?: ExtendedAxiosRequestConfig | undefined): Promise<FleetResponseOfEnvelopedModelOfUserVM> {
        let url_ = `${this.baseUrl}${ FleetUserClient.getFleetUsersPath }?`;
        if (userType !== undefined && userType !== null)
            url_ += "userType=" + encodeURIComponent("" + userType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <ExtendedAxiosRequestConfig>{
            ...requestConfig,
            method: "GET",
            url: url_,
            headers: {
                ...requestConfig?.headers,
                "Accept": "application/json"
            },
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFleetUsers(_response);
        });
    }

    protected processGetFleetUsers(response: AxiosResponse): Promise<FleetResponseOfEnvelopedModelOfUserVM> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FleetResponseOfEnvelopedModelOfUserVM.fromJS(resultData200);
            return Promise.resolve<FleetResponseOfEnvelopedModelOfUserVM>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FleetResponseOfEnvelopedModelOfUserVM>(null as any);
    }

    getUsersByRole(  requestConfig?: ExtendedAxiosRequestConfig | undefined): Promise<FleetResponseOfEnvelopedModelOfTreeVM> {
        let url_ = `${this.baseUrl}${ FleetUserClient.getUsersByRolePath }`;
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <ExtendedAxiosRequestConfig>{
            ...requestConfig,
            method: "GET",
            url: url_,
            headers: {
                ...requestConfig?.headers,
                "Accept": "application/json"
            },
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUsersByRole(_response);
        });
    }

    protected processGetUsersByRole(response: AxiosResponse): Promise<FleetResponseOfEnvelopedModelOfTreeVM> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FleetResponseOfEnvelopedModelOfTreeVM.fromJS(resultData200);
            return Promise.resolve<FleetResponseOfEnvelopedModelOfTreeVM>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FleetResponseOfEnvelopedModelOfTreeVM>(null as any);
    }

    updateUser(user: UserVM | null , requestConfig?: ExtendedAxiosRequestConfig | undefined): Promise<FleetResponseOfUserVM> {
        let url_ = `${this.baseUrl}${ FleetUserClient.updateUserPath }`;
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(user);

        let options_ = <ExtendedAxiosRequestConfig>{
            ...requestConfig,
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                ...requestConfig?.headers,
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateUser(_response);
        });
    }

    protected processUpdateUser(response: AxiosResponse): Promise<FleetResponseOfUserVM> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FleetResponseOfUserVM.fromJS(resultData200);
            return Promise.resolve<FleetResponseOfUserVM>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FleetResponseOfUserVM>(null as any);
    }

    saveUserMappings(userMappings: UserMappingVM[] | null , requestConfig?: ExtendedAxiosRequestConfig | undefined): Promise<FleetResponseOfString> {
        let url_ = `${this.baseUrl}${ FleetUserClient.saveUserMappingsPath }`;
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(userMappings);

        let options_ = <ExtendedAxiosRequestConfig>{
            ...requestConfig,
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                ...requestConfig?.headers,
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveUserMappings(_response);
        });
    }

    protected processSaveUserMappings(response: AxiosResponse): Promise<FleetResponseOfString> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FleetResponseOfString.fromJS(resultData200);
            return Promise.resolve<FleetResponseOfString>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FleetResponseOfString>(null as any);
    }
}

export class GeofenceClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    static readonly getGeofenceCategoriesPath = "/api/v1/Geofence/categories";
    static readonly getGeofencesPath = "/api/v1/Geofence";
    static readonly createGeofencePath = "/api/v1/Geofence";
    static readonly updateGeofencePath = "/api/v1/Geofence";
    static readonly deleteGeofencesPath = "/api/v1/Geofence";
    static readonly getGeofenceDetailsPath = "/api/v1/Geofence/details";
    
    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    getGeofenceCategories(  requestConfig?: ExtendedAxiosRequestConfig | undefined): Promise<FleetResponseOfEnvelopedModelOfTreeVM> {
        let url_ = `${this.baseUrl}${ GeofenceClient.getGeofenceCategoriesPath }`;
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <ExtendedAxiosRequestConfig>{
            ...requestConfig,
            method: "GET",
            url: url_,
            headers: {
                ...requestConfig?.headers,
                "Accept": "application/json"
            },
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetGeofenceCategories(_response);
        });
    }

    protected processGetGeofenceCategories(response: AxiosResponse): Promise<FleetResponseOfEnvelopedModelOfTreeVM> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FleetResponseOfEnvelopedModelOfTreeVM.fromJS(resultData200);
            return Promise.resolve<FleetResponseOfEnvelopedModelOfTreeVM>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FleetResponseOfEnvelopedModelOfTreeVM>(null as any);
    }

    getGeofences(page: number | undefined , requestConfig?: ExtendedAxiosRequestConfig | undefined): Promise<FleetResponseOfPaginatedModelOfGeofenceLightVM> {
        let url_ = `${this.baseUrl}${ GeofenceClient.getGeofencesPath }?`;
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <ExtendedAxiosRequestConfig>{
            ...requestConfig,
            method: "GET",
            url: url_,
            headers: {
                ...requestConfig?.headers,
                "Accept": "application/json"
            },
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetGeofences(_response);
        });
    }

    protected processGetGeofences(response: AxiosResponse): Promise<FleetResponseOfPaginatedModelOfGeofenceLightVM> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FleetResponseOfPaginatedModelOfGeofenceLightVM.fromJS(resultData200);
            return Promise.resolve<FleetResponseOfPaginatedModelOfGeofenceLightVM>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FleetResponseOfPaginatedModelOfGeofenceLightVM>(null as any);
    }

    createGeofence(geofence: GeofenceVM | null , requestConfig?: ExtendedAxiosRequestConfig | undefined): Promise<FleetResponseOfGeofenceVM> {
        let url_ = `${this.baseUrl}${ GeofenceClient.createGeofencePath }`;
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(geofence);

        let options_ = <ExtendedAxiosRequestConfig>{
            ...requestConfig,
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                ...requestConfig?.headers,
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateGeofence(_response);
        });
    }

    protected processCreateGeofence(response: AxiosResponse): Promise<FleetResponseOfGeofenceVM> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FleetResponseOfGeofenceVM.fromJS(resultData200);
            return Promise.resolve<FleetResponseOfGeofenceVM>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FleetResponseOfGeofenceVM>(null as any);
    }

    updateGeofence(geofence: GeofenceVM | null , requestConfig?: ExtendedAxiosRequestConfig | undefined): Promise<FleetResponseOfGeofenceVM> {
        let url_ = `${this.baseUrl}${ GeofenceClient.updateGeofencePath }`;
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(geofence);

        let options_ = <ExtendedAxiosRequestConfig>{
            ...requestConfig,
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                ...requestConfig?.headers,
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateGeofence(_response);
        });
    }

    protected processUpdateGeofence(response: AxiosResponse): Promise<FleetResponseOfGeofenceVM> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FleetResponseOfGeofenceVM.fromJS(resultData200);
            return Promise.resolve<FleetResponseOfGeofenceVM>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FleetResponseOfGeofenceVM>(null as any);
    }

    deleteGeofences(geofenceIds: IdsVM | null , requestConfig?: ExtendedAxiosRequestConfig | undefined): Promise<BaseResponse> {
        let url_ = `${this.baseUrl}${ GeofenceClient.deleteGeofencesPath }`;
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(geofenceIds);

        let options_ = <ExtendedAxiosRequestConfig>{
            ...requestConfig,
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                ...requestConfig?.headers,
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteGeofences(_response);
        });
    }

    protected processDeleteGeofences(response: AxiosResponse): Promise<BaseResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = BaseResponse.fromJS(resultData200);
            return Promise.resolve<BaseResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BaseResponse>(null as any);
    }

    getGeofenceDetails(geofenceId: number , requestConfig?: ExtendedAxiosRequestConfig | undefined): Promise<FleetResponseOfGeofenceVM> {
        let url_ = `${this.baseUrl}${ GeofenceClient.getGeofenceDetailsPath }?`;
        if (geofenceId === undefined || geofenceId === null)
            throw new Error("The parameter 'geofenceId' must be defined and cannot be null.");
        else
            url_ += "geofenceId=" + encodeURIComponent("" + geofenceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <ExtendedAxiosRequestConfig>{
            ...requestConfig,
            method: "GET",
            url: url_,
            headers: {
                ...requestConfig?.headers,
                "Accept": "application/json"
            },
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetGeofenceDetails(_response);
        });
    }

    protected processGetGeofenceDetails(response: AxiosResponse): Promise<FleetResponseOfGeofenceVM> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FleetResponseOfGeofenceVM.fromJS(resultData200);
            return Promise.resolve<FleetResponseOfGeofenceVM>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FleetResponseOfGeofenceVM>(null as any);
    }
}

export class GroupClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    static readonly getGroupsPath = "/api/v1/Group";
    static readonly createGroupPath = "/api/v1/Group";
    static readonly updateGroupPath = "/api/v1/Group";
    static readonly removeGroupPath = "/api/v1/Group";
    static readonly removeGroupsBulkPath = "/api/v1/Group/bulk/delete";
    
    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    getGroups(  requestConfig?: ExtendedAxiosRequestConfig | undefined): Promise<FleetResponseOfEnvelopedModelOfGroupVM> {
        let url_ = `${this.baseUrl}${ GroupClient.getGroupsPath }`;
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <ExtendedAxiosRequestConfig>{
            ...requestConfig,
            method: "GET",
            url: url_,
            headers: {
                ...requestConfig?.headers,
                "Accept": "application/json"
            },
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetGroups(_response);
        });
    }

    protected processGetGroups(response: AxiosResponse): Promise<FleetResponseOfEnvelopedModelOfGroupVM> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FleetResponseOfEnvelopedModelOfGroupVM.fromJS(resultData200);
            return Promise.resolve<FleetResponseOfEnvelopedModelOfGroupVM>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FleetResponseOfEnvelopedModelOfGroupVM>(null as any);
    }

    createGroup(group: GroupVM | null , requestConfig?: ExtendedAxiosRequestConfig | undefined): Promise<FleetResponseOfGroupVM> {
        let url_ = `${this.baseUrl}${ GroupClient.createGroupPath }`;
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(group);

        let options_ = <ExtendedAxiosRequestConfig>{
            ...requestConfig,
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                ...requestConfig?.headers,
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateGroup(_response);
        });
    }

    protected processCreateGroup(response: AxiosResponse): Promise<FleetResponseOfGroupVM> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FleetResponseOfGroupVM.fromJS(resultData200);
            return Promise.resolve<FleetResponseOfGroupVM>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FleetResponseOfGroupVM>(null as any);
    }

    updateGroup(group: GroupVM | null , requestConfig?: ExtendedAxiosRequestConfig | undefined): Promise<FleetResponseOfGroupVM> {
        let url_ = `${this.baseUrl}${ GroupClient.updateGroupPath }`;
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(group);

        let options_ = <ExtendedAxiosRequestConfig>{
            ...requestConfig,
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                ...requestConfig?.headers,
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateGroup(_response);
        });
    }

    protected processUpdateGroup(response: AxiosResponse): Promise<FleetResponseOfGroupVM> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FleetResponseOfGroupVM.fromJS(resultData200);
            return Promise.resolve<FleetResponseOfGroupVM>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FleetResponseOfGroupVM>(null as any);
    }

    removeGroup(groupId: number | undefined , requestConfig?: ExtendedAxiosRequestConfig | undefined): Promise<FleetResponseOfLong> {
        let url_ = `${this.baseUrl}${ GroupClient.removeGroupPath }?`;
        if (groupId === null)
            throw new Error("The parameter 'groupId' cannot be null.");
        else if (groupId !== undefined)
            url_ += "groupId=" + encodeURIComponent("" + groupId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <ExtendedAxiosRequestConfig>{
            ...requestConfig,
            method: "DELETE",
            url: url_,
            headers: {
                ...requestConfig?.headers,
                "Accept": "application/json"
            },
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemoveGroup(_response);
        });
    }

    protected processRemoveGroup(response: AxiosResponse): Promise<FleetResponseOfLong> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FleetResponseOfLong.fromJS(resultData200);
            return Promise.resolve<FleetResponseOfLong>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FleetResponseOfLong>(null as any);
    }

    removeGroupsBulk(groupIds: number[] | null , requestConfig?: ExtendedAxiosRequestConfig | undefined): Promise<FleetResponseOfIEnumerableOfLong> {
        let url_ = `${this.baseUrl}${ GroupClient.removeGroupsBulkPath }`;
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(groupIds);

        let options_ = <ExtendedAxiosRequestConfig>{
            ...requestConfig,
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                ...requestConfig?.headers,
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemoveGroupsBulk(_response);
        });
    }

    protected processRemoveGroupsBulk(response: AxiosResponse): Promise<FleetResponseOfIEnumerableOfLong> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FleetResponseOfIEnumerableOfLong.fromJS(resultData200);
            return Promise.resolve<FleetResponseOfIEnumerableOfLong>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FleetResponseOfIEnumerableOfLong>(null as any);
    }
}

export class MaintenanceClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    static readonly getRemindersPath = "/api/v1/Maintenance/reminders";
    static readonly createReminderPath = "/api/v1/Maintenance/reminders";
    static readonly updateReminderPath = "/api/v1/Maintenance/reminders";
    static readonly deleteRemindersPath = "/api/v1/Maintenance/reminders";
    static readonly getRemindersShortInfosPath = "/api/v1/Maintenance/reminders-info";
    static readonly getReminderByIdPath = "/api/v1/Maintenance/reminders/{reminderId}";
    static readonly updateReminderNotificationSettingsPath = "/api/v1/Maintenance/reminders/settings";
    static readonly getServiceTypesPath = "/api/v1/Maintenance/service-types";
    static readonly createServiceTypePath = "/api/v1/Maintenance/service-types";
    static readonly deleteServiceTypePath = "/api/v1/Maintenance/service-types";
    
    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    getReminders(  requestConfig?: ExtendedAxiosRequestConfig | undefined): Promise<FleetResponseOfEnvelopedModelOfMaintenanceReminderGridVM> {
        let url_ = `${this.baseUrl}${ MaintenanceClient.getRemindersPath }`;
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <ExtendedAxiosRequestConfig>{
            ...requestConfig,
            method: "GET",
            url: url_,
            headers: {
                ...requestConfig?.headers,
                "Accept": "application/json"
            },
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetReminders(_response);
        });
    }

    protected processGetReminders(response: AxiosResponse): Promise<FleetResponseOfEnvelopedModelOfMaintenanceReminderGridVM> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FleetResponseOfEnvelopedModelOfMaintenanceReminderGridVM.fromJS(resultData200);
            return Promise.resolve<FleetResponseOfEnvelopedModelOfMaintenanceReminderGridVM>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FleetResponseOfEnvelopedModelOfMaintenanceReminderGridVM>(null as any);
    }

    createReminder(reminder: MaintenanceReminderCreateVM | null , requestConfig?: ExtendedAxiosRequestConfig | undefined): Promise<FleetResponseOfMaintenanceReminderDetailsVM> {
        let url_ = `${this.baseUrl}${ MaintenanceClient.createReminderPath }`;
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(reminder);

        let options_ = <ExtendedAxiosRequestConfig>{
            ...requestConfig,
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                ...requestConfig?.headers,
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateReminder(_response);
        });
    }

    protected processCreateReminder(response: AxiosResponse): Promise<FleetResponseOfMaintenanceReminderDetailsVM> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FleetResponseOfMaintenanceReminderDetailsVM.fromJS(resultData200);
            return Promise.resolve<FleetResponseOfMaintenanceReminderDetailsVM>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FleetResponseOfMaintenanceReminderDetailsVM>(null as any);
    }

    updateReminder(reminder: MaintenanceReminderUpdateVM | null , requestConfig?: ExtendedAxiosRequestConfig | undefined): Promise<FleetResponseOfMaintenanceReminderDetailsVM> {
        let url_ = `${this.baseUrl}${ MaintenanceClient.updateReminderPath }`;
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(reminder);

        let options_ = <ExtendedAxiosRequestConfig>{
            ...requestConfig,
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                ...requestConfig?.headers,
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateReminder(_response);
        });
    }

    protected processUpdateReminder(response: AxiosResponse): Promise<FleetResponseOfMaintenanceReminderDetailsVM> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FleetResponseOfMaintenanceReminderDetailsVM.fromJS(resultData200);
            return Promise.resolve<FleetResponseOfMaintenanceReminderDetailsVM>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FleetResponseOfMaintenanceReminderDetailsVM>(null as any);
    }

    deleteReminders(ids: IdsVM | null , requestConfig?: ExtendedAxiosRequestConfig | undefined): Promise<BaseResponse> {
        let url_ = `${this.baseUrl}${ MaintenanceClient.deleteRemindersPath }`;
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(ids);

        let options_ = <ExtendedAxiosRequestConfig>{
            ...requestConfig,
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                ...requestConfig?.headers,
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteReminders(_response);
        });
    }

    protected processDeleteReminders(response: AxiosResponse): Promise<BaseResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = BaseResponse.fromJS(resultData200);
            return Promise.resolve<BaseResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BaseResponse>(null as any);
    }

    getRemindersShortInfos(  requestConfig?: ExtendedAxiosRequestConfig | undefined): Promise<FleetResponseOfEnvelopedModelOfMaintenanceReminderShortInfoVM> {
        let url_ = `${this.baseUrl}${ MaintenanceClient.getRemindersShortInfosPath }`;
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <ExtendedAxiosRequestConfig>{
            ...requestConfig,
            method: "GET",
            url: url_,
            headers: {
                ...requestConfig?.headers,
                "Accept": "application/json"
            },
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRemindersShortInfos(_response);
        });
    }

    protected processGetRemindersShortInfos(response: AxiosResponse): Promise<FleetResponseOfEnvelopedModelOfMaintenanceReminderShortInfoVM> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FleetResponseOfEnvelopedModelOfMaintenanceReminderShortInfoVM.fromJS(resultData200);
            return Promise.resolve<FleetResponseOfEnvelopedModelOfMaintenanceReminderShortInfoVM>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FleetResponseOfEnvelopedModelOfMaintenanceReminderShortInfoVM>(null as any);
    }

    getReminderById(reminderId: number , requestConfig?: ExtendedAxiosRequestConfig | undefined): Promise<FleetResponseOfMaintenanceReminderDetailsVM> {
        let url_ = `${this.baseUrl}${ MaintenanceClient.getReminderByIdPath }`;
        if (reminderId === undefined || reminderId === null)
            throw new Error("The parameter 'reminderId' must be defined.");
        url_ = url_.replace("{reminderId}", encodeURIComponent("" + reminderId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <ExtendedAxiosRequestConfig>{
            ...requestConfig,
            method: "GET",
            url: url_,
            headers: {
                ...requestConfig?.headers,
                "Accept": "application/json"
            },
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetReminderById(_response);
        });
    }

    protected processGetReminderById(response: AxiosResponse): Promise<FleetResponseOfMaintenanceReminderDetailsVM> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FleetResponseOfMaintenanceReminderDetailsVM.fromJS(resultData200);
            return Promise.resolve<FleetResponseOfMaintenanceReminderDetailsVM>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FleetResponseOfMaintenanceReminderDetailsVM>(null as any);
    }

    updateReminderNotificationSettings(reminderNotificationSettings: MaintenanceReminderNotificationSettingsVm | null , requestConfig?: ExtendedAxiosRequestConfig | undefined): Promise<BaseResponse> {
        let url_ = `${this.baseUrl}${ MaintenanceClient.updateReminderNotificationSettingsPath }`;
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(reminderNotificationSettings);

        let options_ = <ExtendedAxiosRequestConfig>{
            ...requestConfig,
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                ...requestConfig?.headers,
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateReminderNotificationSettings(_response);
        });
    }

    protected processUpdateReminderNotificationSettings(response: AxiosResponse): Promise<BaseResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = BaseResponse.fromJS(resultData200);
            return Promise.resolve<BaseResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BaseResponse>(null as any);
    }

    getServiceTypes(  requestConfig?: ExtendedAxiosRequestConfig | undefined): Promise<FleetResponseOfEnvelopedModelOfTreeVM> {
        let url_ = `${this.baseUrl}${ MaintenanceClient.getServiceTypesPath }`;
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <ExtendedAxiosRequestConfig>{
            ...requestConfig,
            method: "GET",
            url: url_,
            headers: {
                ...requestConfig?.headers,
                "Accept": "application/json"
            },
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetServiceTypes(_response);
        });
    }

    protected processGetServiceTypes(response: AxiosResponse): Promise<FleetResponseOfEnvelopedModelOfTreeVM> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FleetResponseOfEnvelopedModelOfTreeVM.fromJS(resultData200);
            return Promise.resolve<FleetResponseOfEnvelopedModelOfTreeVM>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FleetResponseOfEnvelopedModelOfTreeVM>(null as any);
    }

    createServiceType(name: string | undefined , requestConfig?: ExtendedAxiosRequestConfig | undefined): Promise<FleetResponseOfMaintenanceServiceTypeVM> {
        let url_ = `${this.baseUrl}${ MaintenanceClient.createServiceTypePath }?`;
        if (name === null)
            throw new Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <ExtendedAxiosRequestConfig>{
            ...requestConfig,
            method: "POST",
            url: url_,
            headers: {
                ...requestConfig?.headers,
                "Accept": "application/json"
            },
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateServiceType(_response);
        });
    }

    protected processCreateServiceType(response: AxiosResponse): Promise<FleetResponseOfMaintenanceServiceTypeVM> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FleetResponseOfMaintenanceServiceTypeVM.fromJS(resultData200);
            return Promise.resolve<FleetResponseOfMaintenanceServiceTypeVM>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FleetResponseOfMaintenanceServiceTypeVM>(null as any);
    }

    deleteServiceType(id: number | undefined , requestConfig?: ExtendedAxiosRequestConfig | undefined): Promise<BaseResponse> {
        let url_ = `${this.baseUrl}${ MaintenanceClient.deleteServiceTypePath }?`;
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <ExtendedAxiosRequestConfig>{
            ...requestConfig,
            method: "DELETE",
            url: url_,
            headers: {
                ...requestConfig?.headers,
                "Accept": "application/json"
            },
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteServiceType(_response);
        });
    }

    protected processDeleteServiceType(response: AxiosResponse): Promise<BaseResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = BaseResponse.fromJS(resultData200);
            return Promise.resolve<BaseResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BaseResponse>(null as any);
    }
}

export class PartnerUserClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    static readonly getPartnerUsersPath = "/api/v1/PartnerUser";
    
    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    getPartnerUsers(userType: string | null | undefined , requestConfig?: ExtendedAxiosRequestConfig | undefined): Promise<FleetResponseOfEnvelopedModelOfPartnerUserVM> {
        let url_ = `${this.baseUrl}${ PartnerUserClient.getPartnerUsersPath }?`;
        if (userType !== undefined && userType !== null)
            url_ += "userType=" + encodeURIComponent("" + userType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <ExtendedAxiosRequestConfig>{
            ...requestConfig,
            method: "GET",
            url: url_,
            headers: {
                ...requestConfig?.headers,
                "Accept": "application/json"
            },
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPartnerUsers(_response);
        });
    }

    protected processGetPartnerUsers(response: AxiosResponse): Promise<FleetResponseOfEnvelopedModelOfPartnerUserVM> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FleetResponseOfEnvelopedModelOfPartnerUserVM.fromJS(resultData200);
            return Promise.resolve<FleetResponseOfEnvelopedModelOfPartnerUserVM>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FleetResponseOfEnvelopedModelOfPartnerUserVM>(null as any);
    }
}

export class RegistrationClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    static readonly getTenantStatusPath = "/api/v1/Registration/status";
    
    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    getTenantStatus(  requestConfig?: ExtendedAxiosRequestConfig | undefined): Promise<FleetResponseOfTenantStatusVM> {
        let url_ = `${this.baseUrl}${ RegistrationClient.getTenantStatusPath }`;
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <ExtendedAxiosRequestConfig>{
            ...requestConfig,
            method: "GET",
            url: url_,
            headers: {
                ...requestConfig?.headers,
                "Accept": "application/json"
            },
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTenantStatus(_response);
        });
    }

    protected processGetTenantStatus(response: AxiosResponse): Promise<FleetResponseOfTenantStatusVM> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FleetResponseOfTenantStatusVM.fromJS(resultData200);
            return Promise.resolve<FleetResponseOfTenantStatusVM>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FleetResponseOfTenantStatusVM>(null as any);
    }
}

export class ReportClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    static readonly getDriversScoresReportsPath = "/api/v1/Report/drivers/scores";
    static readonly getDriverScoresByVendorIdPath = "/api/v1/Report/driver/scores/by-vendor-id";
    static readonly getTripReportsPath = "/api/v1/Report/trips";
    static readonly getDtcReportsPath = "/api/v1/Report/dtc";
    static readonly getDtcCodeDetailsPath = "/api/v1/Report/dtc/details/by-code";
    static readonly getStateMileageReportsPath = "/api/v1/Report/state-mileage";
    static readonly getJobSiteVisitReportPath = "/api/v2/Report/job-site-visit";
    static readonly exportJobSiteVisitReportJobsToCsvPath = "/api/v2/Report/job-site-visit/csv/jobs";
    static readonly exportJobSiteVisitReportVisitsToCsvPath = "/api/v2/Report/job-site-visit/csv/visits";
    
    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    getDriversScoresReports(request: DriversScoresRequestVM | null , requestConfig?: ExtendedAxiosRequestConfig | undefined): Promise<FleetResponseOfEnvelopedModelOfDriverScoreVm> {
        let url_ = `${this.baseUrl}${ ReportClient.getDriversScoresReportsPath }`;
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <ExtendedAxiosRequestConfig>{
            ...requestConfig,
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                ...requestConfig?.headers,
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDriversScoresReports(_response);
        });
    }

    protected processGetDriversScoresReports(response: AxiosResponse): Promise<FleetResponseOfEnvelopedModelOfDriverScoreVm> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FleetResponseOfEnvelopedModelOfDriverScoreVm.fromJS(resultData200);
            return Promise.resolve<FleetResponseOfEnvelopedModelOfDriverScoreVm>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FleetResponseOfEnvelopedModelOfDriverScoreVm>(null as any);
    }

    getDriverScoresByVendorId(request: DriverScoreRequestVM | null , requestConfig?: ExtendedAxiosRequestConfig | undefined): Promise<FleetResponseOfDriverScoreVm> {
        let url_ = `${this.baseUrl}${ ReportClient.getDriverScoresByVendorIdPath }`;
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <ExtendedAxiosRequestConfig>{
            ...requestConfig,
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                ...requestConfig?.headers,
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDriverScoresByVendorId(_response);
        });
    }

    protected processGetDriverScoresByVendorId(response: AxiosResponse): Promise<FleetResponseOfDriverScoreVm> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FleetResponseOfDriverScoreVm.fromJS(resultData200);
            return Promise.resolve<FleetResponseOfDriverScoreVm>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FleetResponseOfDriverScoreVm>(null as any);
    }

    getTripReports(request: TripsReportRequestVm | null , requestConfig?: ExtendedAxiosRequestConfig | undefined): Promise<FleetResponseOfEnvelopedModelOfTripReportVm> {
        let url_ = `${this.baseUrl}${ ReportClient.getTripReportsPath }`;
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <ExtendedAxiosRequestConfig>{
            ...requestConfig,
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                ...requestConfig?.headers,
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTripReports(_response);
        });
    }

    protected processGetTripReports(response: AxiosResponse): Promise<FleetResponseOfEnvelopedModelOfTripReportVm> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FleetResponseOfEnvelopedModelOfTripReportVm.fromJS(resultData200);
            return Promise.resolve<FleetResponseOfEnvelopedModelOfTripReportVm>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FleetResponseOfEnvelopedModelOfTripReportVm>(null as any);
    }

    getDtcReports(request: DtcReportRequestVm | null , requestConfig?: ExtendedAxiosRequestConfig | undefined): Promise<FleetResponseOfEnvelopedModelOfDtcReportVm> {
        let url_ = `${this.baseUrl}${ ReportClient.getDtcReportsPath }`;
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <ExtendedAxiosRequestConfig>{
            ...requestConfig,
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                ...requestConfig?.headers,
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDtcReports(_response);
        });
    }

    protected processGetDtcReports(response: AxiosResponse): Promise<FleetResponseOfEnvelopedModelOfDtcReportVm> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FleetResponseOfEnvelopedModelOfDtcReportVm.fromJS(resultData200);
            return Promise.resolve<FleetResponseOfEnvelopedModelOfDtcReportVm>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FleetResponseOfEnvelopedModelOfDtcReportVm>(null as any);
    }

    getDtcCodeDetails(code: string , requestConfig?: ExtendedAxiosRequestConfig | undefined): Promise<FleetResponseOfDtcCodeDetailsVM> {
        let url_ = `${this.baseUrl}${ ReportClient.getDtcCodeDetailsPath }?`;
        if (code === undefined || code === null)
            throw new Error("The parameter 'code' must be defined and cannot be null.");
        else
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <ExtendedAxiosRequestConfig>{
            ...requestConfig,
            method: "GET",
            url: url_,
            headers: {
                ...requestConfig?.headers,
                "Accept": "application/json"
            },
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDtcCodeDetails(_response);
        });
    }

    protected processGetDtcCodeDetails(response: AxiosResponse): Promise<FleetResponseOfDtcCodeDetailsVM> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FleetResponseOfDtcCodeDetailsVM.fromJS(resultData200);
            return Promise.resolve<FleetResponseOfDtcCodeDetailsVM>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FleetResponseOfDtcCodeDetailsVM>(null as any);
    }

    getStateMileageReports(request: StateMileageReportRequestVm | null , requestConfig?: ExtendedAxiosRequestConfig | undefined): Promise<FleetResponseOfEnvelopedModelOfStateMileageReportVm> {
        let url_ = `${this.baseUrl}${ ReportClient.getStateMileageReportsPath }`;
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <ExtendedAxiosRequestConfig>{
            ...requestConfig,
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                ...requestConfig?.headers,
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetStateMileageReports(_response);
        });
    }

    protected processGetStateMileageReports(response: AxiosResponse): Promise<FleetResponseOfEnvelopedModelOfStateMileageReportVm> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FleetResponseOfEnvelopedModelOfStateMileageReportVm.fromJS(resultData200);
            return Promise.resolve<FleetResponseOfEnvelopedModelOfStateMileageReportVm>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FleetResponseOfEnvelopedModelOfStateMileageReportVm>(null as any);
    }

    getJobSiteVisitReport(request: JobSiteVisitRequestVm | null , requestConfig?: ExtendedAxiosRequestConfig | undefined): Promise<UiDataResponseOfJobSiteVisitResponseVm> {
        let url_ = `${this.baseUrl}${ ReportClient.getJobSiteVisitReportPath }`;
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <ExtendedAxiosRequestConfig>{
            ...requestConfig,
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                ...requestConfig?.headers,
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetJobSiteVisitReport(_response);
        });
    }

    protected processGetJobSiteVisitReport(response: AxiosResponse): Promise<UiDataResponseOfJobSiteVisitResponseVm> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UiDataResponseOfJobSiteVisitResponseVm.fromJS(resultData200);
            return Promise.resolve<UiDataResponseOfJobSiteVisitResponseVm>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UiDataResponseOfJobSiteVisitResponseVm>(null as any);
    }

    exportJobSiteVisitReportJobsToCsv(startDate: Date | undefined, endDate: Date | undefined , requestConfig?: ExtendedAxiosRequestConfig | undefined): Promise<void> {
        let url_ = `${this.baseUrl}${ ReportClient.exportJobSiteVisitReportJobsToCsvPath }?`;
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <ExtendedAxiosRequestConfig>{
            ...requestConfig,
            method: "GET",
            url: url_,
            headers: {
                ...requestConfig?.headers,
            },
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportJobSiteVisitReportJobsToCsv(_response);
        });
    }

    protected processExportJobSiteVisitReportJobsToCsv(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    exportJobSiteVisitReportVisitsToCsv(startDate: Date | undefined, endDate: Date | undefined , requestConfig?: ExtendedAxiosRequestConfig | undefined): Promise<void> {
        let url_ = `${this.baseUrl}${ ReportClient.exportJobSiteVisitReportVisitsToCsvPath }?`;
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <ExtendedAxiosRequestConfig>{
            ...requestConfig,
            method: "GET",
            url: url_,
            headers: {
                ...requestConfig?.headers,
            },
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportJobSiteVisitReportVisitsToCsv(_response);
        });
    }

    protected processExportJobSiteVisitReportVisitsToCsv(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class ReportExportClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    static readonly exportDriversScoresToCsvPath = "/api/v1/ReportExport/drivers/scores/csv";
    static readonly exportTripReportsToCsvPath = "/api/v1/ReportExport/trips/csv";
    static readonly exportDtcReportsToCsvPath = "/api/v1/ReportExport/dtc/csv";
    static readonly exportStateMileageReportsToCsvPath = "/api/v1/ReportExport/state-mileage/csv";
    
    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    exportDriversScoresToCsv(request: DriversScoresRequestVM | null , requestConfig?: ExtendedAxiosRequestConfig | undefined): Promise<void> {
        let url_ = `${this.baseUrl}${ ReportExportClient.exportDriversScoresToCsvPath }`;
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <ExtendedAxiosRequestConfig>{
            ...requestConfig,
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                ...requestConfig?.headers,
                "Content-Type": "application/json",
            },
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportDriversScoresToCsv(_response);
        });
    }

    protected processExportDriversScoresToCsv(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    exportTripReportsToCsv(request: TripsReportRequestVm | null , requestConfig?: ExtendedAxiosRequestConfig | undefined): Promise<void> {
        let url_ = `${this.baseUrl}${ ReportExportClient.exportTripReportsToCsvPath }`;
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <ExtendedAxiosRequestConfig>{
            ...requestConfig,
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                ...requestConfig?.headers,
                "Content-Type": "application/json",
            },
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportTripReportsToCsv(_response);
        });
    }

    protected processExportTripReportsToCsv(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    exportDtcReportsToCsv(request: DtcReportRequestVm | null , requestConfig?: ExtendedAxiosRequestConfig | undefined): Promise<void> {
        let url_ = `${this.baseUrl}${ ReportExportClient.exportDtcReportsToCsvPath }`;
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <ExtendedAxiosRequestConfig>{
            ...requestConfig,
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                ...requestConfig?.headers,
                "Content-Type": "application/json",
            },
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportDtcReportsToCsv(_response);
        });
    }

    protected processExportDtcReportsToCsv(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    exportStateMileageReportsToCsv(request: StateMileageReportRequestVm | null , requestConfig?: ExtendedAxiosRequestConfig | undefined): Promise<void> {
        let url_ = `${this.baseUrl}${ ReportExportClient.exportStateMileageReportsToCsvPath }`;
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <ExtendedAxiosRequestConfig>{
            ...requestConfig,
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                ...requestConfig?.headers,
                "Content-Type": "application/json",
            },
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportStateMileageReportsToCsv(_response);
        });
    }

    protected processExportStateMileageReportsToCsv(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class TrackedResourceClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    static readonly getAllTrackedResourcesPath = "/api/v1/TrackedResource";
    static readonly getTrackedResourcesByIdPath = "/api/v1/TrackedResource/query";
    static readonly getTrackedResourceStatisticsPath = "/api/v2/TrackedResource/{trackedResourceId}/statistics";
    
    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    getAllTrackedResources(  requestConfig?: ExtendedAxiosRequestConfig | undefined): Promise<FleetResponseOfEnvelopedModelOfTrackedResourceLightVM> {
        let url_ = `${this.baseUrl}${ TrackedResourceClient.getAllTrackedResourcesPath }`;
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <ExtendedAxiosRequestConfig>{
            ...requestConfig,
            method: "GET",
            url: url_,
            headers: {
                ...requestConfig?.headers,
                "Accept": "application/json"
            },
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllTrackedResources(_response);
        });
    }

    protected processGetAllTrackedResources(response: AxiosResponse): Promise<FleetResponseOfEnvelopedModelOfTrackedResourceLightVM> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FleetResponseOfEnvelopedModelOfTrackedResourceLightVM.fromJS(resultData200);
            return Promise.resolve<FleetResponseOfEnvelopedModelOfTrackedResourceLightVM>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FleetResponseOfEnvelopedModelOfTrackedResourceLightVM>(null as any);
    }

    getTrackedResourcesById(ids: number[] | null , requestConfig?: ExtendedAxiosRequestConfig | undefined): Promise<FleetResponseOfEnvelopedModelOfTrackedResourceLightVM> {
        let url_ = `${this.baseUrl}${ TrackedResourceClient.getTrackedResourcesByIdPath }`;
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(ids);

        let options_ = <ExtendedAxiosRequestConfig>{
            ...requestConfig,
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                ...requestConfig?.headers,
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTrackedResourcesById(_response);
        });
    }

    protected processGetTrackedResourcesById(response: AxiosResponse): Promise<FleetResponseOfEnvelopedModelOfTrackedResourceLightVM> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FleetResponseOfEnvelopedModelOfTrackedResourceLightVM.fromJS(resultData200);
            return Promise.resolve<FleetResponseOfEnvelopedModelOfTrackedResourceLightVM>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FleetResponseOfEnvelopedModelOfTrackedResourceLightVM>(null as any);
    }

    getTrackedResourceStatistics(trackedResourceId: number, date: Date , requestConfig?: ExtendedAxiosRequestConfig | undefined): Promise<UiDataResponseOfTrackedResourceStatisticsVM> {
        let url_ = `${this.baseUrl}${ TrackedResourceClient.getTrackedResourceStatisticsPath }?`;
        if (trackedResourceId === undefined || trackedResourceId === null)
            throw new Error("The parameter 'trackedResourceId' must be defined.");
        url_ = url_.replace("{trackedResourceId}", encodeURIComponent("" + trackedResourceId));
        if (date === undefined || date === null)
            throw new Error("The parameter 'date' must be defined and cannot be null.");
        else
            url_ += "date=" + encodeURIComponent(date ? "" + date.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <ExtendedAxiosRequestConfig>{
            ...requestConfig,
            method: "POST",
            url: url_,
            headers: {
                ...requestConfig?.headers,
                "Accept": "application/json"
            },
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTrackedResourceStatistics(_response);
        });
    }

    protected processGetTrackedResourceStatistics(response: AxiosResponse): Promise<UiDataResponseOfTrackedResourceStatisticsVM> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UiDataResponseOfTrackedResourceStatisticsVM.fromJS(resultData200);
            return Promise.resolve<UiDataResponseOfTrackedResourceStatisticsVM>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UiDataResponseOfTrackedResourceStatisticsVM>(null as any);
    }
}

export class TruckClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    static readonly getTrucksPath = "/api/v1/Truck";
    
    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    getTrucks(  requestConfig?: ExtendedAxiosRequestConfig | undefined): Promise<FleetResponseOfEnvelopedModelOfTruckVM> {
        let url_ = `${this.baseUrl}${ TruckClient.getTrucksPath }`;
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <ExtendedAxiosRequestConfig>{
            ...requestConfig,
            method: "GET",
            url: url_,
            headers: {
                ...requestConfig?.headers,
                "Accept": "application/json"
            },
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTrucks(_response);
        });
    }

    protected processGetTrucks(response: AxiosResponse): Promise<FleetResponseOfEnvelopedModelOfTruckVM> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FleetResponseOfEnvelopedModelOfTruckVM.fromJS(resultData200);
            return Promise.resolve<FleetResponseOfEnvelopedModelOfTruckVM>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FleetResponseOfEnvelopedModelOfTruckVM>(null as any);
    }
}

export class VehicleClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    static readonly getVehiclesPath = "/api/v1/Vehicle";
    static readonly updateVehiclePath = "/api/v1/Vehicle";
    static readonly getVehicleDetailsPath = "/api/v1/Vehicle/details";
    static readonly updateVehiclesStatusPath = "/api/v1/Vehicle/status";
    static readonly getAllMakesPath = "/api/v1/Vehicle/make";
    static readonly getModelsByMakeNamePath = "/api/v1/Vehicle/model";
    static readonly getModelYearsByModelNamePath = "/api/v1/Vehicle/year";
    
    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    getVehicles(page: number | undefined , requestConfig?: ExtendedAxiosRequestConfig | undefined): Promise<FleetResponseOfPaginatedModelOfVehicleLightVM> {
        let url_ = `${this.baseUrl}${ VehicleClient.getVehiclesPath }?`;
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <ExtendedAxiosRequestConfig>{
            ...requestConfig,
            method: "GET",
            url: url_,
            headers: {
                ...requestConfig?.headers,
                "Accept": "application/json"
            },
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetVehicles(_response);
        });
    }

    protected processGetVehicles(response: AxiosResponse): Promise<FleetResponseOfPaginatedModelOfVehicleLightVM> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FleetResponseOfPaginatedModelOfVehicleLightVM.fromJS(resultData200);
            return Promise.resolve<FleetResponseOfPaginatedModelOfVehicleLightVM>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FleetResponseOfPaginatedModelOfVehicleLightVM>(null as any);
    }

    updateVehicle(vehicle: VehicleVM | null , requestConfig?: ExtendedAxiosRequestConfig | undefined): Promise<FleetResponseOfVehicleVM> {
        let url_ = `${this.baseUrl}${ VehicleClient.updateVehiclePath }`;
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(vehicle);

        let options_ = <ExtendedAxiosRequestConfig>{
            ...requestConfig,
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                ...requestConfig?.headers,
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateVehicle(_response);
        });
    }

    protected processUpdateVehicle(response: AxiosResponse): Promise<FleetResponseOfVehicleVM> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FleetResponseOfVehicleVM.fromJS(resultData200);
            return Promise.resolve<FleetResponseOfVehicleVM>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FleetResponseOfVehicleVM>(null as any);
    }

    getVehicleDetails(entityId: number , requestConfig?: ExtendedAxiosRequestConfig | undefined): Promise<FleetResponseOfVehicleDetailsVM> {
        let url_ = `${this.baseUrl}${ VehicleClient.getVehicleDetailsPath }?`;
        if (entityId === undefined || entityId === null)
            throw new Error("The parameter 'entityId' must be defined and cannot be null.");
        else
            url_ += "entityId=" + encodeURIComponent("" + entityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <ExtendedAxiosRequestConfig>{
            ...requestConfig,
            method: "GET",
            url: url_,
            headers: {
                ...requestConfig?.headers,
                "Accept": "application/json"
            },
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetVehicleDetails(_response);
        });
    }

    protected processGetVehicleDetails(response: AxiosResponse): Promise<FleetResponseOfVehicleDetailsVM> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FleetResponseOfVehicleDetailsVM.fromJS(resultData200);
            return Promise.resolve<FleetResponseOfVehicleDetailsVM>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FleetResponseOfVehicleDetailsVM>(null as any);
    }

    /**
     * @param page (optional) 
     * @deprecated
     */
    updateVehiclesStatus(status: boolean, page: number | undefined, vehicleIds: number[] | null , requestConfig?: ExtendedAxiosRequestConfig | undefined): Promise<FleetResponseOfPaginatedModelOfVehicleLightVM> {
        let url_ = `${this.baseUrl}${ VehicleClient.updateVehiclesStatusPath }?`;
        if (status === undefined || status === null)
            throw new Error("The parameter 'status' must be defined and cannot be null.");
        else
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(vehicleIds);

        let options_ = <ExtendedAxiosRequestConfig>{
            ...requestConfig,
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                ...requestConfig?.headers,
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateVehiclesStatus(_response);
        });
    }

    protected processUpdateVehiclesStatus(response: AxiosResponse): Promise<FleetResponseOfPaginatedModelOfVehicleLightVM> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FleetResponseOfPaginatedModelOfVehicleLightVM.fromJS(resultData200);
            return Promise.resolve<FleetResponseOfPaginatedModelOfVehicleLightVM>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FleetResponseOfPaginatedModelOfVehicleLightVM>(null as any);
    }

    getAllMakes(filterModel: VehicleStaticDataFilterModel | null , requestConfig?: ExtendedAxiosRequestConfig | undefined): Promise<FleetResponseOfPaginatedModelOfVehicleMakeVM> {
        let url_ = `${this.baseUrl}${ VehicleClient.getAllMakesPath }`;
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filterModel);

        let options_ = <ExtendedAxiosRequestConfig>{
            ...requestConfig,
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                ...requestConfig?.headers,
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllMakes(_response);
        });
    }

    protected processGetAllMakes(response: AxiosResponse): Promise<FleetResponseOfPaginatedModelOfVehicleMakeVM> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FleetResponseOfPaginatedModelOfVehicleMakeVM.fromJS(resultData200);
            return Promise.resolve<FleetResponseOfPaginatedModelOfVehicleMakeVM>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FleetResponseOfPaginatedModelOfVehicleMakeVM>(null as any);
    }

    getModelsByMakeName(makeName: string , requestConfig?: ExtendedAxiosRequestConfig | undefined): Promise<FleetResponseOfEnvelopedModelOfVehicleModelVM> {
        let url_ = `${this.baseUrl}${ VehicleClient.getModelsByMakeNamePath }?`;
        if (makeName === undefined || makeName === null)
            throw new Error("The parameter 'makeName' must be defined and cannot be null.");
        else
            url_ += "makeName=" + encodeURIComponent("" + makeName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <ExtendedAxiosRequestConfig>{
            ...requestConfig,
            method: "GET",
            url: url_,
            headers: {
                ...requestConfig?.headers,
                "Accept": "application/json"
            },
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetModelsByMakeName(_response);
        });
    }

    protected processGetModelsByMakeName(response: AxiosResponse): Promise<FleetResponseOfEnvelopedModelOfVehicleModelVM> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FleetResponseOfEnvelopedModelOfVehicleModelVM.fromJS(resultData200);
            return Promise.resolve<FleetResponseOfEnvelopedModelOfVehicleModelVM>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FleetResponseOfEnvelopedModelOfVehicleModelVM>(null as any);
    }

    getModelYearsByModelName(modelName: string , requestConfig?: ExtendedAxiosRequestConfig | undefined): Promise<FleetResponseOfEnvelopedModelOfVehicleModelYearVM> {
        let url_ = `${this.baseUrl}${ VehicleClient.getModelYearsByModelNamePath }?`;
        if (modelName === undefined || modelName === null)
            throw new Error("The parameter 'modelName' must be defined and cannot be null.");
        else
            url_ += "modelName=" + encodeURIComponent("" + modelName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <ExtendedAxiosRequestConfig>{
            ...requestConfig,
            method: "GET",
            url: url_,
            headers: {
                ...requestConfig?.headers,
                "Accept": "application/json"
            },
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetModelYearsByModelName(_response);
        });
    }

    protected processGetModelYearsByModelName(response: AxiosResponse): Promise<FleetResponseOfEnvelopedModelOfVehicleModelYearVM> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FleetResponseOfEnvelopedModelOfVehicleModelYearVM.fromJS(resultData200);
            return Promise.resolve<FleetResponseOfEnvelopedModelOfVehicleModelYearVM>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FleetResponseOfEnvelopedModelOfVehicleModelYearVM>(null as any);
    }
}

export class BreadcrumbTripsClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    static readonly getTripsPath = "/api/v2/BreadcrumbTrips";
    
    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    getTrips(breadcrumbTripRequest: BreadcrumbTripRequestVm | null , requestConfig?: ExtendedAxiosRequestConfig | undefined): Promise<FleetResponseOfEnvelopedModelOfBreadcrumbItemVm> {
        let url_ = `${this.baseUrl}${ BreadcrumbTripsClient.getTripsPath }`;
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(breadcrumbTripRequest);

        let options_ = <ExtendedAxiosRequestConfig>{
            ...requestConfig,
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                ...requestConfig?.headers,
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTrips(_response);
        });
    }

    protected processGetTrips(response: AxiosResponse): Promise<FleetResponseOfEnvelopedModelOfBreadcrumbItemVm> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FleetResponseOfEnvelopedModelOfBreadcrumbItemVm.fromJS(resultData200);
            return Promise.resolve<FleetResponseOfEnvelopedModelOfBreadcrumbItemVm>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FleetResponseOfEnvelopedModelOfBreadcrumbItemVm>(null as any);
    }
}

export class LiveMapClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    static readonly getTrackedResourcesPath = "/api/v2/LiveMap/trackedResources";
    
    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    getTrackedResources(  requestConfig?: ExtendedAxiosRequestConfig | undefined): Promise<UiDataResponseOfEnvelopedModelOfLiveMapTrackedResourceVM> {
        let url_ = `${this.baseUrl}${ LiveMapClient.getTrackedResourcesPath }`;
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <ExtendedAxiosRequestConfig>{
            ...requestConfig,
            method: "GET",
            url: url_,
            headers: {
                ...requestConfig?.headers,
                "Accept": "application/json"
            },
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTrackedResources(_response);
        });
    }

    protected processGetTrackedResources(response: AxiosResponse): Promise<UiDataResponseOfEnvelopedModelOfLiveMapTrackedResourceVM> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UiDataResponseOfEnvelopedModelOfLiveMapTrackedResourceVM.fromJS(resultData200);
            return Promise.resolve<UiDataResponseOfEnvelopedModelOfLiveMapTrackedResourceVM>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UiDataResponseOfEnvelopedModelOfLiveMapTrackedResourceVM>(null as any);
    }
}

export class LogClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    static readonly sendStCorePath = "/api/v2/Log/send-st-core";
    static readonly sendPath = "/api/v2/Log/send";
    
    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    sendStCore(  requestConfig?: ExtendedAxiosRequestConfig | undefined): Promise<UiResponse> {
        let url_ = `${this.baseUrl}${ LogClient.sendStCorePath }`;
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <ExtendedAxiosRequestConfig>{
            ...requestConfig,
            method: "POST",
            url: url_,
            headers: {
                ...requestConfig?.headers,
                "Accept": "application/json"
            },
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSendStCore(_response);
        });
    }

    protected processSendStCore(response: AxiosResponse): Promise<UiResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UiResponse.fromJS(resultData200);
            return Promise.resolve<UiResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UiResponse>(null as any);
    }

    send(events: WebLogEvent[] | null , requestConfig?: ExtendedAxiosRequestConfig | undefined): Promise<UiResponse> {
        let url_ = `${this.baseUrl}${ LogClient.sendPath }`;
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(events);

        let options_ = <ExtendedAxiosRequestConfig>{
            ...requestConfig,
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                ...requestConfig?.headers,
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSend(_response);
        });
    }

    protected processSend(response: AxiosResponse): Promise<UiResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UiResponse.fromJS(resultData200);
            return Promise.resolve<UiResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UiResponse>(null as any);
    }
}

export class MaintenanceServiceEntryClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    static readonly getServiceEntriesPath = "/api/v2/MaintenanceServiceEntry";
    static readonly createServiceEntryPath = "/api/v2/MaintenanceServiceEntry";
    static readonly updateServiceEntryPath = "/api/v2/MaintenanceServiceEntry";
    static readonly getServiceEntryByIdPath = "/api/v2/MaintenanceServiceEntry/{serviceEntryId}";
    static readonly updateServiceEntryStatePath = "/api/v2/MaintenanceServiceEntry/{serviceEntryId}/state";
    static readonly uploadFileAttachmentsPath = "/api/v2/MaintenanceServiceEntry/fileAttachments";
    static readonly downloadFileAttachmentPath = "/api/v2/MaintenanceServiceEntry/fileAttachments/{attachmentId}";
    
    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    getServiceEntries(state: ServiceEntryState | null | undefined , requestConfig?: ExtendedAxiosRequestConfig | undefined): Promise<UiDataResponseOfEnvelopedModelOfMaintenanceServiceEntryGridVm> {
        let url_ = `${this.baseUrl}${ MaintenanceServiceEntryClient.getServiceEntriesPath }?`;
        if (state !== undefined && state !== null)
            url_ += "state=" + encodeURIComponent("" + state) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <ExtendedAxiosRequestConfig>{
            ...requestConfig,
            method: "GET",
            url: url_,
            headers: {
                ...requestConfig?.headers,
                "Accept": "application/json"
            },
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetServiceEntries(_response);
        });
    }

    protected processGetServiceEntries(response: AxiosResponse): Promise<UiDataResponseOfEnvelopedModelOfMaintenanceServiceEntryGridVm> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UiDataResponseOfEnvelopedModelOfMaintenanceServiceEntryGridVm.fromJS(resultData200);
            return Promise.resolve<UiDataResponseOfEnvelopedModelOfMaintenanceServiceEntryGridVm>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UiDataResponseOfEnvelopedModelOfMaintenanceServiceEntryGridVm>(null as any);
    }

    createServiceEntry(serviceEntry: MaintenanceServiceEntryCreateVm | null , requestConfig?: ExtendedAxiosRequestConfig | undefined): Promise<UiDataResponseOfMaintenanceServiceEntryDetailsVm> {
        let url_ = `${this.baseUrl}${ MaintenanceServiceEntryClient.createServiceEntryPath }`;
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(serviceEntry);

        let options_ = <ExtendedAxiosRequestConfig>{
            ...requestConfig,
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                ...requestConfig?.headers,
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateServiceEntry(_response);
        });
    }

    protected processCreateServiceEntry(response: AxiosResponse): Promise<UiDataResponseOfMaintenanceServiceEntryDetailsVm> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UiDataResponseOfMaintenanceServiceEntryDetailsVm.fromJS(resultData200);
            return Promise.resolve<UiDataResponseOfMaintenanceServiceEntryDetailsVm>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UiDataResponseOfMaintenanceServiceEntryDetailsVm>(null as any);
    }

    updateServiceEntry(serviceEntry: MaintenanceServiceEntryUpdateVm | null , requestConfig?: ExtendedAxiosRequestConfig | undefined): Promise<UiDataResponseOfMaintenanceServiceEntryDetailsVm> {
        let url_ = `${this.baseUrl}${ MaintenanceServiceEntryClient.updateServiceEntryPath }`;
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(serviceEntry);

        let options_ = <ExtendedAxiosRequestConfig>{
            ...requestConfig,
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                ...requestConfig?.headers,
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateServiceEntry(_response);
        });
    }

    protected processUpdateServiceEntry(response: AxiosResponse): Promise<UiDataResponseOfMaintenanceServiceEntryDetailsVm> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UiDataResponseOfMaintenanceServiceEntryDetailsVm.fromJS(resultData200);
            return Promise.resolve<UiDataResponseOfMaintenanceServiceEntryDetailsVm>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UiDataResponseOfMaintenanceServiceEntryDetailsVm>(null as any);
    }

    getServiceEntryById(serviceEntryId: number , requestConfig?: ExtendedAxiosRequestConfig | undefined): Promise<UiDataResponseOfMaintenanceServiceEntryDetailsVm> {
        let url_ = `${this.baseUrl}${ MaintenanceServiceEntryClient.getServiceEntryByIdPath }`;
        if (serviceEntryId === undefined || serviceEntryId === null)
            throw new Error("The parameter 'serviceEntryId' must be defined.");
        url_ = url_.replace("{serviceEntryId}", encodeURIComponent("" + serviceEntryId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <ExtendedAxiosRequestConfig>{
            ...requestConfig,
            method: "GET",
            url: url_,
            headers: {
                ...requestConfig?.headers,
                "Accept": "application/json"
            },
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetServiceEntryById(_response);
        });
    }

    protected processGetServiceEntryById(response: AxiosResponse): Promise<UiDataResponseOfMaintenanceServiceEntryDetailsVm> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UiDataResponseOfMaintenanceServiceEntryDetailsVm.fromJS(resultData200);
            return Promise.resolve<UiDataResponseOfMaintenanceServiceEntryDetailsVm>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UiDataResponseOfMaintenanceServiceEntryDetailsVm>(null as any);
    }

    updateServiceEntryState(serviceEntryId: number, state: ServiceEntryState | undefined , requestConfig?: ExtendedAxiosRequestConfig | undefined): Promise<UiDataResponseOfMaintenanceServiceEntryDetailsVm> {
        let url_ = `${this.baseUrl}${ MaintenanceServiceEntryClient.updateServiceEntryStatePath }?`;
        if (serviceEntryId === undefined || serviceEntryId === null)
            throw new Error("The parameter 'serviceEntryId' must be defined.");
        url_ = url_.replace("{serviceEntryId}", encodeURIComponent("" + serviceEntryId));
        if (state === null)
            throw new Error("The parameter 'state' cannot be null.");
        else if (state !== undefined)
            url_ += "state=" + encodeURIComponent("" + state) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <ExtendedAxiosRequestConfig>{
            ...requestConfig,
            method: "PATCH",
            url: url_,
            headers: {
                ...requestConfig?.headers,
                "Accept": "application/json"
            },
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateServiceEntryState(_response);
        });
    }

    protected processUpdateServiceEntryState(response: AxiosResponse): Promise<UiDataResponseOfMaintenanceServiceEntryDetailsVm> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UiDataResponseOfMaintenanceServiceEntryDetailsVm.fromJS(resultData200);
            return Promise.resolve<UiDataResponseOfMaintenanceServiceEntryDetailsVm>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UiDataResponseOfMaintenanceServiceEntryDetailsVm>(null as any);
    }

    uploadFileAttachments(  requestConfig?: ExtendedAxiosRequestConfig | undefined): Promise<UiDataResponseOfEnvelopedModelOfFileUploadResultVm> {
        let url_ = `${this.baseUrl}${ MaintenanceServiceEntryClient.uploadFileAttachmentsPath }`;
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <ExtendedAxiosRequestConfig>{
            ...requestConfig,
            method: "POST",
            url: url_,
            headers: {
                ...requestConfig?.headers,
                "Accept": "application/json"
            },
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUploadFileAttachments(_response);
        });
    }

    protected processUploadFileAttachments(response: AxiosResponse): Promise<UiDataResponseOfEnvelopedModelOfFileUploadResultVm> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UiDataResponseOfEnvelopedModelOfFileUploadResultVm.fromJS(resultData200);
            return Promise.resolve<UiDataResponseOfEnvelopedModelOfFileUploadResultVm>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UiDataResponseOfEnvelopedModelOfFileUploadResultVm>(null as any);
    }

    downloadFileAttachment(attachmentId: number , requestConfig?: ExtendedAxiosRequestConfig | undefined): Promise<FileResponse> {
        let url_ = `${this.baseUrl}${ MaintenanceServiceEntryClient.downloadFileAttachmentPath }`;
        if (attachmentId === undefined || attachmentId === null)
            throw new Error("The parameter 'attachmentId' must be defined.");
        url_ = url_.replace("{attachmentId}", encodeURIComponent("" + attachmentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <ExtendedAxiosRequestConfig>{
            ...requestConfig,
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                ...requestConfig?.headers,
                "Accept": "application/octet-stream"
            },
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDownloadFileAttachment(_response);
        });
    }

    protected processDownloadFileAttachment(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class MobileContextClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    static readonly getUserStatusPath = "/api/mobile/v2/MobileContext/status/user";
    static readonly getAvailableFeaturesPath = "/api/mobile/v2/MobileContext/available-features";

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    getUserStatus(  requestConfig?: ExtendedAxiosRequestConfig | undefined): Promise<UiDataResponseOfUserStatusVM> {
        let url_ = `${this.baseUrl}${ MobileContextClient.getUserStatusPath }`;
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <ExtendedAxiosRequestConfig>{
            ...requestConfig,
            method: "GET",
            url: url_,
            headers: {
                ...requestConfig?.headers,
                "Accept": "application/json"
            },
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserStatus(_response);
        });
    }

    protected processGetUserStatus(response: AxiosResponse): Promise<UiDataResponseOfUserStatusVM> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UiDataResponseOfUserStatusVM.fromJS(resultData200);
            return Promise.resolve<UiDataResponseOfUserStatusVM>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UiDataResponseOfUserStatusVM>(null as any);
    }

    getAvailableFeatures(  requestConfig?: ExtendedAxiosRequestConfig | undefined): Promise<UiDataResponseOfFeatureVmOf> {
        let url_ = `${this.baseUrl}${ MobileContextClient.getAvailableFeaturesPath }`;
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <ExtendedAxiosRequestConfig>{
            ...requestConfig,
            method: "GET",
            url: url_,
            headers: {
                ...requestConfig?.headers,
                "Accept": "application/json"
            },
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAvailableFeatures(_response);
        });
    }

    protected processGetAvailableFeatures(response: AxiosResponse): Promise<UiDataResponseOfFeatureVmOf> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UiDataResponseOfFeatureVmOf.fromJS(resultData200);
            return Promise.resolve<UiDataResponseOfFeatureVmOf>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UiDataResponseOfFeatureVmOf>(null as any);
    }
}

export class MobileMaintenanceServiceEntryClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    static readonly getMobileMaintenanceServiceEntriesPath = "/api/mobile/v2/MobileMaintenanceServiceEntry";
    static readonly createServiceEntryPath = "/api/mobile/v2/MobileMaintenanceServiceEntry";
    static readonly updateServiceEntryPath = "/api/mobile/v2/MobileMaintenanceServiceEntry";
    static readonly getServiceEntryByIdPath = "/api/mobile/v2/MobileMaintenanceServiceEntry/{serviceEntryId}";
    static readonly getMobileServiceEntryTypesPath = "/api/mobile/v2/MobileMaintenanceServiceEntry/service-types";
    static readonly uploadFileAttachmentsPath = "/api/mobile/v2/MobileMaintenanceServiceEntry/fileAttachments";
    static readonly downloadFileAttachmentPath = "/api/mobile/v2/MobileMaintenanceServiceEntry/fileAttachments/{attachmentId}";
    
    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    getMobileMaintenanceServiceEntries(  requestConfig?: ExtendedAxiosRequestConfig | undefined): Promise<UiDataResponseOfEnvelopedModelOfMobileMaintenanceServiceEntryGridVm> {
        let url_ = `${this.baseUrl}${ MobileMaintenanceServiceEntryClient.getMobileMaintenanceServiceEntriesPath }`;
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <ExtendedAxiosRequestConfig>{
            ...requestConfig,
            method: "GET",
            url: url_,
            headers: {
                ...requestConfig?.headers,
                "Accept": "application/json"
            },
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMobileMaintenanceServiceEntries(_response);
        });
    }

    protected processGetMobileMaintenanceServiceEntries(response: AxiosResponse): Promise<UiDataResponseOfEnvelopedModelOfMobileMaintenanceServiceEntryGridVm> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UiDataResponseOfEnvelopedModelOfMobileMaintenanceServiceEntryGridVm.fromJS(resultData200);
            return Promise.resolve<UiDataResponseOfEnvelopedModelOfMobileMaintenanceServiceEntryGridVm>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UiDataResponseOfEnvelopedModelOfMobileMaintenanceServiceEntryGridVm>(null as any);
    }

    createServiceEntry(serviceEntry: MobileMaintenanceServiceEntryCreateVm | null , requestConfig?: ExtendedAxiosRequestConfig | undefined): Promise<UiDataResponseOfMobileMaintenanceServiceEntryDetailsVm> {
        let url_ = `${this.baseUrl}${ MobileMaintenanceServiceEntryClient.createServiceEntryPath }`;
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(serviceEntry);

        let options_ = <ExtendedAxiosRequestConfig>{
            ...requestConfig,
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                ...requestConfig?.headers,
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateServiceEntry(_response);
        });
    }

    protected processCreateServiceEntry(response: AxiosResponse): Promise<UiDataResponseOfMobileMaintenanceServiceEntryDetailsVm> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UiDataResponseOfMobileMaintenanceServiceEntryDetailsVm.fromJS(resultData200);
            return Promise.resolve<UiDataResponseOfMobileMaintenanceServiceEntryDetailsVm>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UiDataResponseOfMobileMaintenanceServiceEntryDetailsVm>(null as any);
    }

    updateServiceEntry(serviceEntry: MobileMaintenanceServiceEntryUpdateVm | null , requestConfig?: ExtendedAxiosRequestConfig | undefined): Promise<UiDataResponseOfMobileMaintenanceServiceEntryDetailsVm> {
        let url_ = `${this.baseUrl}${ MobileMaintenanceServiceEntryClient.updateServiceEntryPath }`;
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(serviceEntry);

        let options_ = <ExtendedAxiosRequestConfig>{
            ...requestConfig,
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                ...requestConfig?.headers,
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateServiceEntry(_response);
        });
    }

    protected processUpdateServiceEntry(response: AxiosResponse): Promise<UiDataResponseOfMobileMaintenanceServiceEntryDetailsVm> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UiDataResponseOfMobileMaintenanceServiceEntryDetailsVm.fromJS(resultData200);
            return Promise.resolve<UiDataResponseOfMobileMaintenanceServiceEntryDetailsVm>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UiDataResponseOfMobileMaintenanceServiceEntryDetailsVm>(null as any);
    }

    getServiceEntryById(serviceEntryId: number , requestConfig?: ExtendedAxiosRequestConfig | undefined): Promise<UiDataResponseOfMobileMaintenanceServiceEntryDetailsVm> {
        let url_ = `${this.baseUrl}${ MobileMaintenanceServiceEntryClient.getServiceEntryByIdPath }`;
        if (serviceEntryId === undefined || serviceEntryId === null)
            throw new Error("The parameter 'serviceEntryId' must be defined.");
        url_ = url_.replace("{serviceEntryId}", encodeURIComponent("" + serviceEntryId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <ExtendedAxiosRequestConfig>{
            ...requestConfig,
            method: "GET",
            url: url_,
            headers: {
                ...requestConfig?.headers,
                "Accept": "application/json"
            },
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetServiceEntryById(_response);
        });
    }

    protected processGetServiceEntryById(response: AxiosResponse): Promise<UiDataResponseOfMobileMaintenanceServiceEntryDetailsVm> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UiDataResponseOfMobileMaintenanceServiceEntryDetailsVm.fromJS(resultData200);
            return Promise.resolve<UiDataResponseOfMobileMaintenanceServiceEntryDetailsVm>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UiDataResponseOfMobileMaintenanceServiceEntryDetailsVm>(null as any);
    }

    getMobileServiceEntryTypes(  requestConfig?: ExtendedAxiosRequestConfig | undefined): Promise<UiDataResponseOfEnvelopedModelOfMobileMaintenanceServiceEntryTypeVm> {
        let url_ = `${this.baseUrl}${ MobileMaintenanceServiceEntryClient.getMobileServiceEntryTypesPath }`;
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <ExtendedAxiosRequestConfig>{
            ...requestConfig,
            method: "GET",
            url: url_,
            headers: {
                ...requestConfig?.headers,
                "Accept": "application/json"
            },
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMobileServiceEntryTypes(_response);
        });
    }

    protected processGetMobileServiceEntryTypes(response: AxiosResponse): Promise<UiDataResponseOfEnvelopedModelOfMobileMaintenanceServiceEntryTypeVm> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UiDataResponseOfEnvelopedModelOfMobileMaintenanceServiceEntryTypeVm.fromJS(resultData200);
            return Promise.resolve<UiDataResponseOfEnvelopedModelOfMobileMaintenanceServiceEntryTypeVm>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UiDataResponseOfEnvelopedModelOfMobileMaintenanceServiceEntryTypeVm>(null as any);
    }

    uploadFileAttachments(  requestConfig?: ExtendedAxiosRequestConfig | undefined): Promise<UiDataResponseOfEnvelopedModelOfFileUploadResultVm> {
        let url_ = `${this.baseUrl}${ MobileMaintenanceServiceEntryClient.uploadFileAttachmentsPath }`;
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <ExtendedAxiosRequestConfig>{
            ...requestConfig,
            method: "POST",
            url: url_,
            headers: {
                ...requestConfig?.headers,
                "Accept": "application/json"
            },
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUploadFileAttachments(_response);
        });
    }

    protected processUploadFileAttachments(response: AxiosResponse): Promise<UiDataResponseOfEnvelopedModelOfFileUploadResultVm> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UiDataResponseOfEnvelopedModelOfFileUploadResultVm.fromJS(resultData200);
            return Promise.resolve<UiDataResponseOfEnvelopedModelOfFileUploadResultVm>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UiDataResponseOfEnvelopedModelOfFileUploadResultVm>(null as any);
    }

    downloadFileAttachment(attachmentId: number , requestConfig?: ExtendedAxiosRequestConfig | undefined): Promise<FileResponse> {
        let url_ = `${this.baseUrl}${ MobileMaintenanceServiceEntryClient.downloadFileAttachmentPath }`;
        if (attachmentId === undefined || attachmentId === null)
            throw new Error("The parameter 'attachmentId' must be defined.");
        url_ = url_.replace("{attachmentId}", encodeURIComponent("" + attachmentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <ExtendedAxiosRequestConfig>{
            ...requestConfig,
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                ...requestConfig?.headers,
                "Accept": "application/octet-stream"
            },
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDownloadFileAttachment(_response);
        });
    }

    protected processDownloadFileAttachment(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class MobileVehicleClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    static readonly getVehiclesByVinPrefixPath = "/api/mobile/v2/MobileVehicle/by-vin-prefix/{vinPrefix}";
    
    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    getVehiclesByVinPrefix(vinPrefix: string , requestConfig?: ExtendedAxiosRequestConfig | undefined): Promise<UiDataResponseOfEnvelopedModelOfMobileVehicleVm> {
        let url_ = `${this.baseUrl}${ MobileVehicleClient.getVehiclesByVinPrefixPath }`;
        if (vinPrefix === undefined || vinPrefix === null)
            throw new Error("The parameter 'vinPrefix' must be defined.");
        url_ = url_.replace("{vinPrefix}", encodeURIComponent("" + vinPrefix));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <ExtendedAxiosRequestConfig>{
            ...requestConfig,
            method: "GET",
            url: url_,
            headers: {
                ...requestConfig?.headers,
                "Accept": "application/json"
            },
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetVehiclesByVinPrefix(_response);
        });
    }

    protected processGetVehiclesByVinPrefix(response: AxiosResponse): Promise<UiDataResponseOfEnvelopedModelOfMobileVehicleVm> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UiDataResponseOfEnvelopedModelOfMobileVehicleVm.fromJS(resultData200);
            return Promise.resolve<UiDataResponseOfEnvelopedModelOfMobileVehicleVm>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UiDataResponseOfEnvelopedModelOfMobileVehicleVm>(null as any);
    }
}

export class BaseResponse implements IBaseResponse {
    success?: boolean;
    statusCode?: number;
    traceId?: string | undefined;
    generatedAt?: Date;
    errors?: ErrorModel[];

    constructor(data?: IBaseResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.statusCode = _data["statusCode"];
            this.traceId = _data["traceId"];
            this.generatedAt = _data["generatedAt"] ? new Date(_data["generatedAt"].toString()) : <any>undefined;
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(ErrorModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BaseResponse {
        data = typeof data === 'object' ? data : {};
        let result = new BaseResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["statusCode"] = this.statusCode;
        data["traceId"] = this.traceId;
        data["generatedAt"] = this.generatedAt ? this.generatedAt.toISOString() : <any>undefined;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item.toJSON());
        }
        return data;
    }
}

export interface IBaseResponse {
    success?: boolean;
    statusCode?: number;
    traceId?: string | undefined;
    generatedAt?: Date;
    errors?: ErrorModel[];
}

export class FleetResponseOfEnvelopedModelOfAlertTypeVM extends BaseResponse implements IFleetResponseOfEnvelopedModelOfAlertTypeVM {
    data?: EnvelopedModelOfAlertTypeVM | undefined;

    constructor(data?: IFleetResponseOfEnvelopedModelOfAlertTypeVM) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? EnvelopedModelOfAlertTypeVM.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FleetResponseOfEnvelopedModelOfAlertTypeVM {
        data = typeof data === 'object' ? data : {};
        let result = new FleetResponseOfEnvelopedModelOfAlertTypeVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IFleetResponseOfEnvelopedModelOfAlertTypeVM extends IBaseResponse {
    data?: EnvelopedModelOfAlertTypeVM | undefined;
}

export class EnvelopedModelOfAlertTypeVM implements IEnvelopedModelOfAlertTypeVM {
    rows?: AlertTypeVM[];
    totalItems?: number;

    constructor(data?: IEnvelopedModelOfAlertTypeVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(AlertTypeVM.fromJS(item));
            }
            this.totalItems = _data["totalItems"];
        }
    }

    static fromJS(data: any): EnvelopedModelOfAlertTypeVM {
        data = typeof data === 'object' ? data : {};
        let result = new EnvelopedModelOfAlertTypeVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        data["totalItems"] = this.totalItems;
        return data;
    }
}

export interface IEnvelopedModelOfAlertTypeVM {
    rows?: AlertTypeVM[];
    totalItems?: number;
}

export class AlertTypeVM implements IAlertTypeVM {
    id?: number;
    name?: string | undefined;
    category?: string | undefined;
    hasCustomHours?: boolean;
    customFields?: CustomField[];

    constructor(data?: IAlertTypeVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.category = _data["category"];
            this.hasCustomHours = _data["hasCustomHours"];
            if (Array.isArray(_data["customFields"])) {
                this.customFields = [] as any;
                for (let item of _data["customFields"])
                    this.customFields!.push(CustomField.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AlertTypeVM {
        data = typeof data === 'object' ? data : {};
        let result = new AlertTypeVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["category"] = this.category;
        data["hasCustomHours"] = this.hasCustomHours;
        if (Array.isArray(this.customFields)) {
            data["customFields"] = [];
            for (let item of this.customFields)
                data["customFields"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAlertTypeVM {
    id?: number;
    name?: string | undefined;
    category?: string | undefined;
    hasCustomHours?: boolean;
    customFields?: CustomField[];
}

export class CustomField implements ICustomField {
    key?: string;
    value?: any;
    category?: string | undefined;

    constructor(data?: ICustomField) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.value = _data["value"];
            this.category = _data["category"];
        }
    }

    static fromJS(data: any): CustomField {
        data = typeof data === 'object' ? data : {};
        let result = new CustomField();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["value"] = this.value;
        data["category"] = this.category;
        return data;
    }
}

export interface ICustomField {
    key?: string;
    value?: any;
    category?: string | undefined;
}

export class ErrorModel implements IErrorModel {
    message?: string | undefined;
    entityId?: string | undefined;

    constructor(data?: IErrorModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"];
            this.entityId = _data["entityId"];
        }
    }

    static fromJS(data: any): ErrorModel {
        data = typeof data === 'object' ? data : {};
        let result = new ErrorModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        data["entityId"] = this.entityId;
        return data;
    }
}

export interface IErrorModel {
    message?: string | undefined;
    entityId?: string | undefined;
}

export class FleetResponseOfPaginatedModelOfAlertGetVM extends BaseResponse implements IFleetResponseOfPaginatedModelOfAlertGetVM {
    data?: PaginatedModelOfAlertGetVM | undefined;

    constructor(data?: IFleetResponseOfPaginatedModelOfAlertGetVM) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? PaginatedModelOfAlertGetVM.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FleetResponseOfPaginatedModelOfAlertGetVM {
        data = typeof data === 'object' ? data : {};
        let result = new FleetResponseOfPaginatedModelOfAlertGetVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IFleetResponseOfPaginatedModelOfAlertGetVM extends IBaseResponse {
    data?: PaginatedModelOfAlertGetVM | undefined;
}

export class PaginatedModelOfAlertGetVM implements IPaginatedModelOfAlertGetVM {
    page!: number;
    totalPages!: number;
    totalItems!: number;
    maxItemCountReached!: boolean;
    maxItemCount!: number;
    rows!: AlertGetVM[];

    constructor(data?: IPaginatedModelOfAlertGetVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.rows = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.page = _data["page"];
            this.totalPages = _data["totalPages"];
            this.totalItems = _data["totalItems"];
            this.maxItemCountReached = _data["maxItemCountReached"];
            this.maxItemCount = _data["maxItemCount"];
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(AlertGetVM.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedModelOfAlertGetVM {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedModelOfAlertGetVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["page"] = this.page;
        data["totalPages"] = this.totalPages;
        data["totalItems"] = this.totalItems;
        data["maxItemCountReached"] = this.maxItemCountReached;
        data["maxItemCount"] = this.maxItemCount;
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPaginatedModelOfAlertGetVM {
    page: number;
    totalPages: number;
    totalItems: number;
    maxItemCountReached: boolean;
    maxItemCount: number;
    rows: AlertGetVM[];
}

export class AlertGetVM implements IAlertGetVM {
    id?: number;
    alertTypeId?: number;
    alertTypeName?: string;
    name?: string;
    customFields?: CustomField[];
    sendAlertNotification?: boolean;
    active?: boolean;
    eventType?: string;
    notificationMethods?: string[];
    groupNames?: string[];
    vehicleNames?: string[];
    trackingSchedule?: string;

    constructor(data?: IAlertGetVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.alertTypeId = _data["alertTypeId"];
            this.alertTypeName = _data["alertTypeName"];
            this.name = _data["name"];
            if (Array.isArray(_data["customFields"])) {
                this.customFields = [] as any;
                for (let item of _data["customFields"])
                    this.customFields!.push(CustomField.fromJS(item));
            }
            this.sendAlertNotification = _data["sendAlertNotification"];
            this.active = _data["active"];
            this.eventType = _data["eventType"];
            if (Array.isArray(_data["notificationMethods"])) {
                this.notificationMethods = [] as any;
                for (let item of _data["notificationMethods"])
                    this.notificationMethods!.push(item);
            }
            if (Array.isArray(_data["groupNames"])) {
                this.groupNames = [] as any;
                for (let item of _data["groupNames"])
                    this.groupNames!.push(item);
            }
            if (Array.isArray(_data["vehicleNames"])) {
                this.vehicleNames = [] as any;
                for (let item of _data["vehicleNames"])
                    this.vehicleNames!.push(item);
            }
            this.trackingSchedule = _data["trackingSchedule"];
        }
    }

    static fromJS(data: any): AlertGetVM {
        data = typeof data === 'object' ? data : {};
        let result = new AlertGetVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["alertTypeId"] = this.alertTypeId;
        data["alertTypeName"] = this.alertTypeName;
        data["name"] = this.name;
        if (Array.isArray(this.customFields)) {
            data["customFields"] = [];
            for (let item of this.customFields)
                data["customFields"].push(item.toJSON());
        }
        data["sendAlertNotification"] = this.sendAlertNotification;
        data["active"] = this.active;
        data["eventType"] = this.eventType;
        if (Array.isArray(this.notificationMethods)) {
            data["notificationMethods"] = [];
            for (let item of this.notificationMethods)
                data["notificationMethods"].push(item);
        }
        if (Array.isArray(this.groupNames)) {
            data["groupNames"] = [];
            for (let item of this.groupNames)
                data["groupNames"].push(item);
        }
        if (Array.isArray(this.vehicleNames)) {
            data["vehicleNames"] = [];
            for (let item of this.vehicleNames)
                data["vehicleNames"].push(item);
        }
        data["trackingSchedule"] = this.trackingSchedule;
        return data;
    }
}

export interface IAlertGetVM {
    id?: number;
    alertTypeId?: number;
    alertTypeName?: string;
    name?: string;
    customFields?: CustomField[];
    sendAlertNotification?: boolean;
    active?: boolean;
    eventType?: string;
    notificationMethods?: string[];
    groupNames?: string[];
    vehicleNames?: string[];
    trackingSchedule?: string;
}

export class FleetResponseOfAlertDetailsGetVM extends BaseResponse implements IFleetResponseOfAlertDetailsGetVM {
    data?: AlertDetailsGetVM | undefined;

    constructor(data?: IFleetResponseOfAlertDetailsGetVM) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? AlertDetailsGetVM.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FleetResponseOfAlertDetailsGetVM {
        data = typeof data === 'object' ? data : {};
        let result = new FleetResponseOfAlertDetailsGetVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IFleetResponseOfAlertDetailsGetVM extends IBaseResponse {
    data?: AlertDetailsGetVM | undefined;
}

export class AlertCreateVM implements IAlertCreateVM {
    id?: number | undefined;
    active?: boolean;
    alertTypeId?: number;
    name?: string;
    customFields?: CustomField[];
    triggerTimeRangesByDay?: TriggerTimeRanges[];
    sendAlertNotification?: boolean;
    notificationFrequency?: number;
    groupIds?: number[];
    vehicleIds?: number[];
    notificationMethods?: NotificationMethodCreateVM[];

    constructor(data?: IAlertCreateVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.active = _data["active"];
            this.alertTypeId = _data["alertTypeId"];
            this.name = _data["name"];
            if (Array.isArray(_data["customFields"])) {
                this.customFields = [] as any;
                for (let item of _data["customFields"])
                    this.customFields!.push(CustomField.fromJS(item));
            }
            if (Array.isArray(_data["triggerTimeRangesByDay"])) {
                this.triggerTimeRangesByDay = [] as any;
                for (let item of _data["triggerTimeRangesByDay"])
                    this.triggerTimeRangesByDay!.push(TriggerTimeRanges.fromJS(item));
            }
            this.sendAlertNotification = _data["sendAlertNotification"];
            this.notificationFrequency = _data["notificationFrequency"];
            if (Array.isArray(_data["groupIds"])) {
                this.groupIds = [] as any;
                for (let item of _data["groupIds"])
                    this.groupIds!.push(item);
            }
            if (Array.isArray(_data["vehicleIds"])) {
                this.vehicleIds = [] as any;
                for (let item of _data["vehicleIds"])
                    this.vehicleIds!.push(item);
            }
            if (Array.isArray(_data["notificationMethods"])) {
                this.notificationMethods = [] as any;
                for (let item of _data["notificationMethods"])
                    this.notificationMethods!.push(NotificationMethodCreateVM.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AlertCreateVM {
        data = typeof data === 'object' ? data : {};
        let result = new AlertCreateVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["active"] = this.active;
        data["alertTypeId"] = this.alertTypeId;
        data["name"] = this.name;
        if (Array.isArray(this.customFields)) {
            data["customFields"] = [];
            for (let item of this.customFields)
                data["customFields"].push(item.toJSON());
        }
        if (Array.isArray(this.triggerTimeRangesByDay)) {
            data["triggerTimeRangesByDay"] = [];
            for (let item of this.triggerTimeRangesByDay)
                data["triggerTimeRangesByDay"].push(item.toJSON());
        }
        data["sendAlertNotification"] = this.sendAlertNotification;
        data["notificationFrequency"] = this.notificationFrequency;
        if (Array.isArray(this.groupIds)) {
            data["groupIds"] = [];
            for (let item of this.groupIds)
                data["groupIds"].push(item);
        }
        if (Array.isArray(this.vehicleIds)) {
            data["vehicleIds"] = [];
            for (let item of this.vehicleIds)
                data["vehicleIds"].push(item);
        }
        if (Array.isArray(this.notificationMethods)) {
            data["notificationMethods"] = [];
            for (let item of this.notificationMethods)
                data["notificationMethods"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAlertCreateVM {
    id?: number | undefined;
    active?: boolean;
    alertTypeId?: number;
    name?: string;
    customFields?: CustomField[];
    triggerTimeRangesByDay?: TriggerTimeRanges[];
    sendAlertNotification?: boolean;
    notificationFrequency?: number;
    groupIds?: number[];
    vehicleIds?: number[];
    notificationMethods?: NotificationMethodCreateVM[];
}

export class AlertDetailsGetVM extends AlertCreateVM implements IAlertDetailsGetVM {

    constructor(data?: IAlertDetailsGetVM) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): AlertDetailsGetVM {
        data = typeof data === 'object' ? data : {};
        let result = new AlertDetailsGetVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IAlertDetailsGetVM extends IAlertCreateVM {
}

export class TriggerTimeRanges implements ITriggerTimeRanges {
    dayOfTheWeek?: string;
    timeRanges?: TimeRange[];

    constructor(data?: ITriggerTimeRanges) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dayOfTheWeek = _data["dayOfTheWeek"];
            if (Array.isArray(_data["timeRanges"])) {
                this.timeRanges = [] as any;
                for (let item of _data["timeRanges"])
                    this.timeRanges!.push(TimeRange.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TriggerTimeRanges {
        data = typeof data === 'object' ? data : {};
        let result = new TriggerTimeRanges();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dayOfTheWeek"] = this.dayOfTheWeek;
        if (Array.isArray(this.timeRanges)) {
            data["timeRanges"] = [];
            for (let item of this.timeRanges)
                data["timeRanges"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITriggerTimeRanges {
    dayOfTheWeek?: string;
    timeRanges?: TimeRange[];
}

export class TimeRange implements ITimeRange {
    startTime?: number;
    endTime?: number;

    constructor(data?: ITimeRange) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startTime = _data["startTime"];
            this.endTime = _data["endTime"];
        }
    }

    static fromJS(data: any): TimeRange {
        data = typeof data === 'object' ? data : {};
        let result = new TimeRange();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startTime"] = this.startTime;
        data["endTime"] = this.endTime;
        return data;
    }
}

export interface ITimeRange {
    startTime?: number;
    endTime?: number;
}

export class NotificationMethodCreateVM implements INotificationMethodCreateVM {
    id?: number | undefined;
    active?: boolean;
    type?: string;
    additionalMessage?: string;
    notifyDriver?: boolean;
    recipients?: string[];
    ccRecipientEmails?: string[];

    constructor(data?: INotificationMethodCreateVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.active = _data["active"];
            this.type = _data["type"];
            this.additionalMessage = _data["additionalMessage"];
            this.notifyDriver = _data["notifyDriver"];
            if (Array.isArray(_data["recipients"])) {
                this.recipients = [] as any;
                for (let item of _data["recipients"])
                    this.recipients!.push(item);
            }
            if (Array.isArray(_data["ccRecipientEmails"])) {
                this.ccRecipientEmails = [] as any;
                for (let item of _data["ccRecipientEmails"])
                    this.ccRecipientEmails!.push(item);
            }
        }
    }

    static fromJS(data: any): NotificationMethodCreateVM {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationMethodCreateVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["active"] = this.active;
        data["type"] = this.type;
        data["additionalMessage"] = this.additionalMessage;
        data["notifyDriver"] = this.notifyDriver;
        if (Array.isArray(this.recipients)) {
            data["recipients"] = [];
            for (let item of this.recipients)
                data["recipients"].push(item);
        }
        if (Array.isArray(this.ccRecipientEmails)) {
            data["ccRecipientEmails"] = [];
            for (let item of this.ccRecipientEmails)
                data["ccRecipientEmails"].push(item);
        }
        return data;
    }
}

export interface INotificationMethodCreateVM {
    id?: number | undefined;
    active?: boolean;
    type?: string;
    additionalMessage?: string;
    notifyDriver?: boolean;
    recipients?: string[];
    ccRecipientEmails?: string[];
}

export class AlertUpdateVM extends AlertCreateVM implements IAlertUpdateVM {

    constructor(data?: IAlertUpdateVM) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): AlertUpdateVM {
        data = typeof data === 'object' ? data : {};
        let result = new AlertUpdateVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IAlertUpdateVM extends IAlertCreateVM {
}

export class IdsVM implements IIdsVM {
    ids?: number[] | undefined;

    constructor(data?: IIdsVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
        }
    }

    static fromJS(data: any): IdsVM {
        data = typeof data === 'object' ? data : {};
        let result = new IdsVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        return data;
    }
}

export interface IIdsVM {
    ids?: number[] | undefined;
}

export class FleetResponseOfEnvelopedModelOfCameraVideoVM extends BaseResponse implements IFleetResponseOfEnvelopedModelOfCameraVideoVM {
    data?: EnvelopedModelOfCameraVideoVM | undefined;

    constructor(data?: IFleetResponseOfEnvelopedModelOfCameraVideoVM) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? EnvelopedModelOfCameraVideoVM.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FleetResponseOfEnvelopedModelOfCameraVideoVM {
        data = typeof data === 'object' ? data : {};
        let result = new FleetResponseOfEnvelopedModelOfCameraVideoVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IFleetResponseOfEnvelopedModelOfCameraVideoVM extends IBaseResponse {
    data?: EnvelopedModelOfCameraVideoVM | undefined;
}

export class EnvelopedModelOfCameraVideoVM implements IEnvelopedModelOfCameraVideoVM {
    rows?: CameraVideoVM[];
    totalItems?: number;

    constructor(data?: IEnvelopedModelOfCameraVideoVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(CameraVideoVM.fromJS(item));
            }
            this.totalItems = _data["totalItems"];
        }
    }

    static fromJS(data: any): EnvelopedModelOfCameraVideoVM {
        data = typeof data === 'object' ? data : {};
        let result = new EnvelopedModelOfCameraVideoVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        data["totalItems"] = this.totalItems;
        return data;
    }
}

export interface IEnvelopedModelOfCameraVideoVM {
    rows?: CameraVideoVM[];
    totalItems?: number;
}

export class CameraVideoVM implements ICameraVideoVM {
    cameraVideoId?: string | undefined;
    location?: CoordinatesVm | undefined;
    address?: string | undefined;
    eventType?: string | undefined;
    eventTime?: Date;
    eventEndTime?: Date | undefined;
    initialSpeed?: number | undefined;
    finalSpeed?: number | undefined;
    vehicleName?: string | undefined;
    driverName?: string | undefined;
    roadVideoLink?: string | undefined;
    roadThumbnailLink?: string | undefined;
    driverVideoLink?: string | undefined;
    driverThumbnailLink?: string | undefined;
    request?: RequestInfoVM;

    constructor(data?: ICameraVideoVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cameraVideoId = _data["cameraVideoId"];
            this.location = _data["location"] ? CoordinatesVm.fromJS(_data["location"]) : <any>undefined;
            this.address = _data["address"];
            this.eventType = _data["eventType"];
            this.eventTime = _data["eventTime"] ? new Date(_data["eventTime"].toString()) : <any>undefined;
            this.eventEndTime = _data["eventEndTime"] ? new Date(_data["eventEndTime"].toString()) : <any>undefined;
            this.initialSpeed = _data["initialSpeed"];
            this.finalSpeed = _data["finalSpeed"];
            this.vehicleName = _data["vehicleName"];
            this.driverName = _data["driverName"];
            this.roadVideoLink = _data["roadVideoLink"];
            this.roadThumbnailLink = _data["roadThumbnailLink"];
            this.driverVideoLink = _data["driverVideoLink"];
            this.driverThumbnailLink = _data["driverThumbnailLink"];
            this.request = _data["request"] ? RequestInfoVM.fromJS(_data["request"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CameraVideoVM {
        data = typeof data === 'object' ? data : {};
        let result = new CameraVideoVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cameraVideoId"] = this.cameraVideoId;
        data["location"] = this.location ? this.location.toJSON() : <any>undefined;
        data["address"] = this.address;
        data["eventType"] = this.eventType;
        data["eventTime"] = this.eventTime ? this.eventTime.toISOString() : <any>undefined;
        data["eventEndTime"] = this.eventEndTime ? this.eventEndTime.toISOString() : <any>undefined;
        data["initialSpeed"] = this.initialSpeed;
        data["finalSpeed"] = this.finalSpeed;
        data["vehicleName"] = this.vehicleName;
        data["driverName"] = this.driverName;
        data["roadVideoLink"] = this.roadVideoLink;
        data["roadThumbnailLink"] = this.roadThumbnailLink;
        data["driverVideoLink"] = this.driverVideoLink;
        data["driverThumbnailLink"] = this.driverThumbnailLink;
        data["request"] = this.request ? this.request.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICameraVideoVM {
    cameraVideoId?: string | undefined;
    location?: CoordinatesVm | undefined;
    address?: string | undefined;
    eventType?: string | undefined;
    eventTime?: Date;
    eventEndTime?: Date | undefined;
    initialSpeed?: number | undefined;
    finalSpeed?: number | undefined;
    vehicleName?: string | undefined;
    driverName?: string | undefined;
    roadVideoLink?: string | undefined;
    roadThumbnailLink?: string | undefined;
    driverVideoLink?: string | undefined;
    driverThumbnailLink?: string | undefined;
    request?: RequestInfoVM;
}

export class CoordinatesVm implements ICoordinatesVm {
    latitude!: number;
    longitude!: number;

    constructor(data?: ICoordinatesVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
        }
    }

    static fromJS(data: any): CoordinatesVm {
        data = typeof data === 'object' ? data : {};
        let result = new CoordinatesVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        return data;
    }
}

export interface ICoordinatesVm {
    latitude: number;
    longitude: number;
}

export class RequestInfoVM implements IRequestInfoVM {
    requestedVideoName?: string;
    userName?: string;
    status?: RequestStatus;

    constructor(data?: IRequestInfoVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requestedVideoName = _data["requestedVideoName"];
            this.userName = _data["userName"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): RequestInfoVM {
        data = typeof data === 'object' ? data : {};
        let result = new RequestInfoVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestedVideoName"] = this.requestedVideoName;
        data["userName"] = this.userName;
        data["status"] = this.status;
        return data;
    }
}

export interface IRequestInfoVM {
    requestedVideoName?: string;
    userName?: string;
    status?: RequestStatus;
}

export enum RequestStatus {
    Pending = 0,
    Succeeded = 1,
    PartiallySucceeded = 2,
    VideoNotAvailable = 3,
    Failed = 4,
}

export class CameraVideoFilterVM implements ICameraVideoFilterVM {
    startTime!: Date;
    endTime!: Date;

    constructor(data?: ICameraVideoFilterVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? new Date(_data["endTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CameraVideoFilterVM {
        data = typeof data === 'object' ? data : {};
        let result = new CameraVideoFilterVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        return data;
    }
}

export interface ICameraVideoFilterVM {
    startTime: Date;
    endTime: Date;
}

export class FleetResponseOfCameraVideoVM extends BaseResponse implements IFleetResponseOfCameraVideoVM {
    data?: CameraVideoVM | undefined;

    constructor(data?: IFleetResponseOfCameraVideoVM) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? CameraVideoVM.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FleetResponseOfCameraVideoVM {
        data = typeof data === 'object' ? data : {};
        let result = new FleetResponseOfCameraVideoVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IFleetResponseOfCameraVideoVM extends IBaseResponse {
    data?: CameraVideoVM | undefined;
}

export class FleetResponseOfIReadOnlyDictionaryOfCameraEventTypeAndString extends BaseResponse implements IFleetResponseOfIReadOnlyDictionaryOfCameraEventTypeAndString {
    data?: { [key in keyof typeof CameraEventType]?: string; } | undefined;

    constructor(data?: IFleetResponseOfIReadOnlyDictionaryOfCameraEventTypeAndString) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (_data["data"]) {
                this.data = {} as any;
                for (let key in _data["data"]) {
                    if (_data["data"].hasOwnProperty(key))
                        (<any>this.data)![key] = _data["data"][key];
                }
            }
        }
    }

    static fromJS(data: any): FleetResponseOfIReadOnlyDictionaryOfCameraEventTypeAndString {
        data = typeof data === 'object' ? data : {};
        let result = new FleetResponseOfIReadOnlyDictionaryOfCameraEventTypeAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.data) {
            data["data"] = {};
            for (let key in this.data) {
                if (this.data.hasOwnProperty(key))
                    (<any>data["data"])[key] = (<any>this.data)[key];
            }
        }
        super.toJSON(data);
        return data;
    }
}

export interface IFleetResponseOfIReadOnlyDictionaryOfCameraEventTypeAndString extends IBaseResponse {
    data?: { [key in keyof typeof CameraEventType]?: string; } | undefined;
}

export enum CameraEventType {
    Unknown = 0,
    CamButtonPressed = 1,
    CamDisconnect = 2,
    CamDistractedDriving = 3,
    CamEatingDrinking = 4,
    CamImpact = 5,
    CamPhoneUse = 6,
    CamSmoking = 7,
    CamTampered = 8,
    CamUnbelted = 9,
    CamViolentLeftTurn = 10,
    CamViolentRightTurn = 11,
    HardAccelerationMessage = 12,
    HardBrakingMessage = 13,
    HardCoreBrakingMessage = 14,
    OverSpeedingMessage = 15,
    RequestedMessage = 16,
    VehicleBackupEvent = 17,
    AccidentDetection = 18,
    CamAccidentAi = 19,
    CamGforceHigh = 20,
    CamGforceRegular = 21,
    CamPossibleFatigue = 22,
    CamTailgating = 23,
    CamObstruction = 24,
    CamLaneDeparture = 25,
    AccelerometerImpact = 26,
    CamViolentTurn = 27,
    CamRollingStop = 28,
    CamForwardCollisionWarning = 29,
}

export class FleetResponseOfString extends BaseResponse implements IFleetResponseOfString {
    data?: string | undefined;

    constructor(data?: IFleetResponseOfString) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"];
        }
    }

    static fromJS(data: any): FleetResponseOfString {
        data = typeof data === 'object' ? data : {};
        let result = new FleetResponseOfString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data;
        super.toJSON(data);
        return data;
    }
}

export interface IFleetResponseOfString extends IBaseResponse {
    data?: string | undefined;
}

export class CameraVideoRequestVM implements ICameraVideoRequestVM {
    vehicleId?: string;
    requestedVideoName?: string;
    startTime?: Date;
    endTime?: Date;

    constructor(data?: ICameraVideoRequestVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vehicleId = _data["vehicleId"];
            this.requestedVideoName = _data["requestedVideoName"];
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? new Date(_data["endTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CameraVideoRequestVM {
        data = typeof data === 'object' ? data : {};
        let result = new CameraVideoRequestVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vehicleId"] = this.vehicleId;
        data["requestedVideoName"] = this.requestedVideoName;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        return data;
    }
}

export interface ICameraVideoRequestVM {
    vehicleId?: string;
    requestedVideoName?: string;
    startTime?: Date;
    endTime?: Date;
}

export class FleetResponseOfPartitionVm extends BaseResponse implements IFleetResponseOfPartitionVm {
    data?: PartitionVm | undefined;

    constructor(data?: IFleetResponseOfPartitionVm) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? PartitionVm.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FleetResponseOfPartitionVm {
        data = typeof data === 'object' ? data : {};
        let result = new FleetResponseOfPartitionVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IFleetResponseOfPartitionVm extends IBaseResponse {
    data?: PartitionVm | undefined;
}

export class PartitionVm implements IPartitionVm {
    standalonePartitionId?: string;
    partitionName?: string | undefined;
    partitionDisplayName?: string | undefined;

    constructor(data?: IPartitionVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.standalonePartitionId = _data["standalonePartitionId"];
            this.partitionName = _data["partitionName"];
            this.partitionDisplayName = _data["partitionDisplayName"];
        }
    }

    static fromJS(data: any): PartitionVm {
        data = typeof data === 'object' ? data : {};
        let result = new PartitionVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["standalonePartitionId"] = this.standalonePartitionId;
        data["partitionName"] = this.partitionName;
        data["partitionDisplayName"] = this.partitionDisplayName;
        return data;
    }
}

export interface IPartitionVm {
    standalonePartitionId?: string;
    partitionName?: string | undefined;
    partitionDisplayName?: string | undefined;
}

export class FleetResponseOfApiUserVm extends BaseResponse implements IFleetResponseOfApiUserVm {
    data?: ApiUserVm | undefined;

    constructor(data?: IFleetResponseOfApiUserVm) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? ApiUserVm.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FleetResponseOfApiUserVm {
        data = typeof data === 'object' ? data : {};
        let result = new FleetResponseOfApiUserVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IFleetResponseOfApiUserVm extends IBaseResponse {
    data?: ApiUserVm | undefined;
}

export class ApiUserVm implements IApiUserVm {
    permissions!: ApiPermission[];

    constructor(data?: IApiUserVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.permissions = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(item);
            }
        }
    }

    static fromJS(data: any): ApiUserVm {
        data = typeof data === 'object' ? data : {};
        let result = new ApiUserVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item);
        }
        return data;
    }
}

export interface IApiUserVm {
    permissions: ApiPermission[];
}

export enum ApiPermission {
    AccessLiveMap = 1,
    AccessVehicleData = 2,
    AccessAssetData = 3,
    AccessDriverData = 4,
    AccessCameraData = 5,
    AccessEventReport = 6,
    AccessAllReports = 7,
    AccessReminders = 8,
    AccessAlerts = 9,
    AccessGroups = 10,
    AccessGeofences = 11,
    AccessServiceEntry = 12,
    AccessDeviceData = 13,
}

export class FleetResponseOfListOfPartitionVm extends BaseResponse implements IFleetResponseOfListOfPartitionVm {
    data?: PartitionVm[] | undefined;

    constructor(data?: IFleetResponseOfListOfPartitionVm) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(PartitionVm.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FleetResponseOfListOfPartitionVm {
        data = typeof data === 'object' ? data : {};
        let result = new FleetResponseOfListOfPartitionVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IFleetResponseOfListOfPartitionVm extends IBaseResponse {
    data?: PartitionVm[] | undefined;
}

export class FleetResponseOfFeatureVmOf extends BaseResponse implements IFleetResponseOfFeatureVmOf {
    data?: FeatureVm[] | undefined;

    constructor(data?: IFleetResponseOfFeatureVmOf) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(FeatureVm.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FleetResponseOfFeatureVmOf {
        data = typeof data === 'object' ? data : {};
        let result = new FleetResponseOfFeatureVmOf();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IFleetResponseOfFeatureVmOf extends IBaseResponse {
    data?: FeatureVm[] | undefined;
}

export class FeatureVm implements IFeatureVm {
    type!: FeatureType;

    constructor(data?: IFeatureVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): FeatureVm {
        data = typeof data === 'object' ? data : {};
        let result = new FeatureVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        return data;
    }
}

export interface IFeatureVm {
    type: FeatureType;
}

export enum FeatureType {
    None = 0,
    GpsData = 1,
    VehicleData = 2,
    AssetData = 3,
    DriverData = 4,
    CameraData = 5,
    RequestVideo = 6,
    EventReport = 7,
    DiagnosticsReport = 8,
    DriverScoreReports = 9,
    TripsReports = 10,
    StateMileageReports = 11,
    MaintenanceReminders = 12,
    ServiceEntries = 13,
    Alerts = 14,
    Groups = 15,
    Geofences = 16,
    GpsDevices = 17,
    AiCams = 18,
    SafetyCams = 19,
    AssetTrackers = 20,
    OemDevices = 21,
    DtcReports = 22,
    VendorCompanyProfile = 23,
    JobSiteVisitReports = 24,
}

export class FleetResponseOfEnvelopedModelOfCameraDeviceVM extends BaseResponse implements IFleetResponseOfEnvelopedModelOfCameraDeviceVM {
    data?: EnvelopedModelOfCameraDeviceVM | undefined;

    constructor(data?: IFleetResponseOfEnvelopedModelOfCameraDeviceVM) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? EnvelopedModelOfCameraDeviceVM.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FleetResponseOfEnvelopedModelOfCameraDeviceVM {
        data = typeof data === 'object' ? data : {};
        let result = new FleetResponseOfEnvelopedModelOfCameraDeviceVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IFleetResponseOfEnvelopedModelOfCameraDeviceVM extends IBaseResponse {
    data?: EnvelopedModelOfCameraDeviceVM | undefined;
}

export class EnvelopedModelOfCameraDeviceVM implements IEnvelopedModelOfCameraDeviceVM {
    rows?: CameraDeviceVM[];
    totalItems?: number;

    constructor(data?: IEnvelopedModelOfCameraDeviceVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(CameraDeviceVM.fromJS(item));
            }
            this.totalItems = _data["totalItems"];
        }
    }

    static fromJS(data: any): EnvelopedModelOfCameraDeviceVM {
        data = typeof data === 'object' ? data : {};
        let result = new EnvelopedModelOfCameraDeviceVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        data["totalItems"] = this.totalItems;
        return data;
    }
}

export interface IEnvelopedModelOfCameraDeviceVM {
    rows?: CameraDeviceVM[];
    totalItems?: number;
}

export class CameraDeviceVM implements ICameraDeviceVM {
    id!: number;
    serialNumber!: string;
    vehicle?: IdNameVM | undefined;

    constructor(data?: ICameraDeviceVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.serialNumber = _data["serialNumber"];
            this.vehicle = _data["vehicle"] ? IdNameVM.fromJS(_data["vehicle"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CameraDeviceVM {
        data = typeof data === 'object' ? data : {};
        let result = new CameraDeviceVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["serialNumber"] = this.serialNumber;
        data["vehicle"] = this.vehicle ? this.vehicle.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICameraDeviceVM {
    id: number;
    serialNumber: string;
    vehicle?: IdNameVM | undefined;
}

export class IdNameVM implements IIdNameVM {
    id!: number;
    name!: string;

    constructor(data?: IIdNameVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): IdNameVM {
        data = typeof data === 'object' ? data : {};
        let result = new IdNameVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IIdNameVM {
    id: number;
    name: string;
}

export class EventBasicFilterModel implements IEventBasicFilterModel {
    startTime?: Date;
    endTime?: Date;
    filters?: { [key: string]: string[]; };
    text?: string | undefined;

    constructor(data?: IEventBasicFilterModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? new Date(_data["endTime"].toString()) : <any>undefined;
            if (_data["filters"]) {
                this.filters = {} as any;
                for (let key in _data["filters"]) {
                    if (_data["filters"].hasOwnProperty(key))
                        (<any>this.filters)![key] = _data["filters"][key] !== undefined ? _data["filters"][key] : [];
                }
            }
            this.text = _data["text"];
        }
    }

    static fromJS(data: any): EventBasicFilterModel {
        data = typeof data === 'object' ? data : {};
        let result = new EventBasicFilterModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        if (this.filters) {
            data["filters"] = {};
            for (let key in this.filters) {
                if (this.filters.hasOwnProperty(key))
                    (<any>data["filters"])[key] = (<any>this.filters)[key];
            }
        }
        data["text"] = this.text;
        return data;
    }
}

export interface IEventBasicFilterModel {
    startTime?: Date;
    endTime?: Date;
    filters?: { [key: string]: string[]; };
    text?: string | undefined;
}

export class EventReportExportModel extends EventBasicFilterModel implements IEventReportExportModel {
    colName?: string;
    isSortDesc?: boolean;
    options?: ReportOptions | undefined;

    constructor(data?: IEventReportExportModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.colName = _data["colName"];
            this.isSortDesc = _data["isSortDesc"];
            this.options = _data["options"] ? ReportOptions.fromJS(_data["options"]) : <any>undefined;
        }
    }

    static fromJS(data: any): EventReportExportModel {
        data = typeof data === 'object' ? data : {};
        let result = new EventReportExportModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["colName"] = this.colName;
        data["isSortDesc"] = this.isSortDesc;
        data["options"] = this.options ? this.options.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IEventReportExportModel extends IEventBasicFilterModel {
    colName?: string;
    isSortDesc?: boolean;
    options?: ReportOptions | undefined;
}

export class ReportOptions implements IReportOptions {
    timezone?: string | undefined;

    constructor(data?: IReportOptions) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.timezone = _data["timezone"];
        }
    }

    static fromJS(data: any): ReportOptions {
        data = typeof data === 'object' ? data : {};
        let result = new ReportOptions();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["timezone"] = this.timezone;
        return data;
    }
}

export interface IReportOptions {
    timezone?: string | undefined;
}

export class FleetResponseOfPaginatedModelOfEventVm extends BaseResponse implements IFleetResponseOfPaginatedModelOfEventVm {
    data?: PaginatedModelOfEventVm | undefined;

    constructor(data?: IFleetResponseOfPaginatedModelOfEventVm) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? PaginatedModelOfEventVm.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FleetResponseOfPaginatedModelOfEventVm {
        data = typeof data === 'object' ? data : {};
        let result = new FleetResponseOfPaginatedModelOfEventVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IFleetResponseOfPaginatedModelOfEventVm extends IBaseResponse {
    data?: PaginatedModelOfEventVm | undefined;
}

export class PaginatedModelOfEventVm implements IPaginatedModelOfEventVm {
    page!: number;
    totalPages!: number;
    totalItems!: number;
    maxItemCountReached!: boolean;
    maxItemCount!: number;
    rows!: EventVm[];

    constructor(data?: IPaginatedModelOfEventVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.rows = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.page = _data["page"];
            this.totalPages = _data["totalPages"];
            this.totalItems = _data["totalItems"];
            this.maxItemCountReached = _data["maxItemCountReached"];
            this.maxItemCount = _data["maxItemCount"];
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(EventVm.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedModelOfEventVm {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedModelOfEventVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["page"] = this.page;
        data["totalPages"] = this.totalPages;
        data["totalItems"] = this.totalItems;
        data["maxItemCountReached"] = this.maxItemCountReached;
        data["maxItemCount"] = this.maxItemCount;
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPaginatedModelOfEventVm {
    page: number;
    totalPages: number;
    totalItems: number;
    maxItemCountReached: boolean;
    maxItemCount: number;
    rows: EventVm[];
}

export class EventVm implements IEventVm {
    id?: string;
    dateTime?: Date;
    vehicleId!: number;
    vehicleName?: string | undefined;
    groupName?: string | undefined;
    driverName?: string | undefined;
    address?: string | undefined;
    coordinates?: CoordinatesVm | undefined;
    geofenceName?: string | undefined;
    eventType?: string | undefined;
    eventName?: string | undefined;
    customFieldsAsStringValues?: string[];
    alertDuration?: number | undefined;

    constructor(data?: IEventVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.dateTime = _data["dateTime"] ? new Date(_data["dateTime"].toString()) : <any>undefined;
            this.vehicleId = _data["vehicleId"];
            this.vehicleName = _data["vehicleName"];
            this.groupName = _data["groupName"];
            this.driverName = _data["driverName"];
            this.address = _data["address"];
            this.coordinates = _data["coordinates"] ? CoordinatesVm.fromJS(_data["coordinates"]) : <any>undefined;
            this.geofenceName = _data["geofenceName"];
            this.eventType = _data["eventType"];
            this.eventName = _data["eventName"];
            if (Array.isArray(_data["customFieldsAsStringValues"])) {
                this.customFieldsAsStringValues = [] as any;
                for (let item of _data["customFieldsAsStringValues"])
                    this.customFieldsAsStringValues!.push(item);
            }
            this.alertDuration = _data["alertDuration"];
        }
    }

    static fromJS(data: any): EventVm {
        data = typeof data === 'object' ? data : {};
        let result = new EventVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["dateTime"] = this.dateTime ? this.dateTime.toISOString() : <any>undefined;
        data["vehicleId"] = this.vehicleId;
        data["vehicleName"] = this.vehicleName;
        data["groupName"] = this.groupName;
        data["driverName"] = this.driverName;
        data["address"] = this.address;
        data["coordinates"] = this.coordinates ? this.coordinates.toJSON() : <any>undefined;
        data["geofenceName"] = this.geofenceName;
        data["eventType"] = this.eventType;
        data["eventName"] = this.eventName;
        if (Array.isArray(this.customFieldsAsStringValues)) {
            data["customFieldsAsStringValues"] = [];
            for (let item of this.customFieldsAsStringValues)
                data["customFieldsAsStringValues"].push(item);
        }
        data["alertDuration"] = this.alertDuration;
        return data;
    }
}

export interface IEventVm {
    id?: string;
    dateTime?: Date;
    vehicleId: number;
    vehicleName?: string | undefined;
    groupName?: string | undefined;
    driverName?: string | undefined;
    address?: string | undefined;
    coordinates?: CoordinatesVm | undefined;
    geofenceName?: string | undefined;
    eventType?: string | undefined;
    eventName?: string | undefined;
    customFieldsAsStringValues?: string[];
    alertDuration?: number | undefined;
}

export class EventFilterVm implements IEventFilterVm {
    startTime?: Date;
    endTime?: Date;
    filters?: { [key: string]: string[]; };
    text?: string | undefined;
    pageModel?: PageInputModel | undefined;

    constructor(data?: IEventFilterVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? new Date(_data["endTime"].toString()) : <any>undefined;
            if (_data["filters"]) {
                this.filters = {} as any;
                for (let key in _data["filters"]) {
                    if (_data["filters"].hasOwnProperty(key))
                        (<any>this.filters)![key] = _data["filters"][key] !== undefined ? _data["filters"][key] : [];
                }
            }
            this.text = _data["text"];
            this.pageModel = _data["pageModel"] ? PageInputModel.fromJS(_data["pageModel"]) : <any>undefined;
        }
    }

    static fromJS(data: any): EventFilterVm {
        data = typeof data === 'object' ? data : {};
        let result = new EventFilterVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        if (this.filters) {
            data["filters"] = {};
            for (let key in this.filters) {
                if (this.filters.hasOwnProperty(key))
                    (<any>data["filters"])[key] = (<any>this.filters)[key];
            }
        }
        data["text"] = this.text;
        data["pageModel"] = this.pageModel ? this.pageModel.toJSON() : <any>undefined;
        return data;
    }
}

export interface IEventFilterVm {
    startTime?: Date;
    endTime?: Date;
    filters?: { [key: string]: string[]; };
    text?: string | undefined;
    pageModel?: PageInputModel | undefined;
}

export class PageInputModel implements IPageInputModel {
    pageNumber?: number;
    pageSize?: number;
    isSortDesc?: boolean;
    colName?: string;

    constructor(data?: IPageInputModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.isSortDesc = _data["isSortDesc"];
            this.colName = _data["colName"];
        }
    }

    static fromJS(data: any): PageInputModel {
        data = typeof data === 'object' ? data : {};
        let result = new PageInputModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["isSortDesc"] = this.isSortDesc;
        data["colName"] = this.colName;
        return data;
    }
}

export interface IPageInputModel {
    pageNumber?: number;
    pageSize?: number;
    isSortDesc?: boolean;
    colName?: string;
}

export class FleetResponseOfEventVm extends BaseResponse implements IFleetResponseOfEventVm {
    data?: EventVm | undefined;

    constructor(data?: IFleetResponseOfEventVm) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? EventVm.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FleetResponseOfEventVm {
        data = typeof data === 'object' ? data : {};
        let result = new FleetResponseOfEventVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IFleetResponseOfEventVm extends IBaseResponse {
    data?: EventVm | undefined;
}

export class FleetResponseOfEventFilterDataVM extends BaseResponse implements IFleetResponseOfEventFilterDataVM {
    data?: EventFilterDataVM | undefined;

    constructor(data?: IFleetResponseOfEventFilterDataVM) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? EventFilterDataVM.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FleetResponseOfEventFilterDataVM {
        data = typeof data === 'object' ? data : {};
        let result = new FleetResponseOfEventFilterDataVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IFleetResponseOfEventFilterDataVM extends IBaseResponse {
    data?: EventFilterDataVM | undefined;
}

export class EventFilterDataVM implements IEventFilterDataVM {
    vehicleNames?: string[];
    groupNames?: string[];
    eventNames?: string[];
    eventTypes?: string[];

    constructor(data?: IEventFilterDataVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["vehicleNames"])) {
                this.vehicleNames = [] as any;
                for (let item of _data["vehicleNames"])
                    this.vehicleNames!.push(item);
            }
            if (Array.isArray(_data["groupNames"])) {
                this.groupNames = [] as any;
                for (let item of _data["groupNames"])
                    this.groupNames!.push(item);
            }
            if (Array.isArray(_data["eventNames"])) {
                this.eventNames = [] as any;
                for (let item of _data["eventNames"])
                    this.eventNames!.push(item);
            }
            if (Array.isArray(_data["eventTypes"])) {
                this.eventTypes = [] as any;
                for (let item of _data["eventTypes"])
                    this.eventTypes!.push(item);
            }
        }
    }

    static fromJS(data: any): EventFilterDataVM {
        data = typeof data === 'object' ? data : {};
        let result = new EventFilterDataVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.vehicleNames)) {
            data["vehicleNames"] = [];
            for (let item of this.vehicleNames)
                data["vehicleNames"].push(item);
        }
        if (Array.isArray(this.groupNames)) {
            data["groupNames"] = [];
            for (let item of this.groupNames)
                data["groupNames"].push(item);
        }
        if (Array.isArray(this.eventNames)) {
            data["eventNames"] = [];
            for (let item of this.eventNames)
                data["eventNames"].push(item);
        }
        if (Array.isArray(this.eventTypes)) {
            data["eventTypes"] = [];
            for (let item of this.eventTypes)
                data["eventTypes"].push(item);
        }
        return data;
    }
}

export interface IEventFilterDataVM {
    vehicleNames?: string[];
    groupNames?: string[];
    eventNames?: string[];
    eventTypes?: string[];
}

export class DateTimeFilterModel implements IDateTimeFilterModel {
    startTime?: Date;
    endTime?: Date;

    constructor(data?: IDateTimeFilterModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? new Date(_data["endTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): DateTimeFilterModel {
        data = typeof data === 'object' ? data : {};
        let result = new DateTimeFilterModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        return data;
    }
}

export interface IDateTimeFilterModel {
    startTime?: Date;
    endTime?: Date;
}

export class FleetResponseOfEnvelopedModelOfVehicleLocationVM extends BaseResponse implements IFleetResponseOfEnvelopedModelOfVehicleLocationVM {
    data?: EnvelopedModelOfVehicleLocationVM | undefined;

    constructor(data?: IFleetResponseOfEnvelopedModelOfVehicleLocationVM) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? EnvelopedModelOfVehicleLocationVM.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FleetResponseOfEnvelopedModelOfVehicleLocationVM {
        data = typeof data === 'object' ? data : {};
        let result = new FleetResponseOfEnvelopedModelOfVehicleLocationVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IFleetResponseOfEnvelopedModelOfVehicleLocationVM extends IBaseResponse {
    data?: EnvelopedModelOfVehicleLocationVM | undefined;
}

export class EnvelopedModelOfVehicleLocationVM implements IEnvelopedModelOfVehicleLocationVM {
    rows?: VehicleLocationVM[];
    totalItems?: number;

    constructor(data?: IEnvelopedModelOfVehicleLocationVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(VehicleLocationVM.fromJS(item));
            }
            this.totalItems = _data["totalItems"];
        }
    }

    static fromJS(data: any): EnvelopedModelOfVehicleLocationVM {
        data = typeof data === 'object' ? data : {};
        let result = new EnvelopedModelOfVehicleLocationVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        data["totalItems"] = this.totalItems;
        return data;
    }
}

export interface IEnvelopedModelOfVehicleLocationVM {
    rows?: VehicleLocationVM[];
    totalItems?: number;
}

export class VehicleLocationVM implements IVehicleLocationVM {
    vehicleId?: number;
    vehicleName?: string | undefined;
    driverName?: string;
    location?: CoordinatesVm | undefined;
    time?: Date;
    speed?: Speed;
    address?: string;
    groupName?: string;
    eventType?: string;
    geofenceName?: string | undefined;

    constructor(data?: IVehicleLocationVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vehicleId = _data["vehicleId"];
            this.vehicleName = _data["vehicleName"];
            this.driverName = _data["driverName"];
            this.location = _data["location"] ? CoordinatesVm.fromJS(_data["location"]) : <any>undefined;
            this.time = _data["time"] ? new Date(_data["time"].toString()) : <any>undefined;
            this.speed = _data["speed"] ? Speed.fromJS(_data["speed"]) : <any>undefined;
            this.address = _data["address"];
            this.groupName = _data["groupName"];
            this.eventType = _data["eventType"];
            this.geofenceName = _data["geofenceName"];
        }
    }

    static fromJS(data: any): VehicleLocationVM {
        data = typeof data === 'object' ? data : {};
        let result = new VehicleLocationVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vehicleId"] = this.vehicleId;
        data["vehicleName"] = this.vehicleName;
        data["driverName"] = this.driverName;
        data["location"] = this.location ? this.location.toJSON() : <any>undefined;
        data["time"] = this.time ? this.time.toISOString() : <any>undefined;
        data["speed"] = this.speed ? this.speed.toJSON() : <any>undefined;
        data["address"] = this.address;
        data["groupName"] = this.groupName;
        data["eventType"] = this.eventType;
        data["geofenceName"] = this.geofenceName;
        return data;
    }
}

export interface IVehicleLocationVM {
    vehicleId?: number;
    vehicleName?: string | undefined;
    driverName?: string;
    location?: CoordinatesVm | undefined;
    time?: Date;
    speed?: Speed;
    address?: string;
    groupName?: string;
    eventType?: string;
    geofenceName?: string | undefined;
}

export class Speed implements ISpeed {
    value?: number;
    unit?: SpeedUnit;

    constructor(data?: ISpeed) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.unit = _data["unit"];
        }
    }

    static fromJS(data: any): Speed {
        data = typeof data === 'object' ? data : {};
        let result = new Speed();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["unit"] = this.unit;
        return data;
    }
}

export interface ISpeed {
    value?: number;
    unit?: SpeedUnit;
}

export enum SpeedUnit {
    Undefined = 0,
    KilometerPerHour = 1,
    MeterPerSecond = 2,
    MilePerHour = 3,
}

export class VehicleLocationsRequestVM implements IVehicleLocationsRequestVM {
    vehicleIds?: number[];
    startTime!: Date;
    endTime!: Date;

    constructor(data?: IVehicleLocationsRequestVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["vehicleIds"])) {
                this.vehicleIds = [] as any;
                for (let item of _data["vehicleIds"])
                    this.vehicleIds!.push(item);
            }
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? new Date(_data["endTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): VehicleLocationsRequestVM {
        data = typeof data === 'object' ? data : {};
        let result = new VehicleLocationsRequestVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.vehicleIds)) {
            data["vehicleIds"] = [];
            for (let item of this.vehicleIds)
                data["vehicleIds"].push(item);
        }
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        return data;
    }
}

export interface IVehicleLocationsRequestVM {
    vehicleIds?: number[];
    startTime: Date;
    endTime: Date;
}

export class FleetResponseOfEnvelopedModelOfTrackedResourceLocationVM extends BaseResponse implements IFleetResponseOfEnvelopedModelOfTrackedResourceLocationVM {
    data?: EnvelopedModelOfTrackedResourceLocationVM | undefined;

    constructor(data?: IFleetResponseOfEnvelopedModelOfTrackedResourceLocationVM) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? EnvelopedModelOfTrackedResourceLocationVM.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FleetResponseOfEnvelopedModelOfTrackedResourceLocationVM {
        data = typeof data === 'object' ? data : {};
        let result = new FleetResponseOfEnvelopedModelOfTrackedResourceLocationVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IFleetResponseOfEnvelopedModelOfTrackedResourceLocationVM extends IBaseResponse {
    data?: EnvelopedModelOfTrackedResourceLocationVM | undefined;
}

export class EnvelopedModelOfTrackedResourceLocationVM implements IEnvelopedModelOfTrackedResourceLocationVM {
    rows?: TrackedResourceLocationVM[];
    totalItems?: number;

    constructor(data?: IEnvelopedModelOfTrackedResourceLocationVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(TrackedResourceLocationVM.fromJS(item));
            }
            this.totalItems = _data["totalItems"];
        }
    }

    static fromJS(data: any): EnvelopedModelOfTrackedResourceLocationVM {
        data = typeof data === 'object' ? data : {};
        let result = new EnvelopedModelOfTrackedResourceLocationVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        data["totalItems"] = this.totalItems;
        return data;
    }
}

export interface IEnvelopedModelOfTrackedResourceLocationVM {
    rows?: TrackedResourceLocationVM[];
    totalItems?: number;
}

export class TrackedResourceLocationVM implements ITrackedResourceLocationVM {
    trackedResourceId!: number;
    trackedResourceName!: string;
    trackedResourceType!: TrackedResourceType;
    driverName?: string | undefined;
    driverId?: number | undefined;
    location?: CoordinatesVm | undefined;
    time!: Date;
    speed?: Speed | undefined;
    address!: string;
    groupName!: string;
    eventId!: string;
    eventType!: string;
    eventVideoId?: number | undefined;
    geofenceName!: string;

    constructor(data?: ITrackedResourceLocationVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.trackedResourceId = _data["trackedResourceId"];
            this.trackedResourceName = _data["trackedResourceName"];
            this.trackedResourceType = _data["trackedResourceType"];
            this.driverName = _data["driverName"];
            this.driverId = _data["driverId"];
            this.location = _data["location"] ? CoordinatesVm.fromJS(_data["location"]) : <any>undefined;
            this.time = _data["time"] ? new Date(_data["time"].toString()) : <any>undefined;
            this.speed = _data["speed"] ? Speed.fromJS(_data["speed"]) : <any>undefined;
            this.address = _data["address"];
            this.groupName = _data["groupName"];
            this.eventId = _data["eventId"];
            this.eventType = _data["eventType"];
            this.eventVideoId = _data["eventVideoId"];
            this.geofenceName = _data["geofenceName"];
        }
    }

    static fromJS(data: any): TrackedResourceLocationVM {
        data = typeof data === 'object' ? data : {};
        let result = new TrackedResourceLocationVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["trackedResourceId"] = this.trackedResourceId;
        data["trackedResourceName"] = this.trackedResourceName;
        data["trackedResourceType"] = this.trackedResourceType;
        data["driverName"] = this.driverName;
        data["driverId"] = this.driverId;
        data["location"] = this.location ? this.location.toJSON() : <any>undefined;
        data["time"] = this.time ? this.time.toISOString() : <any>undefined;
        data["speed"] = this.speed ? this.speed.toJSON() : <any>undefined;
        data["address"] = this.address;
        data["groupName"] = this.groupName;
        data["eventId"] = this.eventId;
        data["eventType"] = this.eventType;
        data["eventVideoId"] = this.eventVideoId;
        data["geofenceName"] = this.geofenceName;
        return data;
    }
}

export interface ITrackedResourceLocationVM {
    trackedResourceId: number;
    trackedResourceName: string;
    trackedResourceType: TrackedResourceType;
    driverName?: string | undefined;
    driverId?: number | undefined;
    location?: CoordinatesVm | undefined;
    time: Date;
    speed?: Speed | undefined;
    address: string;
    groupName: string;
    eventId: string;
    eventType: string;
    eventVideoId?: number | undefined;
    geofenceName: string;
}

export enum TrackedResourceType {
    Vehicle = 1,
    Asset = 2,
}

export class TrackedResourceLocationsRequestVM implements ITrackedResourceLocationsRequestVM {
    trackedResourceIds!: number[];
    startTime!: Date;
    endTime!: Date;
    fetchEventVideoData?: boolean | undefined;

    constructor(data?: ITrackedResourceLocationsRequestVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.trackedResourceIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["trackedResourceIds"])) {
                this.trackedResourceIds = [] as any;
                for (let item of _data["trackedResourceIds"])
                    this.trackedResourceIds!.push(item);
            }
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? new Date(_data["endTime"].toString()) : <any>undefined;
            this.fetchEventVideoData = _data["fetchEventVideoData"];
        }
    }

    static fromJS(data: any): TrackedResourceLocationsRequestVM {
        data = typeof data === 'object' ? data : {};
        let result = new TrackedResourceLocationsRequestVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.trackedResourceIds)) {
            data["trackedResourceIds"] = [];
            for (let item of this.trackedResourceIds)
                data["trackedResourceIds"].push(item);
        }
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["fetchEventVideoData"] = this.fetchEventVideoData;
        return data;
    }
}

export interface ITrackedResourceLocationsRequestVM {
    trackedResourceIds: number[];
    startTime: Date;
    endTime: Date;
    fetchEventVideoData?: boolean | undefined;
}

export class FleetResponseOfIReadOnlyDictionaryOfStringAndString extends BaseResponse implements IFleetResponseOfIReadOnlyDictionaryOfStringAndString {
    data?: { [key: string]: string; } | undefined;

    constructor(data?: IFleetResponseOfIReadOnlyDictionaryOfStringAndString) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (_data["data"]) {
                this.data = {} as any;
                for (let key in _data["data"]) {
                    if (_data["data"].hasOwnProperty(key))
                        (<any>this.data)![key] = _data["data"][key];
                }
            }
        }
    }

    static fromJS(data: any): FleetResponseOfIReadOnlyDictionaryOfStringAndString {
        data = typeof data === 'object' ? data : {};
        let result = new FleetResponseOfIReadOnlyDictionaryOfStringAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.data) {
            data["data"] = {};
            for (let key in this.data) {
                if (this.data.hasOwnProperty(key))
                    (<any>data["data"])[key] = (<any>this.data)[key];
            }
        }
        super.toJSON(data);
        return data;
    }
}

export interface IFleetResponseOfIReadOnlyDictionaryOfStringAndString extends IBaseResponse {
    data?: { [key: string]: string; } | undefined;
}

export class FleetResponseOfEnvelopedModelOfFleetAssetLightVm extends BaseResponse implements IFleetResponseOfEnvelopedModelOfFleetAssetLightVm {
    data?: EnvelopedModelOfFleetAssetLightVm | undefined;

    constructor(data?: IFleetResponseOfEnvelopedModelOfFleetAssetLightVm) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? EnvelopedModelOfFleetAssetLightVm.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FleetResponseOfEnvelopedModelOfFleetAssetLightVm {
        data = typeof data === 'object' ? data : {};
        let result = new FleetResponseOfEnvelopedModelOfFleetAssetLightVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IFleetResponseOfEnvelopedModelOfFleetAssetLightVm extends IBaseResponse {
    data?: EnvelopedModelOfFleetAssetLightVm | undefined;
}

export class EnvelopedModelOfFleetAssetLightVm implements IEnvelopedModelOfFleetAssetLightVm {
    rows?: FleetAssetLightVm[];
    totalItems?: number;

    constructor(data?: IEnvelopedModelOfFleetAssetLightVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(FleetAssetLightVm.fromJS(item));
            }
            this.totalItems = _data["totalItems"];
        }
    }

    static fromJS(data: any): EnvelopedModelOfFleetAssetLightVm {
        data = typeof data === 'object' ? data : {};
        let result = new EnvelopedModelOfFleetAssetLightVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        data["totalItems"] = this.totalItems;
        return data;
    }
}

export interface IEnvelopedModelOfFleetAssetLightVm {
    rows?: FleetAssetLightVm[];
    totalItems?: number;
}

export class FleetAssetLightVm implements IFleetAssetLightVm {
    id!: number;
    group?: string | undefined;
    name!: string;
    deviceSerialNumber?: string | undefined;
    identification?: string | undefined;
    assetType?: string | undefined;
    licensePlateNumber?: string | undefined;
    make?: string | undefined;
    model?: string | undefined;
    year?: number | undefined;

    constructor(data?: IFleetAssetLightVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.group = _data["group"];
            this.name = _data["name"];
            this.deviceSerialNumber = _data["deviceSerialNumber"];
            this.identification = _data["identification"];
            this.assetType = _data["assetType"];
            this.licensePlateNumber = _data["licensePlateNumber"];
            this.make = _data["make"];
            this.model = _data["model"];
            this.year = _data["year"];
        }
    }

    static fromJS(data: any): FleetAssetLightVm {
        data = typeof data === 'object' ? data : {};
        let result = new FleetAssetLightVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["group"] = this.group;
        data["name"] = this.name;
        data["deviceSerialNumber"] = this.deviceSerialNumber;
        data["identification"] = this.identification;
        data["assetType"] = this.assetType;
        data["licensePlateNumber"] = this.licensePlateNumber;
        data["make"] = this.make;
        data["model"] = this.model;
        data["year"] = this.year;
        return data;
    }
}

export interface IFleetAssetLightVm {
    id: number;
    group?: string | undefined;
    name: string;
    deviceSerialNumber?: string | undefined;
    identification?: string | undefined;
    assetType?: string | undefined;
    licensePlateNumber?: string | undefined;
    make?: string | undefined;
    model?: string | undefined;
    year?: number | undefined;
}

export class FleetResponseOfFleetAssetVm extends BaseResponse implements IFleetResponseOfFleetAssetVm {
    data?: FleetAssetVm | undefined;

    constructor(data?: IFleetResponseOfFleetAssetVm) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? FleetAssetVm.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FleetResponseOfFleetAssetVm {
        data = typeof data === 'object' ? data : {};
        let result = new FleetResponseOfFleetAssetVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IFleetResponseOfFleetAssetVm extends IBaseResponse {
    data?: FleetAssetVm | undefined;
}

export class FleetAssetVm extends FleetAssetLightVm implements IFleetAssetVm {
    groupId!: number;
    purchaseDate?: Date | undefined;
    purchasePrice?: number | undefined;
    ownershipTypeId?: number | undefined;
    deviceData?: DeviceVM | undefined;

    constructor(data?: IFleetAssetVm) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.groupId = _data["groupId"];
            this.purchaseDate = _data["purchaseDate"] ? new Date(_data["purchaseDate"].toString()) : <any>undefined;
            this.purchasePrice = _data["purchasePrice"];
            this.ownershipTypeId = _data["ownershipTypeId"];
            this.deviceData = _data["deviceData"] ? DeviceVM.fromJS(_data["deviceData"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FleetAssetVm {
        data = typeof data === 'object' ? data : {};
        let result = new FleetAssetVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["groupId"] = this.groupId;
        data["purchaseDate"] = this.purchaseDate ? formatDate(this.purchaseDate) : <any>undefined;
        data["purchasePrice"] = this.purchasePrice;
        data["ownershipTypeId"] = this.ownershipTypeId;
        data["deviceData"] = this.deviceData ? this.deviceData.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IFleetAssetVm extends IFleetAssetLightVm {
    groupId: number;
    purchaseDate?: Date | undefined;
    purchasePrice?: number | undefined;
    ownershipTypeId?: number | undefined;
    deviceData?: DeviceVM | undefined;
}

export class DeviceVM implements IDeviceVM {
    id?: number;
    vehicleId?: number;
    deviceTypeId?: number;
    deviceVendorId?: number | undefined;
    deviceId?: string | undefined;
    deviceCode?: string | undefined;
    deviceSerialNumber?: string | undefined;
    deviceSimNumber?: string | undefined;
    deviceActivationDate?: Date | undefined;

    constructor(data?: IDeviceVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.vehicleId = _data["vehicleId"];
            this.deviceTypeId = _data["deviceTypeId"];
            this.deviceVendorId = _data["deviceVendorId"];
            this.deviceId = _data["deviceId"];
            this.deviceCode = _data["deviceCode"];
            this.deviceSerialNumber = _data["deviceSerialNumber"];
            this.deviceSimNumber = _data["deviceSimNumber"];
            this.deviceActivationDate = _data["deviceActivationDate"] ? new Date(_data["deviceActivationDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): DeviceVM {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["vehicleId"] = this.vehicleId;
        data["deviceTypeId"] = this.deviceTypeId;
        data["deviceVendorId"] = this.deviceVendorId;
        data["deviceId"] = this.deviceId;
        data["deviceCode"] = this.deviceCode;
        data["deviceSerialNumber"] = this.deviceSerialNumber;
        data["deviceSimNumber"] = this.deviceSimNumber;
        data["deviceActivationDate"] = this.deviceActivationDate ? this.deviceActivationDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IDeviceVM {
    id?: number;
    vehicleId?: number;
    deviceTypeId?: number;
    deviceVendorId?: number | undefined;
    deviceId?: string | undefined;
    deviceCode?: string | undefined;
    deviceSerialNumber?: string | undefined;
    deviceSimNumber?: string | undefined;
    deviceActivationDate?: Date | undefined;
}

export class FleetAssetUpdateVm implements IFleetAssetUpdateVm {
    id!: number;
    name!: string;
    identification?: string | undefined;
    assetType?: string | undefined;
    groupId!: number;
    make?: string | undefined;
    model?: string | undefined;
    year?: number | undefined;
    licensePlateNumber?: string | undefined;
    purchaseDate?: Date | undefined;
    purchasePrice?: number | undefined;
    ownershipTypeId?: number | undefined;

    constructor(data?: IFleetAssetUpdateVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.identification = _data["identification"];
            this.assetType = _data["assetType"];
            this.groupId = _data["groupId"];
            this.make = _data["make"];
            this.model = _data["model"];
            this.year = _data["year"];
            this.licensePlateNumber = _data["licensePlateNumber"];
            this.purchaseDate = _data["purchaseDate"] ? new Date(_data["purchaseDate"].toString()) : <any>undefined;
            this.purchasePrice = _data["purchasePrice"];
            this.ownershipTypeId = _data["ownershipTypeId"];
        }
    }

    static fromJS(data: any): FleetAssetUpdateVm {
        data = typeof data === 'object' ? data : {};
        let result = new FleetAssetUpdateVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["identification"] = this.identification;
        data["assetType"] = this.assetType;
        data["groupId"] = this.groupId;
        data["make"] = this.make;
        data["model"] = this.model;
        data["year"] = this.year;
        data["licensePlateNumber"] = this.licensePlateNumber;
        data["purchaseDate"] = this.purchaseDate ? formatDate(this.purchaseDate) : <any>undefined;
        data["purchasePrice"] = this.purchasePrice;
        data["ownershipTypeId"] = this.ownershipTypeId;
        return data;
    }
}

export interface IFleetAssetUpdateVm {
    id: number;
    name: string;
    identification?: string | undefined;
    assetType?: string | undefined;
    groupId: number;
    make?: string | undefined;
    model?: string | undefined;
    year?: number | undefined;
    licensePlateNumber?: string | undefined;
    purchaseDate?: Date | undefined;
    purchasePrice?: number | undefined;
    ownershipTypeId?: number | undefined;
}

export class FleetResponseOfEnvelopedModelOfUserVM extends BaseResponse implements IFleetResponseOfEnvelopedModelOfUserVM {
    data?: EnvelopedModelOfUserVM | undefined;

    constructor(data?: IFleetResponseOfEnvelopedModelOfUserVM) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? EnvelopedModelOfUserVM.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FleetResponseOfEnvelopedModelOfUserVM {
        data = typeof data === 'object' ? data : {};
        let result = new FleetResponseOfEnvelopedModelOfUserVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IFleetResponseOfEnvelopedModelOfUserVM extends IBaseResponse {
    data?: EnvelopedModelOfUserVM | undefined;
}

export class EnvelopedModelOfUserVM implements IEnvelopedModelOfUserVM {
    rows?: UserVM[];
    totalItems?: number;

    constructor(data?: IEnvelopedModelOfUserVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(UserVM.fromJS(item));
            }
            this.totalItems = _data["totalItems"];
        }
    }

    static fromJS(data: any): EnvelopedModelOfUserVM {
        data = typeof data === 'object' ? data : {};
        let result = new EnvelopedModelOfUserVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        data["totalItems"] = this.totalItems;
        return data;
    }
}

export interface IEnvelopedModelOfUserVM {
    rows?: UserVM[];
    totalItems?: number;
}

export class UserVM implements IUserVM {
    id?: number;
    integrationUserId?: string | undefined;
    partnerUserId?: string | undefined;
    name?: string | undefined;
    vehicleId?: number | undefined;
    vehicleName?: string | undefined;
    drivingScore?: number | undefined;
    groupId?: number;
    group?: string | undefined;
    role?: string | undefined;
    email?: string | undefined;
    status?: string | undefined;
    driverLicenseNumber?: string | undefined;
    driverLicenseIssueDate?: Date | undefined;
    driverLicenseExpirationDate?: Date | undefined;
    driverLicenseState?: string | undefined;
    expirationField1Name?: string | undefined;
    expirationField1Date?: Date | undefined;
    expirationField2Name?: string | undefined;
    expirationField2Date?: Date | undefined;
    createdOn?: Date;
    modifiedOn?: Date;

    constructor(data?: IUserVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.integrationUserId = _data["integrationUserId"];
            this.partnerUserId = _data["partnerUserId"];
            this.name = _data["name"];
            this.vehicleId = _data["vehicleId"];
            this.vehicleName = _data["vehicleName"];
            this.drivingScore = _data["drivingScore"];
            this.groupId = _data["groupId"];
            this.group = _data["group"];
            this.role = _data["role"];
            this.email = _data["email"];
            this.status = _data["status"];
            this.driverLicenseNumber = _data["driverLicenseNumber"];
            this.driverLicenseIssueDate = _data["driverLicenseIssueDate"] ? new Date(_data["driverLicenseIssueDate"].toString()) : <any>undefined;
            this.driverLicenseExpirationDate = _data["driverLicenseExpirationDate"] ? new Date(_data["driverLicenseExpirationDate"].toString()) : <any>undefined;
            this.driverLicenseState = _data["driverLicenseState"];
            this.expirationField1Name = _data["expirationField1Name"];
            this.expirationField1Date = _data["expirationField1Date"] ? new Date(_data["expirationField1Date"].toString()) : <any>undefined;
            this.expirationField2Name = _data["expirationField2Name"];
            this.expirationField2Date = _data["expirationField2Date"] ? new Date(_data["expirationField2Date"].toString()) : <any>undefined;
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.modifiedOn = _data["modifiedOn"] ? new Date(_data["modifiedOn"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): UserVM {
        data = typeof data === 'object' ? data : {};
        let result = new UserVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["integrationUserId"] = this.integrationUserId;
        data["partnerUserId"] = this.partnerUserId;
        data["name"] = this.name;
        data["vehicleId"] = this.vehicleId;
        data["vehicleName"] = this.vehicleName;
        data["drivingScore"] = this.drivingScore;
        data["groupId"] = this.groupId;
        data["group"] = this.group;
        data["role"] = this.role;
        data["email"] = this.email;
        data["status"] = this.status;
        data["driverLicenseNumber"] = this.driverLicenseNumber;
        data["driverLicenseIssueDate"] = this.driverLicenseIssueDate ? this.driverLicenseIssueDate.toISOString() : <any>undefined;
        data["driverLicenseExpirationDate"] = this.driverLicenseExpirationDate ? this.driverLicenseExpirationDate.toISOString() : <any>undefined;
        data["driverLicenseState"] = this.driverLicenseState;
        data["expirationField1Name"] = this.expirationField1Name;
        data["expirationField1Date"] = this.expirationField1Date ? this.expirationField1Date.toISOString() : <any>undefined;
        data["expirationField2Name"] = this.expirationField2Name;
        data["expirationField2Date"] = this.expirationField2Date ? this.expirationField2Date.toISOString() : <any>undefined;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        return data;
    }
}

export interface IUserVM {
    id?: number;
    integrationUserId?: string | undefined;
    partnerUserId?: string | undefined;
    name?: string | undefined;
    vehicleId?: number | undefined;
    vehicleName?: string | undefined;
    drivingScore?: number | undefined;
    groupId?: number;
    group?: string | undefined;
    role?: string | undefined;
    email?: string | undefined;
    status?: string | undefined;
    driverLicenseNumber?: string | undefined;
    driverLicenseIssueDate?: Date | undefined;
    driverLicenseExpirationDate?: Date | undefined;
    driverLicenseState?: string | undefined;
    expirationField1Name?: string | undefined;
    expirationField1Date?: Date | undefined;
    expirationField2Name?: string | undefined;
    expirationField2Date?: Date | undefined;
    createdOn?: Date;
    modifiedOn?: Date;
}

export class FleetResponseOfEnvelopedModelOfTreeVM extends BaseResponse implements IFleetResponseOfEnvelopedModelOfTreeVM {
    data?: EnvelopedModelOfTreeVM | undefined;

    constructor(data?: IFleetResponseOfEnvelopedModelOfTreeVM) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? EnvelopedModelOfTreeVM.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FleetResponseOfEnvelopedModelOfTreeVM {
        data = typeof data === 'object' ? data : {};
        let result = new FleetResponseOfEnvelopedModelOfTreeVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IFleetResponseOfEnvelopedModelOfTreeVM extends IBaseResponse {
    data?: EnvelopedModelOfTreeVM | undefined;
}

export class EnvelopedModelOfTreeVM implements IEnvelopedModelOfTreeVM {
    rows?: TreeVM[];
    totalItems?: number;

    constructor(data?: IEnvelopedModelOfTreeVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(TreeVM.fromJS(item));
            }
            this.totalItems = _data["totalItems"];
        }
    }

    static fromJS(data: any): EnvelopedModelOfTreeVM {
        data = typeof data === 'object' ? data : {};
        let result = new EnvelopedModelOfTreeVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        data["totalItems"] = this.totalItems;
        return data;
    }
}

export interface IEnvelopedModelOfTreeVM {
    rows?: TreeVM[];
    totalItems?: number;
}

export class TreeVM implements ITreeVM {
    text?: string | undefined;
    value?: string | undefined;
    options?: TreeVM[] | undefined;

    constructor(data?: ITreeVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.text = _data["text"];
            this.value = _data["value"];
            if (Array.isArray(_data["options"])) {
                this.options = [] as any;
                for (let item of _data["options"])
                    this.options!.push(TreeVM.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TreeVM {
        data = typeof data === 'object' ? data : {};
        let result = new TreeVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["text"] = this.text;
        data["value"] = this.value;
        if (Array.isArray(this.options)) {
            data["options"] = [];
            for (let item of this.options)
                data["options"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITreeVM {
    text?: string | undefined;
    value?: string | undefined;
    options?: TreeVM[] | undefined;
}

export class FleetResponseOfUserVM extends BaseResponse implements IFleetResponseOfUserVM {
    data?: UserVM | undefined;

    constructor(data?: IFleetResponseOfUserVM) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? UserVM.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FleetResponseOfUserVM {
        data = typeof data === 'object' ? data : {};
        let result = new FleetResponseOfUserVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IFleetResponseOfUserVM extends IBaseResponse {
    data?: UserVM | undefined;
}

export class UserMappingVM implements IUserMappingVM {
    proxyUserId?: string;
    integrationUserId?: string;

    constructor(data?: IUserMappingVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.proxyUserId = _data["proxyUserId"];
            this.integrationUserId = _data["integrationUserId"];
        }
    }

    static fromJS(data: any): UserMappingVM {
        data = typeof data === 'object' ? data : {};
        let result = new UserMappingVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["proxyUserId"] = this.proxyUserId;
        data["integrationUserId"] = this.integrationUserId;
        return data;
    }
}

export interface IUserMappingVM {
    proxyUserId?: string;
    integrationUserId?: string;
}

export class FleetResponseOfPaginatedModelOfGeofenceLightVM extends BaseResponse implements IFleetResponseOfPaginatedModelOfGeofenceLightVM {
    data?: PaginatedModelOfGeofenceLightVM | undefined;

    constructor(data?: IFleetResponseOfPaginatedModelOfGeofenceLightVM) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? PaginatedModelOfGeofenceLightVM.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FleetResponseOfPaginatedModelOfGeofenceLightVM {
        data = typeof data === 'object' ? data : {};
        let result = new FleetResponseOfPaginatedModelOfGeofenceLightVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IFleetResponseOfPaginatedModelOfGeofenceLightVM extends IBaseResponse {
    data?: PaginatedModelOfGeofenceLightVM | undefined;
}

export class PaginatedModelOfGeofenceLightVM implements IPaginatedModelOfGeofenceLightVM {
    page!: number;
    totalPages!: number;
    totalItems!: number;
    maxItemCountReached!: boolean;
    maxItemCount!: number;
    rows!: GeofenceLightVM[];

    constructor(data?: IPaginatedModelOfGeofenceLightVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.rows = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.page = _data["page"];
            this.totalPages = _data["totalPages"];
            this.totalItems = _data["totalItems"];
            this.maxItemCountReached = _data["maxItemCountReached"];
            this.maxItemCount = _data["maxItemCount"];
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(GeofenceLightVM.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedModelOfGeofenceLightVM {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedModelOfGeofenceLightVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["page"] = this.page;
        data["totalPages"] = this.totalPages;
        data["totalItems"] = this.totalItems;
        data["maxItemCountReached"] = this.maxItemCountReached;
        data["maxItemCount"] = this.maxItemCount;
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPaginatedModelOfGeofenceLightVM {
    page: number;
    totalPages: number;
    totalItems: number;
    maxItemCountReached: boolean;
    maxItemCount: number;
    rows: GeofenceLightVM[];
}

export class GeofenceLightVM implements IGeofenceLightVM {
    id?: number;
    name?: string;
    createdAt?: Date;
    address?: string | undefined;
    categoryName?: string;
    latitude?: number;
    longitude?: number;
    polygonVertices?: number[][][] | undefined;
    radius?: number | undefined;
    radiusUnit?: string | undefined;
    type?: string;
    trackWhen?: string;
    groupNames?: string[];
    vehicleNames?: string[];
    sendAlertNotification?: boolean;
    notificationMethods?: string[];
    trackingSchedule?: string;

    constructor(data?: IGeofenceLightVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.address = _data["address"];
            this.categoryName = _data["categoryName"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            if (Array.isArray(_data["polygonVertices"])) {
                this.polygonVertices = [] as any;
                for (let item of _data["polygonVertices"])
                    this.polygonVertices!.push(item);
            }
            this.radius = _data["radius"];
            this.radiusUnit = _data["radiusUnit"];
            this.type = _data["type"];
            this.trackWhen = _data["trackWhen"];
            if (Array.isArray(_data["groupNames"])) {
                this.groupNames = [] as any;
                for (let item of _data["groupNames"])
                    this.groupNames!.push(item);
            }
            if (Array.isArray(_data["vehicleNames"])) {
                this.vehicleNames = [] as any;
                for (let item of _data["vehicleNames"])
                    this.vehicleNames!.push(item);
            }
            this.sendAlertNotification = _data["sendAlertNotification"];
            if (Array.isArray(_data["notificationMethods"])) {
                this.notificationMethods = [] as any;
                for (let item of _data["notificationMethods"])
                    this.notificationMethods!.push(item);
            }
            this.trackingSchedule = _data["trackingSchedule"];
        }
    }

    static fromJS(data: any): GeofenceLightVM {
        data = typeof data === 'object' ? data : {};
        let result = new GeofenceLightVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["address"] = this.address;
        data["categoryName"] = this.categoryName;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        if (Array.isArray(this.polygonVertices)) {
            data["polygonVertices"] = [];
            for (let item of this.polygonVertices)
                data["polygonVertices"].push(item);
        }
        data["radius"] = this.radius;
        data["radiusUnit"] = this.radiusUnit;
        data["type"] = this.type;
        data["trackWhen"] = this.trackWhen;
        if (Array.isArray(this.groupNames)) {
            data["groupNames"] = [];
            for (let item of this.groupNames)
                data["groupNames"].push(item);
        }
        if (Array.isArray(this.vehicleNames)) {
            data["vehicleNames"] = [];
            for (let item of this.vehicleNames)
                data["vehicleNames"].push(item);
        }
        data["sendAlertNotification"] = this.sendAlertNotification;
        if (Array.isArray(this.notificationMethods)) {
            data["notificationMethods"] = [];
            for (let item of this.notificationMethods)
                data["notificationMethods"].push(item);
        }
        data["trackingSchedule"] = this.trackingSchedule;
        return data;
    }
}

export interface IGeofenceLightVM {
    id?: number;
    name?: string;
    createdAt?: Date;
    address?: string | undefined;
    categoryName?: string;
    latitude?: number;
    longitude?: number;
    polygonVertices?: number[][][] | undefined;
    radius?: number | undefined;
    radiusUnit?: string | undefined;
    type?: string;
    trackWhen?: string;
    groupNames?: string[];
    vehicleNames?: string[];
    sendAlertNotification?: boolean;
    notificationMethods?: string[];
    trackingSchedule?: string;
}

export class FleetResponseOfGeofenceVM extends BaseResponse implements IFleetResponseOfGeofenceVM {
    data?: GeofenceVM | undefined;

    constructor(data?: IFleetResponseOfGeofenceVM) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? GeofenceVM.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FleetResponseOfGeofenceVM {
        data = typeof data === 'object' ? data : {};
        let result = new FleetResponseOfGeofenceVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IFleetResponseOfGeofenceVM extends IBaseResponse {
    data?: GeofenceVM | undefined;
}

export class GeofenceVM implements IGeofenceVM {
    id?: number | undefined;
    name?: string;
    categoryName?: string;
    isDefaultCategory?: boolean;
    address?: string | undefined;
    type?: string;
    alertOnEntry?: boolean;
    alertOnExit?: boolean;
    notExitedTimeout?: number | undefined;
    notEnteredTimeout?: number | undefined;
    trackOnlyVehicleMovementInGeofence?: boolean;
    trackOnlyVehicleMovementOutGeofence?: boolean;
    latitude?: number;
    longitude?: number;
    radius?: number | undefined;
    radiusUnit?: string | undefined;
    polygonVertices?: number[][][] | undefined;
    triggerTimeRangesByDay?: TriggerTimeRanges[];
    sendAlertNotification?: boolean;
    notificationFrequency?: number;
    groupIds?: number[];
    vehicleIds?: number[];
    notificationMethods?: NotificationMethodCreateVM[];

    constructor(data?: IGeofenceVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.categoryName = _data["categoryName"];
            this.isDefaultCategory = _data["isDefaultCategory"];
            this.address = _data["address"];
            this.type = _data["type"];
            this.alertOnEntry = _data["alertOnEntry"];
            this.alertOnExit = _data["alertOnExit"];
            this.notExitedTimeout = _data["notExitedTimeout"];
            this.notEnteredTimeout = _data["notEnteredTimeout"];
            this.trackOnlyVehicleMovementInGeofence = _data["trackOnlyVehicleMovementInGeofence"];
            this.trackOnlyVehicleMovementOutGeofence = _data["trackOnlyVehicleMovementOutGeofence"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.radius = _data["radius"];
            this.radiusUnit = _data["radiusUnit"];
            if (Array.isArray(_data["polygonVertices"])) {
                this.polygonVertices = [] as any;
                for (let item of _data["polygonVertices"])
                    this.polygonVertices!.push(item);
            }
            if (Array.isArray(_data["triggerTimeRangesByDay"])) {
                this.triggerTimeRangesByDay = [] as any;
                for (let item of _data["triggerTimeRangesByDay"])
                    this.triggerTimeRangesByDay!.push(TriggerTimeRanges.fromJS(item));
            }
            this.sendAlertNotification = _data["sendAlertNotification"];
            this.notificationFrequency = _data["notificationFrequency"];
            if (Array.isArray(_data["groupIds"])) {
                this.groupIds = [] as any;
                for (let item of _data["groupIds"])
                    this.groupIds!.push(item);
            }
            if (Array.isArray(_data["vehicleIds"])) {
                this.vehicleIds = [] as any;
                for (let item of _data["vehicleIds"])
                    this.vehicleIds!.push(item);
            }
            if (Array.isArray(_data["notificationMethods"])) {
                this.notificationMethods = [] as any;
                for (let item of _data["notificationMethods"])
                    this.notificationMethods!.push(NotificationMethodCreateVM.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GeofenceVM {
        data = typeof data === 'object' ? data : {};
        let result = new GeofenceVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["categoryName"] = this.categoryName;
        data["isDefaultCategory"] = this.isDefaultCategory;
        data["address"] = this.address;
        data["type"] = this.type;
        data["alertOnEntry"] = this.alertOnEntry;
        data["alertOnExit"] = this.alertOnExit;
        data["notExitedTimeout"] = this.notExitedTimeout;
        data["notEnteredTimeout"] = this.notEnteredTimeout;
        data["trackOnlyVehicleMovementInGeofence"] = this.trackOnlyVehicleMovementInGeofence;
        data["trackOnlyVehicleMovementOutGeofence"] = this.trackOnlyVehicleMovementOutGeofence;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["radius"] = this.radius;
        data["radiusUnit"] = this.radiusUnit;
        if (Array.isArray(this.polygonVertices)) {
            data["polygonVertices"] = [];
            for (let item of this.polygonVertices)
                data["polygonVertices"].push(item);
        }
        if (Array.isArray(this.triggerTimeRangesByDay)) {
            data["triggerTimeRangesByDay"] = [];
            for (let item of this.triggerTimeRangesByDay)
                data["triggerTimeRangesByDay"].push(item.toJSON());
        }
        data["sendAlertNotification"] = this.sendAlertNotification;
        data["notificationFrequency"] = this.notificationFrequency;
        if (Array.isArray(this.groupIds)) {
            data["groupIds"] = [];
            for (let item of this.groupIds)
                data["groupIds"].push(item);
        }
        if (Array.isArray(this.vehicleIds)) {
            data["vehicleIds"] = [];
            for (let item of this.vehicleIds)
                data["vehicleIds"].push(item);
        }
        if (Array.isArray(this.notificationMethods)) {
            data["notificationMethods"] = [];
            for (let item of this.notificationMethods)
                data["notificationMethods"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGeofenceVM {
    id?: number | undefined;
    name?: string;
    categoryName?: string;
    isDefaultCategory?: boolean;
    address?: string | undefined;
    type?: string;
    alertOnEntry?: boolean;
    alertOnExit?: boolean;
    notExitedTimeout?: number | undefined;
    notEnteredTimeout?: number | undefined;
    trackOnlyVehicleMovementInGeofence?: boolean;
    trackOnlyVehicleMovementOutGeofence?: boolean;
    latitude?: number;
    longitude?: number;
    radius?: number | undefined;
    radiusUnit?: string | undefined;
    polygonVertices?: number[][][] | undefined;
    triggerTimeRangesByDay?: TriggerTimeRanges[];
    sendAlertNotification?: boolean;
    notificationFrequency?: number;
    groupIds?: number[];
    vehicleIds?: number[];
    notificationMethods?: NotificationMethodCreateVM[];
}

export class FleetResponseOfEnvelopedModelOfGroupVM extends BaseResponse implements IFleetResponseOfEnvelopedModelOfGroupVM {
    data?: EnvelopedModelOfGroupVM | undefined;

    constructor(data?: IFleetResponseOfEnvelopedModelOfGroupVM) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? EnvelopedModelOfGroupVM.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FleetResponseOfEnvelopedModelOfGroupVM {
        data = typeof data === 'object' ? data : {};
        let result = new FleetResponseOfEnvelopedModelOfGroupVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IFleetResponseOfEnvelopedModelOfGroupVM extends IBaseResponse {
    data?: EnvelopedModelOfGroupVM | undefined;
}

export class EnvelopedModelOfGroupVM implements IEnvelopedModelOfGroupVM {
    rows?: GroupVM[];
    totalItems?: number;

    constructor(data?: IEnvelopedModelOfGroupVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(GroupVM.fromJS(item));
            }
            this.totalItems = _data["totalItems"];
        }
    }

    static fromJS(data: any): EnvelopedModelOfGroupVM {
        data = typeof data === 'object' ? data : {};
        let result = new EnvelopedModelOfGroupVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        data["totalItems"] = this.totalItems;
        return data;
    }
}

export interface IEnvelopedModelOfGroupVM {
    rows?: GroupVM[];
    totalItems?: number;
}

export class GroupVM implements IGroupVM {
    id?: number | undefined;
    name?: string;
    vendorId?: string | undefined;
    parentGroupId?: number | undefined;
    parentGroupName?: string | undefined;
    configurationId?: number | undefined;
    description?: string | undefined;
    vehicles?: GroupVehicleVM[];

    constructor(data?: IGroupVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.vendorId = _data["vendorId"];
            this.parentGroupId = _data["parentGroupId"];
            this.parentGroupName = _data["parentGroupName"];
            this.configurationId = _data["configurationId"];
            this.description = _data["description"];
            if (Array.isArray(_data["vehicles"])) {
                this.vehicles = [] as any;
                for (let item of _data["vehicles"])
                    this.vehicles!.push(GroupVehicleVM.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GroupVM {
        data = typeof data === 'object' ? data : {};
        let result = new GroupVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["vendorId"] = this.vendorId;
        data["parentGroupId"] = this.parentGroupId;
        data["parentGroupName"] = this.parentGroupName;
        data["configurationId"] = this.configurationId;
        data["description"] = this.description;
        if (Array.isArray(this.vehicles)) {
            data["vehicles"] = [];
            for (let item of this.vehicles)
                data["vehicles"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGroupVM {
    id?: number | undefined;
    name?: string;
    vendorId?: string | undefined;
    parentGroupId?: number | undefined;
    parentGroupName?: string | undefined;
    configurationId?: number | undefined;
    description?: string | undefined;
    vehicles?: GroupVehicleVM[];
}

export class GroupVehicleVM implements IGroupVehicleVM {
    id?: number;
    name?: string | undefined;
    trackedResourceType?: TrackedResourceType;
    assetId?: number | undefined;

    constructor(data?: IGroupVehicleVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.trackedResourceType = _data["trackedResourceType"];
            this.assetId = _data["assetId"];
        }
    }

    static fromJS(data: any): GroupVehicleVM {
        data = typeof data === 'object' ? data : {};
        let result = new GroupVehicleVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["trackedResourceType"] = this.trackedResourceType;
        data["assetId"] = this.assetId;
        return data;
    }
}

export interface IGroupVehicleVM {
    id?: number;
    name?: string | undefined;
    trackedResourceType?: TrackedResourceType;
    assetId?: number | undefined;
}

export class FleetResponseOfGroupVM extends BaseResponse implements IFleetResponseOfGroupVM {
    data?: GroupVM | undefined;

    constructor(data?: IFleetResponseOfGroupVM) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? GroupVM.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FleetResponseOfGroupVM {
        data = typeof data === 'object' ? data : {};
        let result = new FleetResponseOfGroupVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IFleetResponseOfGroupVM extends IBaseResponse {
    data?: GroupVM | undefined;
}

export class FleetResponseOfLong extends BaseResponse implements IFleetResponseOfLong {
    data?: number;

    constructor(data?: IFleetResponseOfLong) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"];
        }
    }

    static fromJS(data: any): FleetResponseOfLong {
        data = typeof data === 'object' ? data : {};
        let result = new FleetResponseOfLong();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data;
        super.toJSON(data);
        return data;
    }
}

export interface IFleetResponseOfLong extends IBaseResponse {
    data?: number;
}

export class FleetResponseOfIEnumerableOfLong extends BaseResponse implements IFleetResponseOfIEnumerableOfLong {
    data?: number[] | undefined;

    constructor(data?: IFleetResponseOfIEnumerableOfLong) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(item);
            }
        }
    }

    static fromJS(data: any): FleetResponseOfIEnumerableOfLong {
        data = typeof data === 'object' ? data : {};
        let result = new FleetResponseOfIEnumerableOfLong();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IFleetResponseOfIEnumerableOfLong extends IBaseResponse {
    data?: number[] | undefined;
}

export class FleetResponseOfEnvelopedModelOfMaintenanceReminderGridVM extends BaseResponse implements IFleetResponseOfEnvelopedModelOfMaintenanceReminderGridVM {
    data?: EnvelopedModelOfMaintenanceReminderGridVM | undefined;

    constructor(data?: IFleetResponseOfEnvelopedModelOfMaintenanceReminderGridVM) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? EnvelopedModelOfMaintenanceReminderGridVM.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FleetResponseOfEnvelopedModelOfMaintenanceReminderGridVM {
        data = typeof data === 'object' ? data : {};
        let result = new FleetResponseOfEnvelopedModelOfMaintenanceReminderGridVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IFleetResponseOfEnvelopedModelOfMaintenanceReminderGridVM extends IBaseResponse {
    data?: EnvelopedModelOfMaintenanceReminderGridVM | undefined;
}

export class EnvelopedModelOfMaintenanceReminderGridVM implements IEnvelopedModelOfMaintenanceReminderGridVM {
    rows?: MaintenanceReminderGridVM[];
    totalItems?: number;

    constructor(data?: IEnvelopedModelOfMaintenanceReminderGridVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(MaintenanceReminderGridVM.fromJS(item));
            }
            this.totalItems = _data["totalItems"];
        }
    }

    static fromJS(data: any): EnvelopedModelOfMaintenanceReminderGridVM {
        data = typeof data === 'object' ? data : {};
        let result = new EnvelopedModelOfMaintenanceReminderGridVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        data["totalItems"] = this.totalItems;
        return data;
    }
}

export interface IEnvelopedModelOfMaintenanceReminderGridVM {
    rows?: MaintenanceReminderGridVM[];
    totalItems?: number;
}

export class MaintenanceReminderGridVM implements IMaintenanceReminderGridVM {
    reminderId!: number;
    name!: string;
    vehicleId!: number;
    vehicleName!: string;
    groupName!: string;
    dueDate?: Date | undefined;
    dueMileage?: number | undefined;
    dueEngineHourSeconds?: number | undefined;
    notificationEnabled!: boolean;
    notificationTypes!: NotificationType[];
    recipients!: string[];
    checklistId!: number;
    serviceType!: string;
    status!: MaintenanceStatus;
    conditions!: MaintenanceConditionVM[];

    constructor(data?: IMaintenanceReminderGridVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.notificationTypes = [];
            this.recipients = [];
            this.conditions = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reminderId = _data["reminderId"];
            this.name = _data["name"];
            this.vehicleId = _data["vehicleId"];
            this.vehicleName = _data["vehicleName"];
            this.groupName = _data["groupName"];
            this.dueDate = _data["dueDate"] ? new Date(_data["dueDate"].toString()) : <any>undefined;
            this.dueMileage = _data["dueMileage"];
            this.dueEngineHourSeconds = _data["dueEngineHourSeconds"];
            this.notificationEnabled = _data["notificationEnabled"];
            if (Array.isArray(_data["notificationTypes"])) {
                this.notificationTypes = [] as any;
                for (let item of _data["notificationTypes"])
                    this.notificationTypes!.push(item);
            }
            if (Array.isArray(_data["recipients"])) {
                this.recipients = [] as any;
                for (let item of _data["recipients"])
                    this.recipients!.push(item);
            }
            this.checklistId = _data["checklistId"];
            this.serviceType = _data["serviceType"];
            this.status = _data["status"];
            if (Array.isArray(_data["conditions"])) {
                this.conditions = [] as any;
                for (let item of _data["conditions"])
                    this.conditions!.push(MaintenanceConditionVM.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MaintenanceReminderGridVM {
        data = typeof data === 'object' ? data : {};
        let result = new MaintenanceReminderGridVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reminderId"] = this.reminderId;
        data["name"] = this.name;
        data["vehicleId"] = this.vehicleId;
        data["vehicleName"] = this.vehicleName;
        data["groupName"] = this.groupName;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        data["dueMileage"] = this.dueMileage;
        data["dueEngineHourSeconds"] = this.dueEngineHourSeconds;
        data["notificationEnabled"] = this.notificationEnabled;
        if (Array.isArray(this.notificationTypes)) {
            data["notificationTypes"] = [];
            for (let item of this.notificationTypes)
                data["notificationTypes"].push(item);
        }
        if (Array.isArray(this.recipients)) {
            data["recipients"] = [];
            for (let item of this.recipients)
                data["recipients"].push(item);
        }
        data["checklistId"] = this.checklistId;
        data["serviceType"] = this.serviceType;
        data["status"] = this.status;
        if (Array.isArray(this.conditions)) {
            data["conditions"] = [];
            for (let item of this.conditions)
                data["conditions"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMaintenanceReminderGridVM {
    reminderId: number;
    name: string;
    vehicleId: number;
    vehicleName: string;
    groupName: string;
    dueDate?: Date | undefined;
    dueMileage?: number | undefined;
    dueEngineHourSeconds?: number | undefined;
    notificationEnabled: boolean;
    notificationTypes: NotificationType[];
    recipients: string[];
    checklistId: number;
    serviceType: string;
    status: MaintenanceStatus;
    conditions: MaintenanceConditionVM[];
}

export enum NotificationType {
    Email = 1,
    Sms = 2,
    OnScreen = 3,
}

export enum MaintenanceStatus {
    Unknown = 0,
    Upcoming = 1,
    Future = 2,
    Overdue = 3,
}

export class MaintenanceConditionVM implements IMaintenanceConditionVM {
    type!: MaintenanceConditionType;
    value!: number;
    unitType?: string;

    constructor(data?: IMaintenanceConditionVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.value = _data["value"];
            this.unitType = _data["unitType"];
        }
    }

    static fromJS(data: any): MaintenanceConditionVM {
        data = typeof data === 'object' ? data : {};
        let result = new MaintenanceConditionVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["value"] = this.value;
        data["unitType"] = this.unitType;
        return data;
    }
}

export interface IMaintenanceConditionVM {
    type: MaintenanceConditionType;
    value: number;
    unitType?: string;
}

export enum MaintenanceConditionType {
    TimeInterval = 1,
    Mileage = 2,
    EngineHours = 3,
}

export class FleetResponseOfEnvelopedModelOfMaintenanceReminderShortInfoVM extends BaseResponse implements IFleetResponseOfEnvelopedModelOfMaintenanceReminderShortInfoVM {
    data?: EnvelopedModelOfMaintenanceReminderShortInfoVM | undefined;

    constructor(data?: IFleetResponseOfEnvelopedModelOfMaintenanceReminderShortInfoVM) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? EnvelopedModelOfMaintenanceReminderShortInfoVM.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FleetResponseOfEnvelopedModelOfMaintenanceReminderShortInfoVM {
        data = typeof data === 'object' ? data : {};
        let result = new FleetResponseOfEnvelopedModelOfMaintenanceReminderShortInfoVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IFleetResponseOfEnvelopedModelOfMaintenanceReminderShortInfoVM extends IBaseResponse {
    data?: EnvelopedModelOfMaintenanceReminderShortInfoVM | undefined;
}

export class EnvelopedModelOfMaintenanceReminderShortInfoVM implements IEnvelopedModelOfMaintenanceReminderShortInfoVM {
    rows?: MaintenanceReminderShortInfoVM[];
    totalItems?: number;

    constructor(data?: IEnvelopedModelOfMaintenanceReminderShortInfoVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(MaintenanceReminderShortInfoVM.fromJS(item));
            }
            this.totalItems = _data["totalItems"];
        }
    }

    static fromJS(data: any): EnvelopedModelOfMaintenanceReminderShortInfoVM {
        data = typeof data === 'object' ? data : {};
        let result = new EnvelopedModelOfMaintenanceReminderShortInfoVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        data["totalItems"] = this.totalItems;
        return data;
    }
}

export interface IEnvelopedModelOfMaintenanceReminderShortInfoVM {
    rows?: MaintenanceReminderShortInfoVM[];
    totalItems?: number;
}

export class MaintenanceReminderShortInfoVM implements IMaintenanceReminderShortInfoVM {
    reminderId!: number;
    vehicleId!: number;
    name!: string;

    constructor(data?: IMaintenanceReminderShortInfoVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reminderId = _data["reminderId"];
            this.vehicleId = _data["vehicleId"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): MaintenanceReminderShortInfoVM {
        data = typeof data === 'object' ? data : {};
        let result = new MaintenanceReminderShortInfoVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reminderId"] = this.reminderId;
        data["vehicleId"] = this.vehicleId;
        data["name"] = this.name;
        return data;
    }
}

export interface IMaintenanceReminderShortInfoVM {
    reminderId: number;
    vehicleId: number;
    name: string;
}

export class FleetResponseOfMaintenanceReminderDetailsVM extends BaseResponse implements IFleetResponseOfMaintenanceReminderDetailsVM {
    data?: MaintenanceReminderDetailsVM | undefined;

    constructor(data?: IFleetResponseOfMaintenanceReminderDetailsVM) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? MaintenanceReminderDetailsVM.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FleetResponseOfMaintenanceReminderDetailsVM {
        data = typeof data === 'object' ? data : {};
        let result = new FleetResponseOfMaintenanceReminderDetailsVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IFleetResponseOfMaintenanceReminderDetailsVM extends IBaseResponse {
    data?: MaintenanceReminderDetailsVM | undefined;
}

export class MaintenanceReminderDetailsVM implements IMaintenanceReminderDetailsVM {
    id!: number;
    name!: string;
    vehicleId!: number;
    sendAlertNotification?: boolean;
    notificationFrequency?: number;
    notificationMethods!: NotificationMethodCreateVM[];
    thresholds!: MaintenanceThresholdsVM;
    checklists!: MaintenanceChecklistDetailsVM[];

    constructor(data?: IMaintenanceReminderDetailsVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.notificationMethods = [];
            this.thresholds = new MaintenanceThresholdsVM();
            this.checklists = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.vehicleId = _data["vehicleId"];
            this.sendAlertNotification = _data["sendAlertNotification"];
            this.notificationFrequency = _data["notificationFrequency"];
            if (Array.isArray(_data["notificationMethods"])) {
                this.notificationMethods = [] as any;
                for (let item of _data["notificationMethods"])
                    this.notificationMethods!.push(NotificationMethodCreateVM.fromJS(item));
            }
            this.thresholds = _data["thresholds"] ? MaintenanceThresholdsVM.fromJS(_data["thresholds"]) : new MaintenanceThresholdsVM();
            if (Array.isArray(_data["checklists"])) {
                this.checklists = [] as any;
                for (let item of _data["checklists"])
                    this.checklists!.push(MaintenanceChecklistDetailsVM.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MaintenanceReminderDetailsVM {
        data = typeof data === 'object' ? data : {};
        let result = new MaintenanceReminderDetailsVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["vehicleId"] = this.vehicleId;
        data["sendAlertNotification"] = this.sendAlertNotification;
        data["notificationFrequency"] = this.notificationFrequency;
        if (Array.isArray(this.notificationMethods)) {
            data["notificationMethods"] = [];
            for (let item of this.notificationMethods)
                data["notificationMethods"].push(item.toJSON());
        }
        data["thresholds"] = this.thresholds ? this.thresholds.toJSON() : <any>undefined;
        if (Array.isArray(this.checklists)) {
            data["checklists"] = [];
            for (let item of this.checklists)
                data["checklists"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMaintenanceReminderDetailsVM {
    id: number;
    name: string;
    vehicleId: number;
    sendAlertNotification?: boolean;
    notificationFrequency?: number;
    notificationMethods: NotificationMethodCreateVM[];
    thresholds: MaintenanceThresholdsVM;
    checklists: MaintenanceChecklistDetailsVM[];
}

export class MaintenanceThresholdsVM implements IMaintenanceThresholdsVM {
    mileageMiles!: number;
    timeIntervalDays!: number;
    engineHours!: number;

    constructor(data?: IMaintenanceThresholdsVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mileageMiles = _data["mileageMiles"];
            this.timeIntervalDays = _data["timeIntervalDays"];
            this.engineHours = _data["engineHours"];
        }
    }

    static fromJS(data: any): MaintenanceThresholdsVM {
        data = typeof data === 'object' ? data : {};
        let result = new MaintenanceThresholdsVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mileageMiles"] = this.mileageMiles;
        data["timeIntervalDays"] = this.timeIntervalDays;
        data["engineHours"] = this.engineHours;
        return data;
    }
}

export interface IMaintenanceThresholdsVM {
    mileageMiles: number;
    timeIntervalDays: number;
    engineHours: number;
}

export class MaintenanceChecklistDetailsVM implements IMaintenanceChecklistDetailsVM {
    id!: number;
    serviceType!: string;
    lastServiceDate!: Date;
    mileageEnabled!: boolean;
    mileageInterval?: number;
    engineHoursEnabled!: boolean;
    engineHoursInterval?: number;
    serviceEnabled!: boolean;
    serviceInterval?: number;
    serviceIntervalUnit?: MaintenanceTimeIntervalUnit;

    constructor(data?: IMaintenanceChecklistDetailsVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.serviceType = _data["serviceType"];
            this.lastServiceDate = _data["lastServiceDate"] ? new Date(_data["lastServiceDate"].toString()) : <any>undefined;
            this.mileageEnabled = _data["mileageEnabled"];
            this.mileageInterval = _data["mileageInterval"];
            this.engineHoursEnabled = _data["engineHoursEnabled"];
            this.engineHoursInterval = _data["engineHoursInterval"];
            this.serviceEnabled = _data["serviceEnabled"];
            this.serviceInterval = _data["serviceInterval"];
            this.serviceIntervalUnit = _data["serviceIntervalUnit"];
        }
    }

    static fromJS(data: any): MaintenanceChecklistDetailsVM {
        data = typeof data === 'object' ? data : {};
        let result = new MaintenanceChecklistDetailsVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["serviceType"] = this.serviceType;
        data["lastServiceDate"] = this.lastServiceDate ? this.lastServiceDate.toISOString() : <any>undefined;
        data["mileageEnabled"] = this.mileageEnabled;
        data["mileageInterval"] = this.mileageInterval;
        data["engineHoursEnabled"] = this.engineHoursEnabled;
        data["engineHoursInterval"] = this.engineHoursInterval;
        data["serviceEnabled"] = this.serviceEnabled;
        data["serviceInterval"] = this.serviceInterval;
        data["serviceIntervalUnit"] = this.serviceIntervalUnit;
        return data;
    }
}

export interface IMaintenanceChecklistDetailsVM {
    id: number;
    serviceType: string;
    lastServiceDate: Date;
    mileageEnabled: boolean;
    mileageInterval?: number;
    engineHoursEnabled: boolean;
    engineHoursInterval?: number;
    serviceEnabled: boolean;
    serviceInterval?: number;
    serviceIntervalUnit?: MaintenanceTimeIntervalUnit;
}

export enum MaintenanceTimeIntervalUnit {
    Day = 1,
    Month = 2,
    Year = 3,
}

export class MaintenanceReminderCreateVM implements IMaintenanceReminderCreateVM {
    name!: string;
    vehicleId!: number;
    sendAlertNotification?: boolean;
    notificationFrequency?: number;
    notificationMethods!: NotificationMethodCreateVM[];
    thresholds!: MaintenanceThresholdsVM;
    checklists!: MaintenanceChecklistUpsertVM[];

    constructor(data?: IMaintenanceReminderCreateVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.notificationMethods = [];
            this.thresholds = new MaintenanceThresholdsVM();
            this.checklists = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.vehicleId = _data["vehicleId"];
            this.sendAlertNotification = _data["sendAlertNotification"];
            this.notificationFrequency = _data["notificationFrequency"];
            if (Array.isArray(_data["notificationMethods"])) {
                this.notificationMethods = [] as any;
                for (let item of _data["notificationMethods"])
                    this.notificationMethods!.push(NotificationMethodCreateVM.fromJS(item));
            }
            this.thresholds = _data["thresholds"] ? MaintenanceThresholdsVM.fromJS(_data["thresholds"]) : new MaintenanceThresholdsVM();
            if (Array.isArray(_data["checklists"])) {
                this.checklists = [] as any;
                for (let item of _data["checklists"])
                    this.checklists!.push(MaintenanceChecklistUpsertVM.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MaintenanceReminderCreateVM {
        data = typeof data === 'object' ? data : {};
        let result = new MaintenanceReminderCreateVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["vehicleId"] = this.vehicleId;
        data["sendAlertNotification"] = this.sendAlertNotification;
        data["notificationFrequency"] = this.notificationFrequency;
        if (Array.isArray(this.notificationMethods)) {
            data["notificationMethods"] = [];
            for (let item of this.notificationMethods)
                data["notificationMethods"].push(item.toJSON());
        }
        data["thresholds"] = this.thresholds ? this.thresholds.toJSON() : <any>undefined;
        if (Array.isArray(this.checklists)) {
            data["checklists"] = [];
            for (let item of this.checklists)
                data["checklists"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMaintenanceReminderCreateVM {
    name: string;
    vehicleId: number;
    sendAlertNotification?: boolean;
    notificationFrequency?: number;
    notificationMethods: NotificationMethodCreateVM[];
    thresholds: MaintenanceThresholdsVM;
    checklists: MaintenanceChecklistUpsertVM[];
}

export class MaintenanceChecklistUpsertVM implements IMaintenanceChecklistUpsertVM {
    id?: number | undefined;
    serviceType!: string;
    lastServiceDate!: Date;
    mileageEnabled!: boolean;
    mileageInterval?: number | undefined;
    engineHoursEnabled!: boolean;
    engineHoursInterval?: number | undefined;
    serviceEnabled!: boolean;
    serviceInterval?: number | undefined;
    serviceIntervalUnit?: MaintenanceTimeIntervalUnit;

    constructor(data?: IMaintenanceChecklistUpsertVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.serviceType = _data["serviceType"];
            this.lastServiceDate = _data["lastServiceDate"] ? new Date(_data["lastServiceDate"].toString()) : <any>undefined;
            this.mileageEnabled = _data["mileageEnabled"];
            this.mileageInterval = _data["mileageInterval"];
            this.engineHoursEnabled = _data["engineHoursEnabled"];
            this.engineHoursInterval = _data["engineHoursInterval"];
            this.serviceEnabled = _data["serviceEnabled"];
            this.serviceInterval = _data["serviceInterval"];
            this.serviceIntervalUnit = _data["serviceIntervalUnit"];
        }
    }

    static fromJS(data: any): MaintenanceChecklistUpsertVM {
        data = typeof data === 'object' ? data : {};
        let result = new MaintenanceChecklistUpsertVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["serviceType"] = this.serviceType;
        data["lastServiceDate"] = this.lastServiceDate ? this.lastServiceDate.toISOString() : <any>undefined;
        data["mileageEnabled"] = this.mileageEnabled;
        data["mileageInterval"] = this.mileageInterval;
        data["engineHoursEnabled"] = this.engineHoursEnabled;
        data["engineHoursInterval"] = this.engineHoursInterval;
        data["serviceEnabled"] = this.serviceEnabled;
        data["serviceInterval"] = this.serviceInterval;
        data["serviceIntervalUnit"] = this.serviceIntervalUnit;
        return data;
    }
}

export interface IMaintenanceChecklistUpsertVM {
    id?: number | undefined;
    serviceType: string;
    lastServiceDate: Date;
    mileageEnabled: boolean;
    mileageInterval?: number | undefined;
    engineHoursEnabled: boolean;
    engineHoursInterval?: number | undefined;
    serviceEnabled: boolean;
    serviceInterval?: number | undefined;
    serviceIntervalUnit?: MaintenanceTimeIntervalUnit;
}

export class MaintenanceReminderUpdateVM implements IMaintenanceReminderUpdateVM {
    id!: number;
    name!: string;
    vehicleId!: number;
    sendAlertNotification?: boolean;
    notificationFrequency?: number;
    notificationMethods!: NotificationMethodCreateVM[];
    thresholds!: MaintenanceThresholdsVM;
    checklists!: MaintenanceChecklistUpsertVM[];

    constructor(data?: IMaintenanceReminderUpdateVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.notificationMethods = [];
            this.thresholds = new MaintenanceThresholdsVM();
            this.checklists = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.vehicleId = _data["vehicleId"];
            this.sendAlertNotification = _data["sendAlertNotification"];
            this.notificationFrequency = _data["notificationFrequency"];
            if (Array.isArray(_data["notificationMethods"])) {
                this.notificationMethods = [] as any;
                for (let item of _data["notificationMethods"])
                    this.notificationMethods!.push(NotificationMethodCreateVM.fromJS(item));
            }
            this.thresholds = _data["thresholds"] ? MaintenanceThresholdsVM.fromJS(_data["thresholds"]) : new MaintenanceThresholdsVM();
            if (Array.isArray(_data["checklists"])) {
                this.checklists = [] as any;
                for (let item of _data["checklists"])
                    this.checklists!.push(MaintenanceChecklistUpsertVM.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MaintenanceReminderUpdateVM {
        data = typeof data === 'object' ? data : {};
        let result = new MaintenanceReminderUpdateVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["vehicleId"] = this.vehicleId;
        data["sendAlertNotification"] = this.sendAlertNotification;
        data["notificationFrequency"] = this.notificationFrequency;
        if (Array.isArray(this.notificationMethods)) {
            data["notificationMethods"] = [];
            for (let item of this.notificationMethods)
                data["notificationMethods"].push(item.toJSON());
        }
        data["thresholds"] = this.thresholds ? this.thresholds.toJSON() : <any>undefined;
        if (Array.isArray(this.checklists)) {
            data["checklists"] = [];
            for (let item of this.checklists)
                data["checklists"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMaintenanceReminderUpdateVM {
    id: number;
    name: string;
    vehicleId: number;
    sendAlertNotification?: boolean;
    notificationFrequency?: number;
    notificationMethods: NotificationMethodCreateVM[];
    thresholds: MaintenanceThresholdsVM;
    checklists: MaintenanceChecklistUpsertVM[];
}

export class MaintenanceReminderNotificationSettingsVm implements IMaintenanceReminderNotificationSettingsVm {
    reminderId?: number;
    enabled?: boolean;

    constructor(data?: IMaintenanceReminderNotificationSettingsVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reminderId = _data["reminderId"];
            this.enabled = _data["enabled"];
        }
    }

    static fromJS(data: any): MaintenanceReminderNotificationSettingsVm {
        data = typeof data === 'object' ? data : {};
        let result = new MaintenanceReminderNotificationSettingsVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reminderId"] = this.reminderId;
        data["enabled"] = this.enabled;
        return data;
    }
}

export interface IMaintenanceReminderNotificationSettingsVm {
    reminderId?: number;
    enabled?: boolean;
}

export class FleetResponseOfMaintenanceServiceTypeVM extends BaseResponse implements IFleetResponseOfMaintenanceServiceTypeVM {
    data?: MaintenanceServiceTypeVM | undefined;

    constructor(data?: IFleetResponseOfMaintenanceServiceTypeVM) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? MaintenanceServiceTypeVM.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FleetResponseOfMaintenanceServiceTypeVM {
        data = typeof data === 'object' ? data : {};
        let result = new FleetResponseOfMaintenanceServiceTypeVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IFleetResponseOfMaintenanceServiceTypeVM extends IBaseResponse {
    data?: MaintenanceServiceTypeVM | undefined;
}

export class MaintenanceServiceTypeVM implements IMaintenanceServiceTypeVM {
    id?: number;
    name!: string;

    constructor(data?: IMaintenanceServiceTypeVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): MaintenanceServiceTypeVM {
        data = typeof data === 'object' ? data : {};
        let result = new MaintenanceServiceTypeVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IMaintenanceServiceTypeVM {
    id?: number;
    name: string;
}

export class FleetResponseOfEnvelopedModelOfPartnerUserVM extends BaseResponse implements IFleetResponseOfEnvelopedModelOfPartnerUserVM {
    data?: EnvelopedModelOfPartnerUserVM | undefined;

    constructor(data?: IFleetResponseOfEnvelopedModelOfPartnerUserVM) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? EnvelopedModelOfPartnerUserVM.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FleetResponseOfEnvelopedModelOfPartnerUserVM {
        data = typeof data === 'object' ? data : {};
        let result = new FleetResponseOfEnvelopedModelOfPartnerUserVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IFleetResponseOfEnvelopedModelOfPartnerUserVM extends IBaseResponse {
    data?: EnvelopedModelOfPartnerUserVM | undefined;
}

export class EnvelopedModelOfPartnerUserVM implements IEnvelopedModelOfPartnerUserVM {
    rows?: PartnerUserVM[];
    totalItems?: number;

    constructor(data?: IEnvelopedModelOfPartnerUserVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(PartnerUserVM.fromJS(item));
            }
            this.totalItems = _data["totalItems"];
        }
    }

    static fromJS(data: any): EnvelopedModelOfPartnerUserVM {
        data = typeof data === 'object' ? data : {};
        let result = new EnvelopedModelOfPartnerUserVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        data["totalItems"] = this.totalItems;
        return data;
    }
}

export interface IEnvelopedModelOfPartnerUserVM {
    rows?: PartnerUserVM[];
    totalItems?: number;
}

export class PartnerUserVM implements IPartnerUserVM {
    id?: number;
    proxyUserId?: string;
    name?: string | undefined;
    email?: string | undefined;

    constructor(data?: IPartnerUserVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.proxyUserId = _data["proxyUserId"];
            this.name = _data["name"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): PartnerUserVM {
        data = typeof data === 'object' ? data : {};
        let result = new PartnerUserVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["proxyUserId"] = this.proxyUserId;
        data["name"] = this.name;
        data["email"] = this.email;
        return data;
    }
}

export interface IPartnerUserVM {
    id?: number;
    proxyUserId?: string;
    name?: string | undefined;
    email?: string | undefined;
}

export class FleetResponseOfTenantStatusVM extends BaseResponse implements IFleetResponseOfTenantStatusVM {
    data?: TenantStatusVM | undefined;

    constructor(data?: IFleetResponseOfTenantStatusVM) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? TenantStatusVM.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FleetResponseOfTenantStatusVM {
        data = typeof data === 'object' ? data : {};
        let result = new FleetResponseOfTenantStatusVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IFleetResponseOfTenantStatusVM extends IBaseResponse {
    data?: TenantStatusVM | undefined;
}

export class TenantStatusVM implements ITenantStatusVM {
    partnerId!: string;
    tenantId!: string;
    partitionId!: string;
    isTenantRegistered!: boolean;
    isDataValidationCompleted!: boolean;
    isOnboardingCompleted!: boolean;

    constructor(data?: ITenantStatusVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.partnerId = _data["partnerId"];
            this.tenantId = _data["tenantId"];
            this.partitionId = _data["partitionId"];
            this.isTenantRegistered = _data["isTenantRegistered"];
            this.isDataValidationCompleted = _data["isDataValidationCompleted"];
            this.isOnboardingCompleted = _data["isOnboardingCompleted"];
        }
    }

    static fromJS(data: any): TenantStatusVM {
        data = typeof data === 'object' ? data : {};
        let result = new TenantStatusVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["partnerId"] = this.partnerId;
        data["tenantId"] = this.tenantId;
        data["partitionId"] = this.partitionId;
        data["isTenantRegistered"] = this.isTenantRegistered;
        data["isDataValidationCompleted"] = this.isDataValidationCompleted;
        data["isOnboardingCompleted"] = this.isOnboardingCompleted;
        return data;
    }
}

export interface ITenantStatusVM {
    partnerId: string;
    tenantId: string;
    partitionId: string;
    isTenantRegistered: boolean;
    isDataValidationCompleted: boolean;
    isOnboardingCompleted: boolean;
}

export class FleetResponseOfEnvelopedModelOfDriverScoreVm extends BaseResponse implements IFleetResponseOfEnvelopedModelOfDriverScoreVm {
    data?: EnvelopedModelOfDriverScoreVm | undefined;

    constructor(data?: IFleetResponseOfEnvelopedModelOfDriverScoreVm) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? EnvelopedModelOfDriverScoreVm.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FleetResponseOfEnvelopedModelOfDriverScoreVm {
        data = typeof data === 'object' ? data : {};
        let result = new FleetResponseOfEnvelopedModelOfDriverScoreVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IFleetResponseOfEnvelopedModelOfDriverScoreVm extends IBaseResponse {
    data?: EnvelopedModelOfDriverScoreVm | undefined;
}

export class EnvelopedModelOfDriverScoreVm implements IEnvelopedModelOfDriverScoreVm {
    rows?: DriverScoreVm[];
    totalItems?: number;

    constructor(data?: IEnvelopedModelOfDriverScoreVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(DriverScoreVm.fromJS(item));
            }
            this.totalItems = _data["totalItems"];
        }
    }

    static fromJS(data: any): EnvelopedModelOfDriverScoreVm {
        data = typeof data === 'object' ? data : {};
        let result = new EnvelopedModelOfDriverScoreVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        data["totalItems"] = this.totalItems;
        return data;
    }
}

export interface IEnvelopedModelOfDriverScoreVm {
    rows?: DriverScoreVm[];
    totalItems?: number;
}

export class DriverScoreVm implements IDriverScoreVm {
    distanceTravelled?: number | undefined;
    driveTime?: number | undefined;
    idleTime?: number | undefined;
    idlingScore?: number | undefined;
    idlingEventCount?: number | undefined;
    brakingScore?: number | undefined;
    hardBrakingCount?: number | undefined;
    hardCoreBrakingCount?: number | undefined;
    corneringScore?: number | undefined;
    corneringEventCount?: number | undefined;
    accelerationScore?: number | undefined;
    hardAccelerationCount?: number | undefined;
    speedingScore?: number | undefined;
    overSpeedingCount?: number | undefined;
    pslEventCount?: number | undefined;
    distractedDrivingScore?: number | undefined;
    distractedDrivingCount?: number | undefined;
    seatBeltScore?: number | undefined;
    driverSeatBeltPercentage?: number | undefined;
    score?: number | undefined;
    fullName!: string;
    vehicleNames?: string | undefined;
    groupNames?: string | undefined;

    constructor(data?: IDriverScoreVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.distanceTravelled = _data["distanceTravelled"];
            this.driveTime = _data["driveTime"];
            this.idleTime = _data["idleTime"];
            this.idlingScore = _data["idlingScore"];
            this.idlingEventCount = _data["idlingEventCount"];
            this.brakingScore = _data["brakingScore"];
            this.hardBrakingCount = _data["hardBrakingCount"];
            this.hardCoreBrakingCount = _data["hardCoreBrakingCount"];
            this.corneringScore = _data["corneringScore"];
            this.corneringEventCount = _data["corneringEventCount"];
            this.accelerationScore = _data["accelerationScore"];
            this.hardAccelerationCount = _data["hardAccelerationCount"];
            this.speedingScore = _data["speedingScore"];
            this.overSpeedingCount = _data["overSpeedingCount"];
            this.pslEventCount = _data["pslEventCount"];
            this.distractedDrivingScore = _data["distractedDrivingScore"];
            this.distractedDrivingCount = _data["distractedDrivingCount"];
            this.seatBeltScore = _data["seatBeltScore"];
            this.driverSeatBeltPercentage = _data["driverSeatBeltPercentage"];
            this.score = _data["score"];
            this.fullName = _data["fullName"];
            this.vehicleNames = _data["vehicleNames"];
            this.groupNames = _data["groupNames"];
        }
    }

    static fromJS(data: any): DriverScoreVm {
        data = typeof data === 'object' ? data : {};
        let result = new DriverScoreVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["distanceTravelled"] = this.distanceTravelled;
        data["driveTime"] = this.driveTime;
        data["idleTime"] = this.idleTime;
        data["idlingScore"] = this.idlingScore;
        data["idlingEventCount"] = this.idlingEventCount;
        data["brakingScore"] = this.brakingScore;
        data["hardBrakingCount"] = this.hardBrakingCount;
        data["hardCoreBrakingCount"] = this.hardCoreBrakingCount;
        data["corneringScore"] = this.corneringScore;
        data["corneringEventCount"] = this.corneringEventCount;
        data["accelerationScore"] = this.accelerationScore;
        data["hardAccelerationCount"] = this.hardAccelerationCount;
        data["speedingScore"] = this.speedingScore;
        data["overSpeedingCount"] = this.overSpeedingCount;
        data["pslEventCount"] = this.pslEventCount;
        data["distractedDrivingScore"] = this.distractedDrivingScore;
        data["distractedDrivingCount"] = this.distractedDrivingCount;
        data["seatBeltScore"] = this.seatBeltScore;
        data["driverSeatBeltPercentage"] = this.driverSeatBeltPercentage;
        data["score"] = this.score;
        data["fullName"] = this.fullName;
        data["vehicleNames"] = this.vehicleNames;
        data["groupNames"] = this.groupNames;
        return data;
    }
}

export interface IDriverScoreVm {
    distanceTravelled?: number | undefined;
    driveTime?: number | undefined;
    idleTime?: number | undefined;
    idlingScore?: number | undefined;
    idlingEventCount?: number | undefined;
    brakingScore?: number | undefined;
    hardBrakingCount?: number | undefined;
    hardCoreBrakingCount?: number | undefined;
    corneringScore?: number | undefined;
    corneringEventCount?: number | undefined;
    accelerationScore?: number | undefined;
    hardAccelerationCount?: number | undefined;
    speedingScore?: number | undefined;
    overSpeedingCount?: number | undefined;
    pslEventCount?: number | undefined;
    distractedDrivingScore?: number | undefined;
    distractedDrivingCount?: number | undefined;
    seatBeltScore?: number | undefined;
    driverSeatBeltPercentage?: number | undefined;
    score?: number | undefined;
    fullName: string;
    vehicleNames?: string | undefined;
    groupNames?: string | undefined;
}

export class DriversScoresRequestVM implements IDriversScoresRequestVM {
    driverIds!: number[];
    startTime!: Date;
    endTime!: Date;
    timezone!: string;

    constructor(data?: IDriversScoresRequestVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.driverIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["driverIds"])) {
                this.driverIds = [] as any;
                for (let item of _data["driverIds"])
                    this.driverIds!.push(item);
            }
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? new Date(_data["endTime"].toString()) : <any>undefined;
            this.timezone = _data["timezone"];
        }
    }

    static fromJS(data: any): DriversScoresRequestVM {
        data = typeof data === 'object' ? data : {};
        let result = new DriversScoresRequestVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.driverIds)) {
            data["driverIds"] = [];
            for (let item of this.driverIds)
                data["driverIds"].push(item);
        }
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["timezone"] = this.timezone;
        return data;
    }
}

export interface IDriversScoresRequestVM {
    driverIds: number[];
    startTime: Date;
    endTime: Date;
    timezone: string;
}

export class FleetResponseOfDriverScoreVm extends BaseResponse implements IFleetResponseOfDriverScoreVm {
    data?: DriverScoreVm | undefined;

    constructor(data?: IFleetResponseOfDriverScoreVm) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? DriverScoreVm.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FleetResponseOfDriverScoreVm {
        data = typeof data === 'object' ? data : {};
        let result = new FleetResponseOfDriverScoreVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IFleetResponseOfDriverScoreVm extends IBaseResponse {
    data?: DriverScoreVm | undefined;
}

export class DriverScoreRequestVM implements IDriverScoreRequestVM {
    integrationDriverId?: string | undefined;
    startDate?: Date;
    endDate?: Date;
    timezone!: string;

    constructor(data?: IDriverScoreRequestVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.integrationDriverId = _data["integrationDriverId"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.timezone = _data["timezone"];
        }
    }

    static fromJS(data: any): DriverScoreRequestVM {
        data = typeof data === 'object' ? data : {};
        let result = new DriverScoreRequestVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["integrationDriverId"] = this.integrationDriverId;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["timezone"] = this.timezone;
        return data;
    }
}

export interface IDriverScoreRequestVM {
    integrationDriverId?: string | undefined;
    startDate?: Date;
    endDate?: Date;
    timezone: string;
}

export class FleetResponseOfEnvelopedModelOfTripReportVm extends BaseResponse implements IFleetResponseOfEnvelopedModelOfTripReportVm {
    data?: EnvelopedModelOfTripReportVm | undefined;

    constructor(data?: IFleetResponseOfEnvelopedModelOfTripReportVm) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? EnvelopedModelOfTripReportVm.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FleetResponseOfEnvelopedModelOfTripReportVm {
        data = typeof data === 'object' ? data : {};
        let result = new FleetResponseOfEnvelopedModelOfTripReportVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IFleetResponseOfEnvelopedModelOfTripReportVm extends IBaseResponse {
    data?: EnvelopedModelOfTripReportVm | undefined;
}

export class EnvelopedModelOfTripReportVm implements IEnvelopedModelOfTripReportVm {
    rows?: TripReportVm[];
    totalItems?: number;

    constructor(data?: IEnvelopedModelOfTripReportVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(TripReportVm.fromJS(item));
            }
            this.totalItems = _data["totalItems"];
        }
    }

    static fromJS(data: any): EnvelopedModelOfTripReportVm {
        data = typeof data === 'object' ? data : {};
        let result = new EnvelopedModelOfTripReportVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        data["totalItems"] = this.totalItems;
        return data;
    }
}

export interface IEnvelopedModelOfTripReportVm {
    rows?: TripReportVm[];
    totalItems?: number;
}

export class TripReportVm implements ITripReportVm {
    trackedResourceName!: string;
    groupName?: string | undefined;
    vin?: string | undefined;
    tripStartTime!: Date;
    tripEndTime?: Date | undefined;
    tripStartAddress?: string | undefined;
    tripEndAddress?: string | undefined;
    tripTime?: number | undefined;
    stopTime?: number | undefined;
    idleTime?: number | undefined;
    idleTimePercentage?: number | undefined;
    tripDistance?: number | undefined;
    tripCost?: number | undefined;
    maxSpeed?: number | undefined;
    averageSpeed?: number | undefined;
    overSpeedingCount?: number | undefined;
    overSpeedDuration?: number | undefined;
    postedSpeedingCount?: number | undefined;
    postedSpeedingDuration?: number | undefined;
    hardBreakingCount?: number | undefined;
    hardcoreBrakingCount?: number | undefined;
    hardAccelerationCount?: number | undefined;
    corneringEventCount?: number | undefined;
    driverSeatBeltPercentage?: number | undefined;

    constructor(data?: ITripReportVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.trackedResourceName = _data["trackedResourceName"];
            this.groupName = _data["groupName"];
            this.vin = _data["vin"];
            this.tripStartTime = _data["tripStartTime"] ? new Date(_data["tripStartTime"].toString()) : <any>undefined;
            this.tripEndTime = _data["tripEndTime"] ? new Date(_data["tripEndTime"].toString()) : <any>undefined;
            this.tripStartAddress = _data["tripStartAddress"];
            this.tripEndAddress = _data["tripEndAddress"];
            this.tripTime = _data["tripTime"];
            this.stopTime = _data["stopTime"];
            this.idleTime = _data["idleTime"];
            this.idleTimePercentage = _data["idleTimePercentage"];
            this.tripDistance = _data["tripDistance"];
            this.tripCost = _data["tripCost"];
            this.maxSpeed = _data["maxSpeed"];
            this.averageSpeed = _data["averageSpeed"];
            this.overSpeedingCount = _data["overSpeedingCount"];
            this.overSpeedDuration = _data["overSpeedDuration"];
            this.postedSpeedingCount = _data["postedSpeedingCount"];
            this.postedSpeedingDuration = _data["postedSpeedingDuration"];
            this.hardBreakingCount = _data["hardBreakingCount"];
            this.hardcoreBrakingCount = _data["hardcoreBrakingCount"];
            this.hardAccelerationCount = _data["hardAccelerationCount"];
            this.corneringEventCount = _data["corneringEventCount"];
            this.driverSeatBeltPercentage = _data["driverSeatBeltPercentage"];
        }
    }

    static fromJS(data: any): TripReportVm {
        data = typeof data === 'object' ? data : {};
        let result = new TripReportVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["trackedResourceName"] = this.trackedResourceName;
        data["groupName"] = this.groupName;
        data["vin"] = this.vin;
        data["tripStartTime"] = this.tripStartTime ? this.tripStartTime.toISOString() : <any>undefined;
        data["tripEndTime"] = this.tripEndTime ? this.tripEndTime.toISOString() : <any>undefined;
        data["tripStartAddress"] = this.tripStartAddress;
        data["tripEndAddress"] = this.tripEndAddress;
        data["tripTime"] = this.tripTime;
        data["stopTime"] = this.stopTime;
        data["idleTime"] = this.idleTime;
        data["idleTimePercentage"] = this.idleTimePercentage;
        data["tripDistance"] = this.tripDistance;
        data["tripCost"] = this.tripCost;
        data["maxSpeed"] = this.maxSpeed;
        data["averageSpeed"] = this.averageSpeed;
        data["overSpeedingCount"] = this.overSpeedingCount;
        data["overSpeedDuration"] = this.overSpeedDuration;
        data["postedSpeedingCount"] = this.postedSpeedingCount;
        data["postedSpeedingDuration"] = this.postedSpeedingDuration;
        data["hardBreakingCount"] = this.hardBreakingCount;
        data["hardcoreBrakingCount"] = this.hardcoreBrakingCount;
        data["hardAccelerationCount"] = this.hardAccelerationCount;
        data["corneringEventCount"] = this.corneringEventCount;
        data["driverSeatBeltPercentage"] = this.driverSeatBeltPercentage;
        return data;
    }
}

export interface ITripReportVm {
    trackedResourceName: string;
    groupName?: string | undefined;
    vin?: string | undefined;
    tripStartTime: Date;
    tripEndTime?: Date | undefined;
    tripStartAddress?: string | undefined;
    tripEndAddress?: string | undefined;
    tripTime?: number | undefined;
    stopTime?: number | undefined;
    idleTime?: number | undefined;
    idleTimePercentage?: number | undefined;
    tripDistance?: number | undefined;
    tripCost?: number | undefined;
    maxSpeed?: number | undefined;
    averageSpeed?: number | undefined;
    overSpeedingCount?: number | undefined;
    overSpeedDuration?: number | undefined;
    postedSpeedingCount?: number | undefined;
    postedSpeedingDuration?: number | undefined;
    hardBreakingCount?: number | undefined;
    hardcoreBrakingCount?: number | undefined;
    hardAccelerationCount?: number | undefined;
    corneringEventCount?: number | undefined;
    driverSeatBeltPercentage?: number | undefined;
}

export class TripsReportRequestVm implements ITripsReportRequestVm {
    trackedResourceIds!: number[];
    startTime!: Date;
    endTime!: Date;
    reportType!: TripReportType;
    reportAggregationType?: TripReportAggregationType;
    timezone!: string;

    constructor(data?: ITripsReportRequestVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.trackedResourceIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["trackedResourceIds"])) {
                this.trackedResourceIds = [] as any;
                for (let item of _data["trackedResourceIds"])
                    this.trackedResourceIds!.push(item);
            }
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? new Date(_data["endTime"].toString()) : <any>undefined;
            this.reportType = _data["reportType"];
            this.reportAggregationType = _data["reportAggregationType"];
            this.timezone = _data["timezone"];
        }
    }

    static fromJS(data: any): TripsReportRequestVm {
        data = typeof data === 'object' ? data : {};
        let result = new TripsReportRequestVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.trackedResourceIds)) {
            data["trackedResourceIds"] = [];
            for (let item of this.trackedResourceIds)
                data["trackedResourceIds"].push(item);
        }
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["reportType"] = this.reportType;
        data["reportAggregationType"] = this.reportAggregationType;
        data["timezone"] = this.timezone;
        return data;
    }
}

export interface ITripsReportRequestVm {
    trackedResourceIds: number[];
    startTime: Date;
    endTime: Date;
    reportType: TripReportType;
    reportAggregationType?: TripReportAggregationType;
    timezone: string;
}

export enum TripReportType {
    AllTrips = 1,
    AggregatedTrips = 2,
}

export enum TripReportAggregationType {
    Daily = 1,
}

export class FleetResponseOfEnvelopedModelOfDtcReportVm extends BaseResponse implements IFleetResponseOfEnvelopedModelOfDtcReportVm {
    data?: EnvelopedModelOfDtcReportVm | undefined;

    constructor(data?: IFleetResponseOfEnvelopedModelOfDtcReportVm) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? EnvelopedModelOfDtcReportVm.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FleetResponseOfEnvelopedModelOfDtcReportVm {
        data = typeof data === 'object' ? data : {};
        let result = new FleetResponseOfEnvelopedModelOfDtcReportVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IFleetResponseOfEnvelopedModelOfDtcReportVm extends IBaseResponse {
    data?: EnvelopedModelOfDtcReportVm | undefined;
}

export class EnvelopedModelOfDtcReportVm implements IEnvelopedModelOfDtcReportVm {
    rows?: DtcReportVm[];
    totalItems?: number;

    constructor(data?: IEnvelopedModelOfDtcReportVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(DtcReportVm.fromJS(item));
            }
            this.totalItems = _data["totalItems"];
        }
    }

    static fromJS(data: any): EnvelopedModelOfDtcReportVm {
        data = typeof data === 'object' ? data : {};
        let result = new EnvelopedModelOfDtcReportVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        data["totalItems"] = this.totalItems;
        return data;
    }
}

export interface IEnvelopedModelOfDtcReportVm {
    rows?: DtcReportVm[];
    totalItems?: number;
}

export class DtcReportVm implements IDtcReportVm {
    vehicleName!: string;
    eventDate!: Date;
    address?: string | undefined;
    groupName?: string | undefined;
    obdCode!: string;
    obdDescription?: string | undefined;
    spnCode?: string | undefined;
    spnDescription?: string | undefined;
    fmiCode?: string | undefined;
    fmiDescription?: string | undefined;

    constructor(data?: IDtcReportVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vehicleName = _data["vehicleName"];
            this.eventDate = _data["eventDate"] ? new Date(_data["eventDate"].toString()) : <any>undefined;
            this.address = _data["address"];
            this.groupName = _data["groupName"];
            this.obdCode = _data["obdCode"];
            this.obdDescription = _data["obdDescription"];
            this.spnCode = _data["spnCode"];
            this.spnDescription = _data["spnDescription"];
            this.fmiCode = _data["fmiCode"];
            this.fmiDescription = _data["fmiDescription"];
        }
    }

    static fromJS(data: any): DtcReportVm {
        data = typeof data === 'object' ? data : {};
        let result = new DtcReportVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vehicleName"] = this.vehicleName;
        data["eventDate"] = this.eventDate ? this.eventDate.toISOString() : <any>undefined;
        data["address"] = this.address;
        data["groupName"] = this.groupName;
        data["obdCode"] = this.obdCode;
        data["obdDescription"] = this.obdDescription;
        data["spnCode"] = this.spnCode;
        data["spnDescription"] = this.spnDescription;
        data["fmiCode"] = this.fmiCode;
        data["fmiDescription"] = this.fmiDescription;
        return data;
    }
}

export interface IDtcReportVm {
    vehicleName: string;
    eventDate: Date;
    address?: string | undefined;
    groupName?: string | undefined;
    obdCode: string;
    obdDescription?: string | undefined;
    spnCode?: string | undefined;
    spnDescription?: string | undefined;
    fmiCode?: string | undefined;
    fmiDescription?: string | undefined;
}

export class DtcReportRequestVm implements IDtcReportRequestVm {
    vehicleIds!: number[];
    startTime!: Date;
    endTime!: Date;
    timezone!: string;

    constructor(data?: IDtcReportRequestVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.vehicleIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["vehicleIds"])) {
                this.vehicleIds = [] as any;
                for (let item of _data["vehicleIds"])
                    this.vehicleIds!.push(item);
            }
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? new Date(_data["endTime"].toString()) : <any>undefined;
            this.timezone = _data["timezone"];
        }
    }

    static fromJS(data: any): DtcReportRequestVm {
        data = typeof data === 'object' ? data : {};
        let result = new DtcReportRequestVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.vehicleIds)) {
            data["vehicleIds"] = [];
            for (let item of this.vehicleIds)
                data["vehicleIds"].push(item);
        }
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["timezone"] = this.timezone;
        return data;
    }
}

export interface IDtcReportRequestVm {
    vehicleIds: number[];
    startTime: Date;
    endTime: Date;
    timezone: string;
}

export class FleetResponseOfDtcCodeDetailsVM extends BaseResponse implements IFleetResponseOfDtcCodeDetailsVM {
    data?: DtcCodeDetailsVM | undefined;

    constructor(data?: IFleetResponseOfDtcCodeDetailsVM) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? DtcCodeDetailsVM.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FleetResponseOfDtcCodeDetailsVM {
        data = typeof data === 'object' ? data : {};
        let result = new FleetResponseOfDtcCodeDetailsVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IFleetResponseOfDtcCodeDetailsVM extends IBaseResponse {
    data?: DtcCodeDetailsVM | undefined;
}

export class DtcCodeDetailsVM implements IDtcCodeDetailsVM {
    code!: string;
    description?: string | undefined;
    detailedDescription?: string | undefined;
    causes?: string | undefined;
    occurrence?: string | undefined;
    symptoms?: string | undefined;
    repairImportance?: string | undefined;
    repairDifficulty?: string | undefined;

    constructor(data?: IDtcCodeDetailsVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.description = _data["description"];
            this.detailedDescription = _data["detailedDescription"];
            this.causes = _data["causes"];
            this.occurrence = _data["occurrence"];
            this.symptoms = _data["symptoms"];
            this.repairImportance = _data["repairImportance"];
            this.repairDifficulty = _data["repairDifficulty"];
        }
    }

    static fromJS(data: any): DtcCodeDetailsVM {
        data = typeof data === 'object' ? data : {};
        let result = new DtcCodeDetailsVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["description"] = this.description;
        data["detailedDescription"] = this.detailedDescription;
        data["causes"] = this.causes;
        data["occurrence"] = this.occurrence;
        data["symptoms"] = this.symptoms;
        data["repairImportance"] = this.repairImportance;
        data["repairDifficulty"] = this.repairDifficulty;
        return data;
    }
}

export interface IDtcCodeDetailsVM {
    code: string;
    description?: string | undefined;
    detailedDescription?: string | undefined;
    causes?: string | undefined;
    occurrence?: string | undefined;
    symptoms?: string | undefined;
    repairImportance?: string | undefined;
    repairDifficulty?: string | undefined;
}

export class FleetResponseOfEnvelopedModelOfStateMileageReportVm extends BaseResponse implements IFleetResponseOfEnvelopedModelOfStateMileageReportVm {
    data?: EnvelopedModelOfStateMileageReportVm | undefined;

    constructor(data?: IFleetResponseOfEnvelopedModelOfStateMileageReportVm) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? EnvelopedModelOfStateMileageReportVm.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FleetResponseOfEnvelopedModelOfStateMileageReportVm {
        data = typeof data === 'object' ? data : {};
        let result = new FleetResponseOfEnvelopedModelOfStateMileageReportVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IFleetResponseOfEnvelopedModelOfStateMileageReportVm extends IBaseResponse {
    data?: EnvelopedModelOfStateMileageReportVm | undefined;
}

export class EnvelopedModelOfStateMileageReportVm implements IEnvelopedModelOfStateMileageReportVm {
    rows?: StateMileageReportVm[];
    totalItems?: number;

    constructor(data?: IEnvelopedModelOfStateMileageReportVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(StateMileageReportVm.fromJS(item));
            }
            this.totalItems = _data["totalItems"];
        }
    }

    static fromJS(data: any): EnvelopedModelOfStateMileageReportVm {
        data = typeof data === 'object' ? data : {};
        let result = new EnvelopedModelOfStateMileageReportVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        data["totalItems"] = this.totalItems;
        return data;
    }
}

export interface IEnvelopedModelOfStateMileageReportVm {
    rows?: StateMileageReportVm[];
    totalItems?: number;
}

export class StateMileageReportVm implements IStateMileageReportVm {
    trackedResourceName!: string;
    groupName?: string | undefined;
    state!: string;
    country?: string | undefined;
    travelledDistance?: number | undefined;
    travelDuration?: number | undefined;

    constructor(data?: IStateMileageReportVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.trackedResourceName = _data["trackedResourceName"];
            this.groupName = _data["groupName"];
            this.state = _data["state"];
            this.country = _data["country"];
            this.travelledDistance = _data["travelledDistance"];
            this.travelDuration = _data["travelDuration"];
        }
    }

    static fromJS(data: any): StateMileageReportVm {
        data = typeof data === 'object' ? data : {};
        let result = new StateMileageReportVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["trackedResourceName"] = this.trackedResourceName;
        data["groupName"] = this.groupName;
        data["state"] = this.state;
        data["country"] = this.country;
        data["travelledDistance"] = this.travelledDistance;
        data["travelDuration"] = this.travelDuration;
        return data;
    }
}

export interface IStateMileageReportVm {
    trackedResourceName: string;
    groupName?: string | undefined;
    state: string;
    country?: string | undefined;
    travelledDistance?: number | undefined;
    travelDuration?: number | undefined;
}

export class StateMileageReportRequestVm implements IStateMileageReportRequestVm {
    trackedResourceIds!: number[];
    startTime!: Date;
    endTime!: Date;
    timezone!: string;

    constructor(data?: IStateMileageReportRequestVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.trackedResourceIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["trackedResourceIds"])) {
                this.trackedResourceIds = [] as any;
                for (let item of _data["trackedResourceIds"])
                    this.trackedResourceIds!.push(item);
            }
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? new Date(_data["endTime"].toString()) : <any>undefined;
            this.timezone = _data["timezone"];
        }
    }

    static fromJS(data: any): StateMileageReportRequestVm {
        data = typeof data === 'object' ? data : {};
        let result = new StateMileageReportRequestVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.trackedResourceIds)) {
            data["trackedResourceIds"] = [];
            for (let item of this.trackedResourceIds)
                data["trackedResourceIds"].push(item);
        }
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["timezone"] = this.timezone;
        return data;
    }
}

export interface IStateMileageReportRequestVm {
    trackedResourceIds: number[];
    startTime: Date;
    endTime: Date;
    timezone: string;
}

export class FleetResponseOfEnvelopedModelOfTrackedResourceLightVM extends BaseResponse implements IFleetResponseOfEnvelopedModelOfTrackedResourceLightVM {
    data?: EnvelopedModelOfTrackedResourceLightVM | undefined;

    constructor(data?: IFleetResponseOfEnvelopedModelOfTrackedResourceLightVM) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? EnvelopedModelOfTrackedResourceLightVM.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FleetResponseOfEnvelopedModelOfTrackedResourceLightVM {
        data = typeof data === 'object' ? data : {};
        let result = new FleetResponseOfEnvelopedModelOfTrackedResourceLightVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IFleetResponseOfEnvelopedModelOfTrackedResourceLightVM extends IBaseResponse {
    data?: EnvelopedModelOfTrackedResourceLightVM | undefined;
}

export class EnvelopedModelOfTrackedResourceLightVM implements IEnvelopedModelOfTrackedResourceLightVM {
    rows?: TrackedResourceLightVM[];
    totalItems?: number;

    constructor(data?: IEnvelopedModelOfTrackedResourceLightVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(TrackedResourceLightVM.fromJS(item));
            }
            this.totalItems = _data["totalItems"];
        }
    }

    static fromJS(data: any): EnvelopedModelOfTrackedResourceLightVM {
        data = typeof data === 'object' ? data : {};
        let result = new EnvelopedModelOfTrackedResourceLightVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        data["totalItems"] = this.totalItems;
        return data;
    }
}

export interface IEnvelopedModelOfTrackedResourceLightVM {
    rows?: TrackedResourceLightVM[];
    totalItems?: number;
}

export class TrackedResourceLightVM implements ITrackedResourceLightVM {
    id!: number;
    name!: string;
    type!: TrackedResourceType;
    groupName!: string;
    driverName?: string | undefined;

    constructor(data?: ITrackedResourceLightVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.type = _data["type"];
            this.groupName = _data["groupName"];
            this.driverName = _data["driverName"];
        }
    }

    static fromJS(data: any): TrackedResourceLightVM {
        data = typeof data === 'object' ? data : {};
        let result = new TrackedResourceLightVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["type"] = this.type;
        data["groupName"] = this.groupName;
        data["driverName"] = this.driverName;
        return data;
    }
}

export interface ITrackedResourceLightVM {
    id: number;
    name: string;
    type: TrackedResourceType;
    groupName: string;
    driverName?: string | undefined;
}

export class FleetResponseOfEnvelopedModelOfTruckVM extends BaseResponse implements IFleetResponseOfEnvelopedModelOfTruckVM {
    data?: EnvelopedModelOfTruckVM | undefined;

    constructor(data?: IFleetResponseOfEnvelopedModelOfTruckVM) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? EnvelopedModelOfTruckVM.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FleetResponseOfEnvelopedModelOfTruckVM {
        data = typeof data === 'object' ? data : {};
        let result = new FleetResponseOfEnvelopedModelOfTruckVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IFleetResponseOfEnvelopedModelOfTruckVM extends IBaseResponse {
    data?: EnvelopedModelOfTruckVM | undefined;
}

export class EnvelopedModelOfTruckVM implements IEnvelopedModelOfTruckVM {
    rows?: TruckVM[];
    totalItems?: number;

    constructor(data?: IEnvelopedModelOfTruckVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(TruckVM.fromJS(item));
            }
            this.totalItems = _data["totalItems"];
        }
    }

    static fromJS(data: any): EnvelopedModelOfTruckVM {
        data = typeof data === 'object' ? data : {};
        let result = new EnvelopedModelOfTruckVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        data["totalItems"] = this.totalItems;
        return data;
    }
}

export interface IEnvelopedModelOfTruckVM {
    rows?: TruckVM[];
    totalItems?: number;
}

export class TruckVM implements ITruckVM {
    id?: number;
    name?: string | undefined;
    vin?: string | undefined;
    deviceNumber?: string | undefined;

    constructor(data?: ITruckVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.vin = _data["vin"];
            this.deviceNumber = _data["deviceNumber"];
        }
    }

    static fromJS(data: any): TruckVM {
        data = typeof data === 'object' ? data : {};
        let result = new TruckVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["vin"] = this.vin;
        data["deviceNumber"] = this.deviceNumber;
        return data;
    }
}

export interface ITruckVM {
    id?: number;
    name?: string | undefined;
    vin?: string | undefined;
    deviceNumber?: string | undefined;
}

export class FleetResponseOfPaginatedModelOfVehicleLightVM extends BaseResponse implements IFleetResponseOfPaginatedModelOfVehicleLightVM {
    data?: PaginatedModelOfVehicleLightVM | undefined;

    constructor(data?: IFleetResponseOfPaginatedModelOfVehicleLightVM) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? PaginatedModelOfVehicleLightVM.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FleetResponseOfPaginatedModelOfVehicleLightVM {
        data = typeof data === 'object' ? data : {};
        let result = new FleetResponseOfPaginatedModelOfVehicleLightVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IFleetResponseOfPaginatedModelOfVehicleLightVM extends IBaseResponse {
    data?: PaginatedModelOfVehicleLightVM | undefined;
}

export class PaginatedModelOfVehicleLightVM implements IPaginatedModelOfVehicleLightVM {
    page!: number;
    totalPages!: number;
    totalItems!: number;
    maxItemCountReached!: boolean;
    maxItemCount!: number;
    rows!: VehicleLightVM[];

    constructor(data?: IPaginatedModelOfVehicleLightVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.rows = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.page = _data["page"];
            this.totalPages = _data["totalPages"];
            this.totalItems = _data["totalItems"];
            this.maxItemCountReached = _data["maxItemCountReached"];
            this.maxItemCount = _data["maxItemCount"];
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(VehicleLightVM.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedModelOfVehicleLightVM {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedModelOfVehicleLightVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["page"] = this.page;
        data["totalPages"] = this.totalPages;
        data["totalItems"] = this.totalItems;
        data["maxItemCountReached"] = this.maxItemCountReached;
        data["maxItemCount"] = this.maxItemCount;
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPaginatedModelOfVehicleLightVM {
    page: number;
    totalPages: number;
    totalItems: number;
    maxItemCountReached: boolean;
    maxItemCount: number;
    rows: VehicleLightVM[];
}

export class VehicleLightVM implements IVehicleLightVM {
    id?: number;
    vehicleId?: string | undefined;
    vehicleName?: string | undefined;
    deviceSerialNumber?: string | undefined;
    cameraDeviceSerialNumber?: string | undefined;
    group?: string | undefined;
    make?: string | undefined;
    model?: string | undefined;
    year?: number | undefined;
    driver?: string | undefined;
    vin?: string | undefined;
    odometer?: number | undefined;
    status?: string | undefined;
    statusMessages?: string[] | undefined;
    latestLocationTime?: Date | undefined;
    createdOn?: Date;
    modifiedOn?: Date;

    constructor(data?: IVehicleLightVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.vehicleId = _data["vehicleId"];
            this.vehicleName = _data["vehicleName"];
            this.deviceSerialNumber = _data["deviceSerialNumber"];
            this.cameraDeviceSerialNumber = _data["cameraDeviceSerialNumber"];
            this.group = _data["group"];
            this.make = _data["make"];
            this.model = _data["model"];
            this.year = _data["year"];
            this.driver = _data["driver"];
            this.vin = _data["vin"];
            this.odometer = _data["odometer"];
            this.status = _data["status"];
            if (Array.isArray(_data["statusMessages"])) {
                this.statusMessages = [] as any;
                for (let item of _data["statusMessages"])
                    this.statusMessages!.push(item);
            }
            this.latestLocationTime = _data["latestLocationTime"] ? new Date(_data["latestLocationTime"].toString()) : <any>undefined;
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.modifiedOn = _data["modifiedOn"] ? new Date(_data["modifiedOn"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): VehicleLightVM {
        data = typeof data === 'object' ? data : {};
        let result = new VehicleLightVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["vehicleId"] = this.vehicleId;
        data["vehicleName"] = this.vehicleName;
        data["deviceSerialNumber"] = this.deviceSerialNumber;
        data["cameraDeviceSerialNumber"] = this.cameraDeviceSerialNumber;
        data["group"] = this.group;
        data["make"] = this.make;
        data["model"] = this.model;
        data["year"] = this.year;
        data["driver"] = this.driver;
        data["vin"] = this.vin;
        data["odometer"] = this.odometer;
        data["status"] = this.status;
        if (Array.isArray(this.statusMessages)) {
            data["statusMessages"] = [];
            for (let item of this.statusMessages)
                data["statusMessages"].push(item);
        }
        data["latestLocationTime"] = this.latestLocationTime ? this.latestLocationTime.toISOString() : <any>undefined;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        return data;
    }
}

export interface IVehicleLightVM {
    id?: number;
    vehicleId?: string | undefined;
    vehicleName?: string | undefined;
    deviceSerialNumber?: string | undefined;
    cameraDeviceSerialNumber?: string | undefined;
    group?: string | undefined;
    make?: string | undefined;
    model?: string | undefined;
    year?: number | undefined;
    driver?: string | undefined;
    vin?: string | undefined;
    odometer?: number | undefined;
    status?: string | undefined;
    statusMessages?: string[] | undefined;
    latestLocationTime?: Date | undefined;
    createdOn?: Date;
    modifiedOn?: Date;
}

export class FleetResponseOfVehicleDetailsVM extends BaseResponse implements IFleetResponseOfVehicleDetailsVM {
    data?: VehicleDetailsVM | undefined;

    constructor(data?: IFleetResponseOfVehicleDetailsVM) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? VehicleDetailsVM.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FleetResponseOfVehicleDetailsVM {
        data = typeof data === 'object' ? data : {};
        let result = new FleetResponseOfVehicleDetailsVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IFleetResponseOfVehicleDetailsVM extends IBaseResponse {
    data?: VehicleDetailsVM | undefined;
}

export class VehicleDetailsVM implements IVehicleDetailsVM {
    vehicleData?: VehicleVM;
    deviceData?: DeviceVM[];

    constructor(data?: IVehicleDetailsVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vehicleData = _data["vehicleData"] ? VehicleVM.fromJS(_data["vehicleData"]) : <any>undefined;
            if (Array.isArray(_data["deviceData"])) {
                this.deviceData = [] as any;
                for (let item of _data["deviceData"])
                    this.deviceData!.push(DeviceVM.fromJS(item));
            }
        }
    }

    static fromJS(data: any): VehicleDetailsVM {
        data = typeof data === 'object' ? data : {};
        let result = new VehicleDetailsVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vehicleData"] = this.vehicleData ? this.vehicleData.toJSON() : <any>undefined;
        if (Array.isArray(this.deviceData)) {
            data["deviceData"] = [];
            for (let item of this.deviceData)
                data["deviceData"].push(item.toJSON());
        }
        return data;
    }
}

export interface IVehicleDetailsVM {
    vehicleData?: VehicleVM;
    deviceData?: DeviceVM[];
}

export class VehicleVM implements IVehicleVM {
    id?: number;
    vehicleId?: string | undefined;
    group?: string | undefined;
    groupId?: number;
    vehicleName?: string | undefined;
    driverId?: number | undefined;
    driver?: string | undefined;
    truckId?: number | undefined;
    cameraDeviceId?: number | undefined;
    status?: string | undefined;
    statusMessages?: string[] | undefined;
    make?: string | undefined;
    model?: string | undefined;
    year?: number | undefined;
    vin?: string | undefined;
    licensePlateNumber?: string | undefined;
    purchaseDate?: Date | undefined;
    purchasePrice?: number | undefined;
    ownershipTypeId?: number;
    vehicleTypeId?: number;
    fuelTypeId?: number;
    costPerMile?: number | undefined;
    fuelTankCapacity?: number | undefined;
    insuranceProvider?: string | undefined;
    initialEngineHours?: number | undefined;
    engineHours?: number | undefined;
    odometer?: number | undefined;
    vehicleOdometerSynced?: boolean;
    warnings?: VehicleWarningsVM;
    createdOn?: Date;
    modifiedOn?: Date;

    constructor(data?: IVehicleVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.vehicleId = _data["vehicleId"];
            this.group = _data["group"];
            this.groupId = _data["groupId"];
            this.vehicleName = _data["vehicleName"];
            this.driverId = _data["driverId"];
            this.driver = _data["driver"];
            this.truckId = _data["truckId"];
            this.cameraDeviceId = _data["cameraDeviceId"];
            this.status = _data["status"];
            if (Array.isArray(_data["statusMessages"])) {
                this.statusMessages = [] as any;
                for (let item of _data["statusMessages"])
                    this.statusMessages!.push(item);
            }
            this.make = _data["make"];
            this.model = _data["model"];
            this.year = _data["year"];
            this.vin = _data["vin"];
            this.licensePlateNumber = _data["licensePlateNumber"];
            this.purchaseDate = _data["purchaseDate"] ? new Date(_data["purchaseDate"].toString()) : <any>undefined;
            this.purchasePrice = _data["purchasePrice"];
            this.ownershipTypeId = _data["ownershipTypeId"];
            this.vehicleTypeId = _data["vehicleTypeId"];
            this.fuelTypeId = _data["fuelTypeId"];
            this.costPerMile = _data["costPerMile"];
            this.fuelTankCapacity = _data["fuelTankCapacity"];
            this.insuranceProvider = _data["insuranceProvider"];
            this.initialEngineHours = _data["initialEngineHours"];
            this.engineHours = _data["engineHours"];
            this.odometer = _data["odometer"];
            this.vehicleOdometerSynced = _data["vehicleOdometerSynced"];
            this.warnings = _data["warnings"] ? VehicleWarningsVM.fromJS(_data["warnings"]) : <any>undefined;
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.modifiedOn = _data["modifiedOn"] ? new Date(_data["modifiedOn"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): VehicleVM {
        data = typeof data === 'object' ? data : {};
        let result = new VehicleVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["vehicleId"] = this.vehicleId;
        data["group"] = this.group;
        data["groupId"] = this.groupId;
        data["vehicleName"] = this.vehicleName;
        data["driverId"] = this.driverId;
        data["driver"] = this.driver;
        data["truckId"] = this.truckId;
        data["cameraDeviceId"] = this.cameraDeviceId;
        data["status"] = this.status;
        if (Array.isArray(this.statusMessages)) {
            data["statusMessages"] = [];
            for (let item of this.statusMessages)
                data["statusMessages"].push(item);
        }
        data["make"] = this.make;
        data["model"] = this.model;
        data["year"] = this.year;
        data["vin"] = this.vin;
        data["licensePlateNumber"] = this.licensePlateNumber;
        data["purchaseDate"] = this.purchaseDate ? this.purchaseDate.toISOString() : <any>undefined;
        data["purchasePrice"] = this.purchasePrice;
        data["ownershipTypeId"] = this.ownershipTypeId;
        data["vehicleTypeId"] = this.vehicleTypeId;
        data["fuelTypeId"] = this.fuelTypeId;
        data["costPerMile"] = this.costPerMile;
        data["fuelTankCapacity"] = this.fuelTankCapacity;
        data["insuranceProvider"] = this.insuranceProvider;
        data["initialEngineHours"] = this.initialEngineHours;
        data["engineHours"] = this.engineHours;
        data["odometer"] = this.odometer;
        data["vehicleOdometerSynced"] = this.vehicleOdometerSynced;
        data["warnings"] = this.warnings ? this.warnings.toJSON() : <any>undefined;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        return data;
    }
}

export interface IVehicleVM {
    id?: number;
    vehicleId?: string | undefined;
    group?: string | undefined;
    groupId?: number;
    vehicleName?: string | undefined;
    driverId?: number | undefined;
    driver?: string | undefined;
    truckId?: number | undefined;
    cameraDeviceId?: number | undefined;
    status?: string | undefined;
    statusMessages?: string[] | undefined;
    make?: string | undefined;
    model?: string | undefined;
    year?: number | undefined;
    vin?: string | undefined;
    licensePlateNumber?: string | undefined;
    purchaseDate?: Date | undefined;
    purchasePrice?: number | undefined;
    ownershipTypeId?: number;
    vehicleTypeId?: number;
    fuelTypeId?: number;
    costPerMile?: number | undefined;
    fuelTankCapacity?: number | undefined;
    insuranceProvider?: string | undefined;
    initialEngineHours?: number | undefined;
    engineHours?: number | undefined;
    odometer?: number | undefined;
    vehicleOdometerSynced?: boolean;
    warnings?: VehicleWarningsVM;
    createdOn?: Date;
    modifiedOn?: Date;
}

export class VehicleWarningsVM implements IVehicleWarningsVM {
    driverId?: string | undefined;
    vehicleName?: string | undefined;
    vin?: string | undefined;

    constructor(data?: IVehicleWarningsVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.driverId = _data["driverId"];
            this.vehicleName = _data["vehicleName"];
            this.vin = _data["vin"];
        }
    }

    static fromJS(data: any): VehicleWarningsVM {
        data = typeof data === 'object' ? data : {};
        let result = new VehicleWarningsVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["driverId"] = this.driverId;
        data["vehicleName"] = this.vehicleName;
        data["vin"] = this.vin;
        return data;
    }
}

export interface IVehicleWarningsVM {
    driverId?: string | undefined;
    vehicleName?: string | undefined;
    vin?: string | undefined;
}

export class FleetResponseOfVehicleVM extends BaseResponse implements IFleetResponseOfVehicleVM {
    data?: VehicleVM | undefined;

    constructor(data?: IFleetResponseOfVehicleVM) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? VehicleVM.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FleetResponseOfVehicleVM {
        data = typeof data === 'object' ? data : {};
        let result = new FleetResponseOfVehicleVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IFleetResponseOfVehicleVM extends IBaseResponse {
    data?: VehicleVM | undefined;
}

export class FleetResponseOfPaginatedModelOfVehicleMakeVM extends BaseResponse implements IFleetResponseOfPaginatedModelOfVehicleMakeVM {
    data?: PaginatedModelOfVehicleMakeVM | undefined;

    constructor(data?: IFleetResponseOfPaginatedModelOfVehicleMakeVM) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? PaginatedModelOfVehicleMakeVM.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FleetResponseOfPaginatedModelOfVehicleMakeVM {
        data = typeof data === 'object' ? data : {};
        let result = new FleetResponseOfPaginatedModelOfVehicleMakeVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IFleetResponseOfPaginatedModelOfVehicleMakeVM extends IBaseResponse {
    data?: PaginatedModelOfVehicleMakeVM | undefined;
}

export class PaginatedModelOfVehicleMakeVM implements IPaginatedModelOfVehicleMakeVM {
    page!: number;
    totalPages!: number;
    totalItems!: number;
    maxItemCountReached!: boolean;
    maxItemCount!: number;
    rows!: VehicleMakeVM[];

    constructor(data?: IPaginatedModelOfVehicleMakeVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.rows = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.page = _data["page"];
            this.totalPages = _data["totalPages"];
            this.totalItems = _data["totalItems"];
            this.maxItemCountReached = _data["maxItemCountReached"];
            this.maxItemCount = _data["maxItemCount"];
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(VehicleMakeVM.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaginatedModelOfVehicleMakeVM {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedModelOfVehicleMakeVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["page"] = this.page;
        data["totalPages"] = this.totalPages;
        data["totalItems"] = this.totalItems;
        data["maxItemCountReached"] = this.maxItemCountReached;
        data["maxItemCount"] = this.maxItemCount;
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPaginatedModelOfVehicleMakeVM {
    page: number;
    totalPages: number;
    totalItems: number;
    maxItemCountReached: boolean;
    maxItemCount: number;
    rows: VehicleMakeVM[];
}

export class VehicleMakeVM implements IVehicleMakeVM {
    id!: number;
    name!: string;

    constructor(data?: IVehicleMakeVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): VehicleMakeVM {
        data = typeof data === 'object' ? data : {};
        let result = new VehicleMakeVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IVehicleMakeVM {
    id: number;
    name: string;
}

export class VehicleStaticDataFilterModel implements IVehicleStaticDataFilterModel {
    text?: string | undefined;
    existingVehicleName?: string | undefined;
    pageModel?: PageInputModel;

    constructor(data?: IVehicleStaticDataFilterModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.text = _data["text"];
            this.existingVehicleName = _data["existingVehicleName"];
            this.pageModel = _data["pageModel"] ? PageInputModel.fromJS(_data["pageModel"]) : <any>undefined;
        }
    }

    static fromJS(data: any): VehicleStaticDataFilterModel {
        data = typeof data === 'object' ? data : {};
        let result = new VehicleStaticDataFilterModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["text"] = this.text;
        data["existingVehicleName"] = this.existingVehicleName;
        data["pageModel"] = this.pageModel ? this.pageModel.toJSON() : <any>undefined;
        return data;
    }
}

export interface IVehicleStaticDataFilterModel {
    text?: string | undefined;
    existingVehicleName?: string | undefined;
    pageModel?: PageInputModel;
}

export class FleetResponseOfEnvelopedModelOfVehicleModelVM extends BaseResponse implements IFleetResponseOfEnvelopedModelOfVehicleModelVM {
    data?: EnvelopedModelOfVehicleModelVM | undefined;

    constructor(data?: IFleetResponseOfEnvelopedModelOfVehicleModelVM) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? EnvelopedModelOfVehicleModelVM.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FleetResponseOfEnvelopedModelOfVehicleModelVM {
        data = typeof data === 'object' ? data : {};
        let result = new FleetResponseOfEnvelopedModelOfVehicleModelVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IFleetResponseOfEnvelopedModelOfVehicleModelVM extends IBaseResponse {
    data?: EnvelopedModelOfVehicleModelVM | undefined;
}

export class EnvelopedModelOfVehicleModelVM implements IEnvelopedModelOfVehicleModelVM {
    rows?: VehicleModelVM[];
    totalItems?: number;

    constructor(data?: IEnvelopedModelOfVehicleModelVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(VehicleModelVM.fromJS(item));
            }
            this.totalItems = _data["totalItems"];
        }
    }

    static fromJS(data: any): EnvelopedModelOfVehicleModelVM {
        data = typeof data === 'object' ? data : {};
        let result = new EnvelopedModelOfVehicleModelVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        data["totalItems"] = this.totalItems;
        return data;
    }
}

export interface IEnvelopedModelOfVehicleModelVM {
    rows?: VehicleModelVM[];
    totalItems?: number;
}

export class VehicleModelVM implements IVehicleModelVM {
    id!: number;
    modelName!: string;
    makeId!: number;

    constructor(data?: IVehicleModelVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.modelName = _data["modelName"];
            this.makeId = _data["makeId"];
        }
    }

    static fromJS(data: any): VehicleModelVM {
        data = typeof data === 'object' ? data : {};
        let result = new VehicleModelVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["modelName"] = this.modelName;
        data["makeId"] = this.makeId;
        return data;
    }
}

export interface IVehicleModelVM {
    id: number;
    modelName: string;
    makeId: number;
}

export class FleetResponseOfEnvelopedModelOfVehicleModelYearVM extends BaseResponse implements IFleetResponseOfEnvelopedModelOfVehicleModelYearVM {
    data?: EnvelopedModelOfVehicleModelYearVM | undefined;

    constructor(data?: IFleetResponseOfEnvelopedModelOfVehicleModelYearVM) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? EnvelopedModelOfVehicleModelYearVM.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FleetResponseOfEnvelopedModelOfVehicleModelYearVM {
        data = typeof data === 'object' ? data : {};
        let result = new FleetResponseOfEnvelopedModelOfVehicleModelYearVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IFleetResponseOfEnvelopedModelOfVehicleModelYearVM extends IBaseResponse {
    data?: EnvelopedModelOfVehicleModelYearVM | undefined;
}

export class EnvelopedModelOfVehicleModelYearVM implements IEnvelopedModelOfVehicleModelYearVM {
    rows?: VehicleModelYearVM[];
    totalItems?: number;

    constructor(data?: IEnvelopedModelOfVehicleModelYearVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(VehicleModelYearVM.fromJS(item));
            }
            this.totalItems = _data["totalItems"];
        }
    }

    static fromJS(data: any): EnvelopedModelOfVehicleModelYearVM {
        data = typeof data === 'object' ? data : {};
        let result = new EnvelopedModelOfVehicleModelYearVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        data["totalItems"] = this.totalItems;
        return data;
    }
}

export interface IEnvelopedModelOfVehicleModelYearVM {
    rows?: VehicleModelYearVM[];
    totalItems?: number;
}

export class VehicleModelYearVM implements IVehicleModelYearVM {
    year!: number;

    constructor(data?: IVehicleModelYearVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.year = _data["year"];
        }
    }

    static fromJS(data: any): VehicleModelYearVM {
        data = typeof data === 'object' ? data : {};
        let result = new VehicleModelYearVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["year"] = this.year;
        return data;
    }
}

export interface IVehicleModelYearVM {
    year: number;
}

export class FleetResponseOfEnvelopedModelOfBreadcrumbItemVm extends BaseResponse implements IFleetResponseOfEnvelopedModelOfBreadcrumbItemVm {
    data?: EnvelopedModelOfBreadcrumbItemVm | undefined;

    constructor(data?: IFleetResponseOfEnvelopedModelOfBreadcrumbItemVm) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? EnvelopedModelOfBreadcrumbItemVm.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FleetResponseOfEnvelopedModelOfBreadcrumbItemVm {
        data = typeof data === 'object' ? data : {};
        let result = new FleetResponseOfEnvelopedModelOfBreadcrumbItemVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IFleetResponseOfEnvelopedModelOfBreadcrumbItemVm extends IBaseResponse {
    data?: EnvelopedModelOfBreadcrumbItemVm | undefined;
}

export class EnvelopedModelOfBreadcrumbItemVm implements IEnvelopedModelOfBreadcrumbItemVm {
    rows?: BreadcrumbItemVm[];
    totalItems?: number;

    constructor(data?: IEnvelopedModelOfBreadcrumbItemVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(BreadcrumbItemVm.fromJS(item));
            }
            this.totalItems = _data["totalItems"];
        }
    }

    static fromJS(data: any): EnvelopedModelOfBreadcrumbItemVm {
        data = typeof data === 'object' ? data : {};
        let result = new EnvelopedModelOfBreadcrumbItemVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        data["totalItems"] = this.totalItems;
        return data;
    }
}

export interface IEnvelopedModelOfBreadcrumbItemVm {
    rows?: BreadcrumbItemVm[];
    totalItems?: number;
}

export abstract class BreadcrumbItemVm implements IBreadcrumbItemVm {
    id!: string;

    protected _discriminator: string;

    constructor(data?: IBreadcrumbItemVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "BreadcrumbItemVm";
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): BreadcrumbItemVm {
        data = typeof data === 'object' ? data : {};
        if (data["$type"] === "trip") {
            let result = new BreadcrumbTripVm();
            result.init(data);
            return result;
        }
        if (data["$type"] === "jobAssignment") {
            let result = new BreadcrumbJobAssignmentVm();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'BreadcrumbItemVm' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["$type"] = this._discriminator;
        data["id"] = this.id;
        return data;
    }
}

export interface IBreadcrumbItemVm {
    id: string;
}

export class BreadcrumbTripVm extends BreadcrumbItemVm implements IBreadcrumbTripVm {
    trackedResourceId!: number;
    tripNumber!: number;
    driverName?: string | undefined;
    tripName!: string;
    details!: BreadcrumbTripDetailsVm;
    startInfo!: BreadcrumbTripLocationInfoVm;
    lastInfo!: BreadcrumbTripLocationInfoVm;
    events!: BreadcrumbTripEventVm[];
    gpsPings!: CoordinatesVm[];
    isOngoing!: boolean;

    constructor(data?: IBreadcrumbTripVm) {
        super(data);
        if (!data) {
            this.details = new BreadcrumbTripDetailsVm();
            this.startInfo = new BreadcrumbTripLocationInfoVm();
            this.lastInfo = new BreadcrumbTripLocationInfoVm();
            this.events = [];
            this.gpsPings = [];
        }
        this._discriminator = "trip";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.trackedResourceId = _data["trackedResourceId"];
            this.tripNumber = _data["tripNumber"];
            this.driverName = _data["driverName"];
            this.tripName = _data["tripName"];
            this.details = _data["details"] ? BreadcrumbTripDetailsVm.fromJS(_data["details"]) : new BreadcrumbTripDetailsVm();
            this.startInfo = _data["startInfo"] ? BreadcrumbTripLocationInfoVm.fromJS(_data["startInfo"]) : new BreadcrumbTripLocationInfoVm();
            this.lastInfo = _data["lastInfo"] ? BreadcrumbTripLocationInfoVm.fromJS(_data["lastInfo"]) : new BreadcrumbTripLocationInfoVm();
            if (Array.isArray(_data["events"])) {
                this.events = [] as any;
                for (let item of _data["events"])
                    this.events!.push(BreadcrumbTripEventVm.fromJS(item));
            }
            if (Array.isArray(_data["gpsPings"])) {
                this.gpsPings = [] as any;
                for (let item of _data["gpsPings"])
                    this.gpsPings!.push(CoordinatesVm.fromJS(item));
            }
            this.isOngoing = _data["isOngoing"];
        }
    }

    static fromJS(data: any): BreadcrumbTripVm {
        data = typeof data === 'object' ? data : {};
        let result = new BreadcrumbTripVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["trackedResourceId"] = this.trackedResourceId;
        data["tripNumber"] = this.tripNumber;
        data["driverName"] = this.driverName;
        data["tripName"] = this.tripName;
        data["details"] = this.details ? this.details.toJSON() : <any>undefined;
        data["startInfo"] = this.startInfo ? this.startInfo.toJSON() : <any>undefined;
        data["lastInfo"] = this.lastInfo ? this.lastInfo.toJSON() : <any>undefined;
        if (Array.isArray(this.events)) {
            data["events"] = [];
            for (let item of this.events)
                data["events"].push(item.toJSON());
        }
        if (Array.isArray(this.gpsPings)) {
            data["gpsPings"] = [];
            for (let item of this.gpsPings)
                data["gpsPings"].push(item.toJSON());
        }
        data["isOngoing"] = this.isOngoing;
        super.toJSON(data);
        return data;
    }
}

export interface IBreadcrumbTripVm extends IBreadcrumbItemVm {
    trackedResourceId: number;
    tripNumber: number;
    driverName?: string | undefined;
    tripName: string;
    details: BreadcrumbTripDetailsVm;
    startInfo: BreadcrumbTripLocationInfoVm;
    lastInfo: BreadcrumbTripLocationInfoVm;
    events: BreadcrumbTripEventVm[];
    gpsPings: CoordinatesVm[];
    isOngoing: boolean;
}

export class BreadcrumbTripDetailsVm implements IBreadcrumbTripDetailsVm {
    timeSeconds!: number;
    idlingTimeSeconds?: number | undefined;
    stopTimeSeconds?: number | undefined;
    distanceMiles!: number;
    gpsDistanceMiles!: number;

    constructor(data?: IBreadcrumbTripDetailsVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.timeSeconds = _data["timeSeconds"];
            this.idlingTimeSeconds = _data["idlingTimeSeconds"];
            this.stopTimeSeconds = _data["stopTimeSeconds"];
            this.distanceMiles = _data["distanceMiles"];
            this.gpsDistanceMiles = _data["gpsDistanceMiles"];
        }
    }

    static fromJS(data: any): BreadcrumbTripDetailsVm {
        data = typeof data === 'object' ? data : {};
        let result = new BreadcrumbTripDetailsVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["timeSeconds"] = this.timeSeconds;
        data["idlingTimeSeconds"] = this.idlingTimeSeconds;
        data["stopTimeSeconds"] = this.stopTimeSeconds;
        data["distanceMiles"] = this.distanceMiles;
        data["gpsDistanceMiles"] = this.gpsDistanceMiles;
        return data;
    }
}

export interface IBreadcrumbTripDetailsVm {
    timeSeconds: number;
    idlingTimeSeconds?: number | undefined;
    stopTimeSeconds?: number | undefined;
    distanceMiles: number;
    gpsDistanceMiles: number;
}

export class BreadcrumbTripLocationInfoVm implements IBreadcrumbTripLocationInfoVm {
    eventId!: string;
    timestamp!: Date;
    coordinates!: CoordinatesVm;
    address?: string | undefined;
    geofenceName?: string | undefined;

    constructor(data?: IBreadcrumbTripLocationInfoVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.coordinates = new CoordinatesVm();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.eventId = _data["eventId"];
            this.timestamp = _data["timestamp"] ? new Date(_data["timestamp"].toString()) : <any>undefined;
            this.coordinates = _data["coordinates"] ? CoordinatesVm.fromJS(_data["coordinates"]) : new CoordinatesVm();
            this.address = _data["address"];
            this.geofenceName = _data["geofenceName"];
        }
    }

    static fromJS(data: any): BreadcrumbTripLocationInfoVm {
        data = typeof data === 'object' ? data : {};
        let result = new BreadcrumbTripLocationInfoVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["eventId"] = this.eventId;
        data["timestamp"] = this.timestamp ? this.timestamp.toISOString() : <any>undefined;
        data["coordinates"] = this.coordinates ? this.coordinates.toJSON() : <any>undefined;
        data["address"] = this.address;
        data["geofenceName"] = this.geofenceName;
        return data;
    }
}

export interface IBreadcrumbTripLocationInfoVm {
    eventId: string;
    timestamp: Date;
    coordinates: CoordinatesVm;
    address?: string | undefined;
    geofenceName?: string | undefined;
}

export class BreadcrumbTripEventVm implements IBreadcrumbTripEventVm {
    id!: string;
    type!: FleetEventType;
    typeName!: string;
    title!: string;
    timestamp!: Date;
    details?: string | undefined;
    coordinates!: CoordinatesVm;
    address?: string | undefined;
    geofenceName?: string | undefined;
    videoId?: number | undefined;

    constructor(data?: IBreadcrumbTripEventVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.coordinates = new CoordinatesVm();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.type = _data["type"];
            this.typeName = _data["typeName"];
            this.title = _data["title"];
            this.timestamp = _data["timestamp"] ? new Date(_data["timestamp"].toString()) : <any>undefined;
            this.details = _data["details"];
            this.coordinates = _data["coordinates"] ? CoordinatesVm.fromJS(_data["coordinates"]) : new CoordinatesVm();
            this.address = _data["address"];
            this.geofenceName = _data["geofenceName"];
            this.videoId = _data["videoId"];
        }
    }

    static fromJS(data: any): BreadcrumbTripEventVm {
        data = typeof data === 'object' ? data : {};
        let result = new BreadcrumbTripEventVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["type"] = this.type;
        data["typeName"] = this.typeName;
        data["title"] = this.title;
        data["timestamp"] = this.timestamp ? this.timestamp.toISOString() : <any>undefined;
        data["details"] = this.details;
        data["coordinates"] = this.coordinates ? this.coordinates.toJSON() : <any>undefined;
        data["address"] = this.address;
        data["geofenceName"] = this.geofenceName;
        data["videoId"] = this.videoId;
        return data;
    }
}

export interface IBreadcrumbTripEventVm {
    id: string;
    type: FleetEventType;
    typeName: string;
    title: string;
    timestamp: Date;
    details?: string | undefined;
    coordinates: CoordinatesVm;
    address?: string | undefined;
    geofenceName?: string | undefined;
    videoId?: number | undefined;
}

export enum FleetEventType {
    AccelerometerYAxisEvent = 1,
    AssetEvent = 2,
    BatteryCriticalAlarmEvent = 3,
    BatteryLowAlarmEvent = 4,
    ConnectEvent = 5,
    DisconnectEvent = 6,
    DtcEvent = 7,
    FuelDecreaseEvent = 8,
    FuelIncreaseEvent = 9,
    GeofenceEntryEvent = 10,
    GeofenceExitEvent = 11,
    GeofenceInTimerEvent = 12,
    GeofenceOutTimerEvent = 13,
    GpsEvent = 14,
    HardAccelerationEvent = 15,
    HardBrakingEvent = 16,
    HardcoreBrakingEvent = 17,
    IdlingDetectedEvent = 18,
    IdlingEvent = 19,
    InstantPslAlertEvent = 20,
    InvalidPostedSpeedLimitEvent = 21,
    LowBatteryVoltageEvent = 22,
    LowFuelEvent = 23,
    NonInstantPslAlertEvent = 24,
    OverSpeedingEvent = 25,
    PeripheralConnectEvent = 26,
    PeripheralDisconnectEvent = 27,
    RawPostedSpeedLimitEvent = 28,
    SeatBeltEvent = 29,
    StopTimeEvent = 30,
    TripEndEvent = 31,
    TripStartEvent = 32,
    UnauthorizedVehicleUsageEvent = 33,
    VehicleNotTrackingEvent = 34,
    VINChangeEvent = 35,
    AccidentDetectionEvent = 36,
    VehicleBackupEvent = 37,
    AccelerometerImpactEvent = 38,
    CamButtonPressedEvent = 39,
    CamDisconnectEvent = 40,
    CamDistractedDrivingEvent = 41,
    CamImpactEvent = 42,
    CamTamperedEvent = 43,
    CamViolentLeftTurnEvent = 44,
    CamViolentRightTurnEvent = 45,
    CamAccidentAiEvent = 46,
    CamPhoneUseEvent = 47,
    CamUnbeltedEvent = 48,
    CamEatingDrinkingEvent = 49,
    CamSmokingEvent = 50,
    CamGforceHighEvent = 51,
    CamGforceRegularEvent = 52,
    CamPossibleFatigueEvent = 53,
    CamTailgatingEvent = 54,
    CamObstructionEvent = 55,
    CamLaneDepartureEvent = 56,
    CamViolentTurnEvent = 57,
    CamRollingStopEvent = 58,
    CamForwardCollisionWarningEvent = 59,
}

export class BreadcrumbJobAssignmentVm extends BreadcrumbItemVm implements IBreadcrumbJobAssignmentVm {
    status!: JobAppointmentAssignmentStatusVm;
    jobTypeName!: string;
    jobId!: string;
    address?: string | undefined;
    location!: CoordinatesVm;
    startDate!: Date;
    technicianName!: string;
    jobNumber!: string;

    constructor(data?: IBreadcrumbJobAssignmentVm) {
        super(data);
        if (!data) {
            this.location = new CoordinatesVm();
        }
        this._discriminator = "jobAssignment";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.status = _data["status"];
            this.jobTypeName = _data["jobTypeName"];
            this.jobId = _data["jobId"];
            this.address = _data["address"];
            this.location = _data["location"] ? CoordinatesVm.fromJS(_data["location"]) : new CoordinatesVm();
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.technicianName = _data["technicianName"];
            this.jobNumber = _data["jobNumber"];
        }
    }

    static fromJS(data: any): BreadcrumbJobAssignmentVm {
        data = typeof data === 'object' ? data : {};
        let result = new BreadcrumbJobAssignmentVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["jobTypeName"] = this.jobTypeName;
        data["jobId"] = this.jobId;
        data["address"] = this.address;
        data["location"] = this.location ? this.location.toJSON() : <any>undefined;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["technicianName"] = this.technicianName;
        data["jobNumber"] = this.jobNumber;
        super.toJSON(data);
        return data;
    }
}

export interface IBreadcrumbJobAssignmentVm extends IBreadcrumbItemVm {
    status: JobAppointmentAssignmentStatusVm;
    jobTypeName: string;
    jobId: string;
    address?: string | undefined;
    location: CoordinatesVm;
    startDate: Date;
    technicianName: string;
    jobNumber: string;
}

export enum JobAppointmentAssignmentStatusVm {
    Scheduled = 1,
    Dispatched = 2,
    Working = 3,
    Done = 4,
}

export class BreadcrumbTripRequestVm implements IBreadcrumbTripRequestVm {
    trackedResourceIds!: number[];
    startTime!: Date;
    endTime!: Date;
    fetchEventVideoData?: boolean | undefined;

    constructor(data?: IBreadcrumbTripRequestVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.trackedResourceIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["trackedResourceIds"])) {
                this.trackedResourceIds = [] as any;
                for (let item of _data["trackedResourceIds"])
                    this.trackedResourceIds!.push(item);
            }
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? new Date(_data["endTime"].toString()) : <any>undefined;
            this.fetchEventVideoData = _data["fetchEventVideoData"];
        }
    }

    static fromJS(data: any): BreadcrumbTripRequestVm {
        data = typeof data === 'object' ? data : {};
        let result = new BreadcrumbTripRequestVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.trackedResourceIds)) {
            data["trackedResourceIds"] = [];
            for (let item of this.trackedResourceIds)
                data["trackedResourceIds"].push(item);
        }
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["fetchEventVideoData"] = this.fetchEventVideoData;
        return data;
    }
}

export interface IBreadcrumbTripRequestVm {
    trackedResourceIds: number[];
    startTime: Date;
    endTime: Date;
    fetchEventVideoData?: boolean | undefined;
}

export class UiResponse implements IUiResponse {
    traceId?: string | undefined;
    generatedAt!: Date;
    errors?: UiError[];

    constructor(data?: IUiResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.traceId = _data["traceId"];
            this.generatedAt = _data["generatedAt"] ? new Date(_data["generatedAt"].toString()) : <any>undefined;
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(UiError.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UiResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UiResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["traceId"] = this.traceId;
        data["generatedAt"] = this.generatedAt ? this.generatedAt.toISOString() : <any>undefined;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUiResponse {
    traceId?: string | undefined;
    generatedAt: Date;
    errors?: UiError[];
}

export class UiDataResponseOfEnvelopedModelOfCameraVideoGridVM extends UiResponse implements IUiDataResponseOfEnvelopedModelOfCameraVideoGridVM {
    data?: EnvelopedModelOfCameraVideoGridVM | undefined;

    constructor(data?: IUiDataResponseOfEnvelopedModelOfCameraVideoGridVM) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? EnvelopedModelOfCameraVideoGridVM.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UiDataResponseOfEnvelopedModelOfCameraVideoGridVM {
        data = typeof data === 'object' ? data : {};
        let result = new UiDataResponseOfEnvelopedModelOfCameraVideoGridVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IUiDataResponseOfEnvelopedModelOfCameraVideoGridVM extends IUiResponse {
    data?: EnvelopedModelOfCameraVideoGridVM | undefined;
}

export class EnvelopedModelOfCameraVideoGridVM implements IEnvelopedModelOfCameraVideoGridVM {
    rows?: CameraVideoGridVM[];
    totalItems?: number;

    constructor(data?: IEnvelopedModelOfCameraVideoGridVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(CameraVideoGridVM.fromJS(item));
            }
            this.totalItems = _data["totalItems"];
        }
    }

    static fromJS(data: any): EnvelopedModelOfCameraVideoGridVM {
        data = typeof data === 'object' ? data : {};
        let result = new EnvelopedModelOfCameraVideoGridVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        data["totalItems"] = this.totalItems;
        return data;
    }
}

export interface IEnvelopedModelOfCameraVideoGridVM {
    rows?: CameraVideoGridVM[];
    totalItems?: number;
}

export class CameraVideoGridVM implements ICameraVideoGridVM {
    cameraVideoId!: string;
    vendorId!: string;
    vehicleName!: string;
    eventType!: string;
    driverName?: string | undefined;
    groupName!: string;
    time?: Date;
    location?: CoordinatesVm | undefined;
    address?: string | undefined;
    initialSpeed?: number | undefined;
    finalSpeed?: number | undefined;
    request?: CameraVideoRequestInfoVM | undefined;
    fragments!: CameraVideoFragmentVM[];

    constructor(data?: ICameraVideoGridVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.fragments = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cameraVideoId = _data["cameraVideoId"];
            this.vendorId = _data["vendorId"];
            this.vehicleName = _data["vehicleName"];
            this.eventType = _data["eventType"];
            this.driverName = _data["driverName"];
            this.groupName = _data["groupName"];
            this.time = _data["time"] ? new Date(_data["time"].toString()) : <any>undefined;
            this.location = _data["location"] ? CoordinatesVm.fromJS(_data["location"]) : <any>undefined;
            this.address = _data["address"];
            this.initialSpeed = _data["initialSpeed"];
            this.finalSpeed = _data["finalSpeed"];
            this.request = _data["request"] ? CameraVideoRequestInfoVM.fromJS(_data["request"]) : <any>undefined;
            if (Array.isArray(_data["fragments"])) {
                this.fragments = [] as any;
                for (let item of _data["fragments"])
                    this.fragments!.push(CameraVideoFragmentVM.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CameraVideoGridVM {
        data = typeof data === 'object' ? data : {};
        let result = new CameraVideoGridVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cameraVideoId"] = this.cameraVideoId;
        data["vendorId"] = this.vendorId;
        data["vehicleName"] = this.vehicleName;
        data["eventType"] = this.eventType;
        data["driverName"] = this.driverName;
        data["groupName"] = this.groupName;
        data["time"] = this.time ? this.time.toISOString() : <any>undefined;
        data["location"] = this.location ? this.location.toJSON() : <any>undefined;
        data["address"] = this.address;
        data["initialSpeed"] = this.initialSpeed;
        data["finalSpeed"] = this.finalSpeed;
        data["request"] = this.request ? this.request.toJSON() : <any>undefined;
        if (Array.isArray(this.fragments)) {
            data["fragments"] = [];
            for (let item of this.fragments)
                data["fragments"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICameraVideoGridVM {
    cameraVideoId: string;
    vendorId: string;
    vehicleName: string;
    eventType: string;
    driverName?: string | undefined;
    groupName: string;
    time?: Date;
    location?: CoordinatesVm | undefined;
    address?: string | undefined;
    initialSpeed?: number | undefined;
    finalSpeed?: number | undefined;
    request?: CameraVideoRequestInfoVM | undefined;
    fragments: CameraVideoFragmentVM[];
}

export class CameraVideoRequestInfoVM implements ICameraVideoRequestInfoVM {
    name!: string;
    startTime!: Date;
    endTime!: Date;
    status!: RequestStatus;

    constructor(data?: ICameraVideoRequestInfoVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? new Date(_data["endTime"].toString()) : <any>undefined;
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): CameraVideoRequestInfoVM {
        data = typeof data === 'object' ? data : {};
        let result = new CameraVideoRequestInfoVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["status"] = this.status;
        return data;
    }
}

export interface ICameraVideoRequestInfoVM {
    name: string;
    startTime: Date;
    endTime: Date;
    status: RequestStatus;
}

export class CameraVideoFragmentVM implements ICameraVideoFragmentVM {
    roadVideoLink?: string | undefined;
    roadThumbnailLink?: string | undefined;
    driverVideoLink?: string | undefined;
    driverThumbnailLink?: string | undefined;
    startTime!: Date;
    endTime?: Date | undefined;

    constructor(data?: ICameraVideoFragmentVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.roadVideoLink = _data["roadVideoLink"];
            this.roadThumbnailLink = _data["roadThumbnailLink"];
            this.driverVideoLink = _data["driverVideoLink"];
            this.driverThumbnailLink = _data["driverThumbnailLink"];
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? new Date(_data["endTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CameraVideoFragmentVM {
        data = typeof data === 'object' ? data : {};
        let result = new CameraVideoFragmentVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["roadVideoLink"] = this.roadVideoLink;
        data["roadThumbnailLink"] = this.roadThumbnailLink;
        data["driverVideoLink"] = this.driverVideoLink;
        data["driverThumbnailLink"] = this.driverThumbnailLink;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        return data;
    }
}

export interface ICameraVideoFragmentVM {
    roadVideoLink?: string | undefined;
    roadThumbnailLink?: string | undefined;
    driverVideoLink?: string | undefined;
    driverThumbnailLink?: string | undefined;
    startTime: Date;
    endTime?: Date | undefined;
}

export class UiError implements IUiError {
    message!: string;

    constructor(data?: IUiError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): UiError {
        data = typeof data === 'object' ? data : {};
        let result = new UiError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        return data;
    }
}

export interface IUiError {
    message: string;
}

export class UiDataResponseOfRequestedCameraVideoVM extends UiResponse implements IUiDataResponseOfRequestedCameraVideoVM {
    data?: RequestedCameraVideoVM | undefined;

    constructor(data?: IUiDataResponseOfRequestedCameraVideoVM) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? RequestedCameraVideoVM.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UiDataResponseOfRequestedCameraVideoVM {
        data = typeof data === 'object' ? data : {};
        let result = new UiDataResponseOfRequestedCameraVideoVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IUiDataResponseOfRequestedCameraVideoVM extends IUiResponse {
    data?: RequestedCameraVideoVM | undefined;
}

export class RequestedCameraVideoVM implements IRequestedCameraVideoVM {
    id!: number;

    constructor(data?: IRequestedCameraVideoVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): RequestedCameraVideoVM {
        data = typeof data === 'object' ? data : {};
        let result = new RequestedCameraVideoVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IRequestedCameraVideoVM {
    id: number;
}

export class CameraVideoRequestCreateVM implements ICameraVideoRequestCreateVM {
    trackedResourceId!: number;
    name!: string;
    startTime!: Date;
    endTime!: Date;

    constructor(data?: ICameraVideoRequestCreateVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.trackedResourceId = _data["trackedResourceId"];
            this.name = _data["name"];
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? new Date(_data["endTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CameraVideoRequestCreateVM {
        data = typeof data === 'object' ? data : {};
        let result = new CameraVideoRequestCreateVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["trackedResourceId"] = this.trackedResourceId;
        data["name"] = this.name;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        return data;
    }
}

export interface ICameraVideoRequestCreateVM {
    trackedResourceId: number;
    name: string;
    startTime: Date;
    endTime: Date;
}

export class UiDataResponseOfCameraVideoGridVM extends UiResponse implements IUiDataResponseOfCameraVideoGridVM {
    data?: CameraVideoGridVM | undefined;

    constructor(data?: IUiDataResponseOfCameraVideoGridVM) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? CameraVideoGridVM.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UiDataResponseOfCameraVideoGridVM {
        data = typeof data === 'object' ? data : {};
        let result = new UiDataResponseOfCameraVideoGridVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IUiDataResponseOfCameraVideoGridVM extends IUiResponse {
    data?: CameraVideoGridVM | undefined;
}

export class UiDataResponseOfEnvelopedModelOfCameraVideoFragmentVM extends UiResponse implements IUiDataResponseOfEnvelopedModelOfCameraVideoFragmentVM {
    data?: EnvelopedModelOfCameraVideoFragmentVM | undefined;

    constructor(data?: IUiDataResponseOfEnvelopedModelOfCameraVideoFragmentVM) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? EnvelopedModelOfCameraVideoFragmentVM.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UiDataResponseOfEnvelopedModelOfCameraVideoFragmentVM {
        data = typeof data === 'object' ? data : {};
        let result = new UiDataResponseOfEnvelopedModelOfCameraVideoFragmentVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IUiDataResponseOfEnvelopedModelOfCameraVideoFragmentVM extends IUiResponse {
    data?: EnvelopedModelOfCameraVideoFragmentVM | undefined;
}

export class EnvelopedModelOfCameraVideoFragmentVM implements IEnvelopedModelOfCameraVideoFragmentVM {
    rows?: CameraVideoFragmentVM[];
    totalItems?: number;

    constructor(data?: IEnvelopedModelOfCameraVideoFragmentVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(CameraVideoFragmentVM.fromJS(item));
            }
            this.totalItems = _data["totalItems"];
        }
    }

    static fromJS(data: any): EnvelopedModelOfCameraVideoFragmentVM {
        data = typeof data === 'object' ? data : {};
        let result = new EnvelopedModelOfCameraVideoFragmentVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        data["totalItems"] = this.totalItems;
        return data;
    }
}

export interface IEnvelopedModelOfCameraVideoFragmentVM {
    rows?: CameraVideoFragmentVM[];
    totalItems?: number;
}

export class UiDataResponseOfDevicesSummaryVM extends UiResponse implements IUiDataResponseOfDevicesSummaryVM {
    data?: DevicesSummaryVM | undefined;

    constructor(data?: IUiDataResponseOfDevicesSummaryVM) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? DevicesSummaryVM.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UiDataResponseOfDevicesSummaryVM {
        data = typeof data === 'object' ? data : {};
        let result = new UiDataResponseOfDevicesSummaryVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IUiDataResponseOfDevicesSummaryVM extends IUiResponse {
    data?: DevicesSummaryVM | undefined;
}

export class DevicesSummaryVM implements IDevicesSummaryVM {
    dataLoggersCount!: number;
    assetTrackersCount!: number;
    aiCamerasCount!: number;
    nonAiCamerasCount!: number;
    oemTcuCount!: number;

    constructor(data?: IDevicesSummaryVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dataLoggersCount = _data["dataLoggersCount"];
            this.assetTrackersCount = _data["assetTrackersCount"];
            this.aiCamerasCount = _data["aiCamerasCount"];
            this.nonAiCamerasCount = _data["nonAiCamerasCount"];
            this.oemTcuCount = _data["oemTcuCount"];
        }
    }

    static fromJS(data: any): DevicesSummaryVM {
        data = typeof data === 'object' ? data : {};
        let result = new DevicesSummaryVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dataLoggersCount"] = this.dataLoggersCount;
        data["assetTrackersCount"] = this.assetTrackersCount;
        data["aiCamerasCount"] = this.aiCamerasCount;
        data["nonAiCamerasCount"] = this.nonAiCamerasCount;
        data["oemTcuCount"] = this.oemTcuCount;
        return data;
    }
}

export interface IDevicesSummaryVM {
    dataLoggersCount: number;
    assetTrackersCount: number;
    aiCamerasCount: number;
    nonAiCamerasCount: number;
    oemTcuCount: number;
}

export class UiDataResponseOfEnvelopedModelOfDataLoggerVM extends UiResponse implements IUiDataResponseOfEnvelopedModelOfDataLoggerVM {
    data?: EnvelopedModelOfDataLoggerVM | undefined;

    constructor(data?: IUiDataResponseOfEnvelopedModelOfDataLoggerVM) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? EnvelopedModelOfDataLoggerVM.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UiDataResponseOfEnvelopedModelOfDataLoggerVM {
        data = typeof data === 'object' ? data : {};
        let result = new UiDataResponseOfEnvelopedModelOfDataLoggerVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IUiDataResponseOfEnvelopedModelOfDataLoggerVM extends IUiResponse {
    data?: EnvelopedModelOfDataLoggerVM | undefined;
}

export class EnvelopedModelOfDataLoggerVM implements IEnvelopedModelOfDataLoggerVM {
    rows?: DataLoggerVM[];
    totalItems?: number;

    constructor(data?: IEnvelopedModelOfDataLoggerVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(DataLoggerVM.fromJS(item));
            }
            this.totalItems = _data["totalItems"];
        }
    }

    static fromJS(data: any): EnvelopedModelOfDataLoggerVM {
        data = typeof data === 'object' ? data : {};
        let result = new EnvelopedModelOfDataLoggerVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        data["totalItems"] = this.totalItems;
        return data;
    }
}

export interface IEnvelopedModelOfDataLoggerVM {
    rows?: DataLoggerVM[];
    totalItems?: number;
}

export class DataLoggerVM implements IDataLoggerVM {
    deviceId!: number;
    vendorDeviceId!: string;
    vehicleId?: number | undefined;
    vehicleName?: string | undefined;
    deviceTypeId?: DeviceType | undefined;
    deviceVendorId?: number | undefined;
    activationDate?: Date | undefined;
    serialNumber?: string | undefined;
    imei?: string | undefined;
    simNumber?: string | undefined;
    productCode?: string | undefined;

    constructor(data?: IDataLoggerVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.deviceId = _data["deviceId"];
            this.vendorDeviceId = _data["vendorDeviceId"];
            this.vehicleId = _data["vehicleId"];
            this.vehicleName = _data["vehicleName"];
            this.deviceTypeId = _data["deviceTypeId"];
            this.deviceVendorId = _data["deviceVendorId"];
            this.activationDate = _data["activationDate"] ? new Date(_data["activationDate"].toString()) : <any>undefined;
            this.serialNumber = _data["serialNumber"];
            this.imei = _data["imei"];
            this.simNumber = _data["simNumber"];
            this.productCode = _data["productCode"];
        }
    }

    static fromJS(data: any): DataLoggerVM {
        data = typeof data === 'object' ? data : {};
        let result = new DataLoggerVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deviceId"] = this.deviceId;
        data["vendorDeviceId"] = this.vendorDeviceId;
        data["vehicleId"] = this.vehicleId;
        data["vehicleName"] = this.vehicleName;
        data["deviceTypeId"] = this.deviceTypeId;
        data["deviceVendorId"] = this.deviceVendorId;
        data["activationDate"] = this.activationDate ? this.activationDate.toISOString() : <any>undefined;
        data["serialNumber"] = this.serialNumber;
        data["imei"] = this.imei;
        data["simNumber"] = this.simNumber;
        data["productCode"] = this.productCode;
        return data;
    }
}

export interface IDataLoggerVM {
    deviceId: number;
    vendorDeviceId: string;
    vehicleId?: number | undefined;
    vehicleName?: string | undefined;
    deviceTypeId?: DeviceType | undefined;
    deviceVendorId?: number | undefined;
    activationDate?: Date | undefined;
    serialNumber?: string | undefined;
    imei?: string | undefined;
    simNumber?: string | undefined;
    productCode?: string | undefined;
}

export enum DeviceType {
    Unknown = 0,
    DataLogger = 1,
    SafetyCamera = 2,
    Sensor = 3,
    AssetTracker = 4,
    Oem = 5,
}

export class UiDataResponseOfEnvelopedModelOfAssetTrackerVM extends UiResponse implements IUiDataResponseOfEnvelopedModelOfAssetTrackerVM {
    data?: EnvelopedModelOfAssetTrackerVM | undefined;

    constructor(data?: IUiDataResponseOfEnvelopedModelOfAssetTrackerVM) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? EnvelopedModelOfAssetTrackerVM.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UiDataResponseOfEnvelopedModelOfAssetTrackerVM {
        data = typeof data === 'object' ? data : {};
        let result = new UiDataResponseOfEnvelopedModelOfAssetTrackerVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IUiDataResponseOfEnvelopedModelOfAssetTrackerVM extends IUiResponse {
    data?: EnvelopedModelOfAssetTrackerVM | undefined;
}

export class EnvelopedModelOfAssetTrackerVM implements IEnvelopedModelOfAssetTrackerVM {
    rows?: AssetTrackerVM[];
    totalItems?: number;

    constructor(data?: IEnvelopedModelOfAssetTrackerVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(AssetTrackerVM.fromJS(item));
            }
            this.totalItems = _data["totalItems"];
        }
    }

    static fromJS(data: any): EnvelopedModelOfAssetTrackerVM {
        data = typeof data === 'object' ? data : {};
        let result = new EnvelopedModelOfAssetTrackerVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        data["totalItems"] = this.totalItems;
        return data;
    }
}

export interface IEnvelopedModelOfAssetTrackerVM {
    rows?: AssetTrackerVM[];
    totalItems?: number;
}

export class AssetTrackerVM implements IAssetTrackerVM {
    deviceId!: number;
    vendorDeviceId!: string;
    assetId?: number | undefined;
    assetName?: string | undefined;
    deviceTypeId?: DeviceType | undefined;
    deviceVendorId?: number | undefined;
    activationDate?: Date | undefined;
    serialNumber?: string | undefined;
    imei?: string | undefined;
    simNumber?: string | undefined;
    productCode?: string | undefined;

    constructor(data?: IAssetTrackerVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.deviceId = _data["deviceId"];
            this.vendorDeviceId = _data["vendorDeviceId"];
            this.assetId = _data["assetId"];
            this.assetName = _data["assetName"];
            this.deviceTypeId = _data["deviceTypeId"];
            this.deviceVendorId = _data["deviceVendorId"];
            this.activationDate = _data["activationDate"] ? new Date(_data["activationDate"].toString()) : <any>undefined;
            this.serialNumber = _data["serialNumber"];
            this.imei = _data["imei"];
            this.simNumber = _data["simNumber"];
            this.productCode = _data["productCode"];
        }
    }

    static fromJS(data: any): AssetTrackerVM {
        data = typeof data === 'object' ? data : {};
        let result = new AssetTrackerVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deviceId"] = this.deviceId;
        data["vendorDeviceId"] = this.vendorDeviceId;
        data["assetId"] = this.assetId;
        data["assetName"] = this.assetName;
        data["deviceTypeId"] = this.deviceTypeId;
        data["deviceVendorId"] = this.deviceVendorId;
        data["activationDate"] = this.activationDate ? this.activationDate.toISOString() : <any>undefined;
        data["serialNumber"] = this.serialNumber;
        data["imei"] = this.imei;
        data["simNumber"] = this.simNumber;
        data["productCode"] = this.productCode;
        return data;
    }
}

export interface IAssetTrackerVM {
    deviceId: number;
    vendorDeviceId: string;
    assetId?: number | undefined;
    assetName?: string | undefined;
    deviceTypeId?: DeviceType | undefined;
    deviceVendorId?: number | undefined;
    activationDate?: Date | undefined;
    serialNumber?: string | undefined;
    imei?: string | undefined;
    simNumber?: string | undefined;
    productCode?: string | undefined;
}

export class UiDataResponseOfEnvelopedModelOfAiCameraVM extends UiResponse implements IUiDataResponseOfEnvelopedModelOfAiCameraVM {
    data?: EnvelopedModelOfAiCameraVM | undefined;

    constructor(data?: IUiDataResponseOfEnvelopedModelOfAiCameraVM) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? EnvelopedModelOfAiCameraVM.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UiDataResponseOfEnvelopedModelOfAiCameraVM {
        data = typeof data === 'object' ? data : {};
        let result = new UiDataResponseOfEnvelopedModelOfAiCameraVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IUiDataResponseOfEnvelopedModelOfAiCameraVM extends IUiResponse {
    data?: EnvelopedModelOfAiCameraVM | undefined;
}

export class EnvelopedModelOfAiCameraVM implements IEnvelopedModelOfAiCameraVM {
    rows?: AiCameraVM[];
    totalItems?: number;

    constructor(data?: IEnvelopedModelOfAiCameraVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(AiCameraVM.fromJS(item));
            }
            this.totalItems = _data["totalItems"];
        }
    }

    static fromJS(data: any): EnvelopedModelOfAiCameraVM {
        data = typeof data === 'object' ? data : {};
        let result = new EnvelopedModelOfAiCameraVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        data["totalItems"] = this.totalItems;
        return data;
    }
}

export interface IEnvelopedModelOfAiCameraVM {
    rows?: AiCameraVM[];
    totalItems?: number;
}

export class AiCameraVM implements IAiCameraVM {
    deviceId!: number;
    vendorDeviceId!: string;
    vehicleId?: number | undefined;
    vehicleName?: string | undefined;
    deviceTypeId?: DeviceType | undefined;
    deviceVendorId?: number | undefined;
    activationDate?: Date | undefined;
    serialNumber?: string | undefined;
    imei?: string | undefined;
    simNumber?: string | undefined;
    productCode?: string | undefined;
    actionsExecutingAvailable?: boolean;
    aiCameraAdditionalInfo?: AiCameraAdditionalInfoVM | undefined;

    constructor(data?: IAiCameraVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.deviceId = _data["deviceId"];
            this.vendorDeviceId = _data["vendorDeviceId"];
            this.vehicleId = _data["vehicleId"];
            this.vehicleName = _data["vehicleName"];
            this.deviceTypeId = _data["deviceTypeId"];
            this.deviceVendorId = _data["deviceVendorId"];
            this.activationDate = _data["activationDate"] ? new Date(_data["activationDate"].toString()) : <any>undefined;
            this.serialNumber = _data["serialNumber"];
            this.imei = _data["imei"];
            this.simNumber = _data["simNumber"];
            this.productCode = _data["productCode"];
            this.actionsExecutingAvailable = _data["actionsExecutingAvailable"];
            this.aiCameraAdditionalInfo = _data["aiCameraAdditionalInfo"] ? AiCameraAdditionalInfoVM.fromJS(_data["aiCameraAdditionalInfo"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AiCameraVM {
        data = typeof data === 'object' ? data : {};
        let result = new AiCameraVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deviceId"] = this.deviceId;
        data["vendorDeviceId"] = this.vendorDeviceId;
        data["vehicleId"] = this.vehicleId;
        data["vehicleName"] = this.vehicleName;
        data["deviceTypeId"] = this.deviceTypeId;
        data["deviceVendorId"] = this.deviceVendorId;
        data["activationDate"] = this.activationDate ? this.activationDate.toISOString() : <any>undefined;
        data["serialNumber"] = this.serialNumber;
        data["imei"] = this.imei;
        data["simNumber"] = this.simNumber;
        data["productCode"] = this.productCode;
        data["actionsExecutingAvailable"] = this.actionsExecutingAvailable;
        data["aiCameraAdditionalInfo"] = this.aiCameraAdditionalInfo ? this.aiCameraAdditionalInfo.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAiCameraVM {
    deviceId: number;
    vendorDeviceId: string;
    vehicleId?: number | undefined;
    vehicleName?: string | undefined;
    deviceTypeId?: DeviceType | undefined;
    deviceVendorId?: number | undefined;
    activationDate?: Date | undefined;
    serialNumber?: string | undefined;
    imei?: string | undefined;
    simNumber?: string | undefined;
    productCode?: string | undefined;
    actionsExecutingAvailable?: boolean;
    aiCameraAdditionalInfo?: AiCameraAdditionalInfoVM | undefined;
}

export class AiCameraAdditionalInfoVM implements IAiCameraAdditionalInfoVM {
    lastConnectedAt?: Date | undefined;
    lastRecordingUpdatedAt?: Date | undefined;
    recordingAvailabilityStatus!: AiCameraRecordingAvailabilityStatusVM;
    calibrationState!: AiCameraCalibrationStateVM;
    calibrationStateUpdatedAt?: Date | undefined;
    alarmDetail?: string | undefined;
    alarmRecommendation?: string | undefined;

    constructor(data?: IAiCameraAdditionalInfoVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lastConnectedAt = _data["lastConnectedAt"] ? new Date(_data["lastConnectedAt"].toString()) : <any>undefined;
            this.lastRecordingUpdatedAt = _data["lastRecordingUpdatedAt"] ? new Date(_data["lastRecordingUpdatedAt"].toString()) : <any>undefined;
            this.recordingAvailabilityStatus = _data["recordingAvailabilityStatus"];
            this.calibrationState = _data["calibrationState"];
            this.calibrationStateUpdatedAt = _data["calibrationStateUpdatedAt"] ? new Date(_data["calibrationStateUpdatedAt"].toString()) : <any>undefined;
            this.alarmDetail = _data["alarmDetail"];
            this.alarmRecommendation = _data["alarmRecommendation"];
        }
    }

    static fromJS(data: any): AiCameraAdditionalInfoVM {
        data = typeof data === 'object' ? data : {};
        let result = new AiCameraAdditionalInfoVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lastConnectedAt"] = this.lastConnectedAt ? this.lastConnectedAt.toISOString() : <any>undefined;
        data["lastRecordingUpdatedAt"] = this.lastRecordingUpdatedAt ? this.lastRecordingUpdatedAt.toISOString() : <any>undefined;
        data["recordingAvailabilityStatus"] = this.recordingAvailabilityStatus;
        data["calibrationState"] = this.calibrationState;
        data["calibrationStateUpdatedAt"] = this.calibrationStateUpdatedAt ? this.calibrationStateUpdatedAt.toISOString() : <any>undefined;
        data["alarmDetail"] = this.alarmDetail;
        data["alarmRecommendation"] = this.alarmRecommendation;
        return data;
    }
}

export interface IAiCameraAdditionalInfoVM {
    lastConnectedAt?: Date | undefined;
    lastRecordingUpdatedAt?: Date | undefined;
    recordingAvailabilityStatus: AiCameraRecordingAvailabilityStatusVM;
    calibrationState: AiCameraCalibrationStateVM;
    calibrationStateUpdatedAt?: Date | undefined;
    alarmDetail?: string | undefined;
    alarmRecommendation?: string | undefined;
}

export enum AiCameraRecordingAvailabilityStatusVM {
    Unknown = 0,
    Available = 1,
    NotAvailable = 2,
}

export enum AiCameraCalibrationStateVM {
    Unknown = 0,
    Calibrated = 1,
    NotCalibrated = 2,
}

export class UiDataResponseOfEnvelopedModelOfCameraVM extends UiResponse implements IUiDataResponseOfEnvelopedModelOfCameraVM {
    data?: EnvelopedModelOfCameraVM | undefined;

    constructor(data?: IUiDataResponseOfEnvelopedModelOfCameraVM) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? EnvelopedModelOfCameraVM.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UiDataResponseOfEnvelopedModelOfCameraVM {
        data = typeof data === 'object' ? data : {};
        let result = new UiDataResponseOfEnvelopedModelOfCameraVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IUiDataResponseOfEnvelopedModelOfCameraVM extends IUiResponse {
    data?: EnvelopedModelOfCameraVM | undefined;
}

export class EnvelopedModelOfCameraVM implements IEnvelopedModelOfCameraVM {
    rows?: CameraVM[];
    totalItems?: number;

    constructor(data?: IEnvelopedModelOfCameraVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(CameraVM.fromJS(item));
            }
            this.totalItems = _data["totalItems"];
        }
    }

    static fromJS(data: any): EnvelopedModelOfCameraVM {
        data = typeof data === 'object' ? data : {};
        let result = new EnvelopedModelOfCameraVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        data["totalItems"] = this.totalItems;
        return data;
    }
}

export interface IEnvelopedModelOfCameraVM {
    rows?: CameraVM[];
    totalItems?: number;
}

export class CameraVM implements ICameraVM {
    deviceId!: number;
    vendorDeviceId!: string;
    vehicleId?: number | undefined;
    vehicleName?: string | undefined;
    deviceTypeId?: DeviceType | undefined;
    deviceVendorId?: number | undefined;
    activationDate?: Date | undefined;
    serialNumber?: string | undefined;
    imei?: string | undefined;
    simNumber?: string | undefined;
    productCode?: string | undefined;

    constructor(data?: ICameraVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.deviceId = _data["deviceId"];
            this.vendorDeviceId = _data["vendorDeviceId"];
            this.vehicleId = _data["vehicleId"];
            this.vehicleName = _data["vehicleName"];
            this.deviceTypeId = _data["deviceTypeId"];
            this.deviceVendorId = _data["deviceVendorId"];
            this.activationDate = _data["activationDate"] ? new Date(_data["activationDate"].toString()) : <any>undefined;
            this.serialNumber = _data["serialNumber"];
            this.imei = _data["imei"];
            this.simNumber = _data["simNumber"];
            this.productCode = _data["productCode"];
        }
    }

    static fromJS(data: any): CameraVM {
        data = typeof data === 'object' ? data : {};
        let result = new CameraVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deviceId"] = this.deviceId;
        data["vendorDeviceId"] = this.vendorDeviceId;
        data["vehicleId"] = this.vehicleId;
        data["vehicleName"] = this.vehicleName;
        data["deviceTypeId"] = this.deviceTypeId;
        data["deviceVendorId"] = this.deviceVendorId;
        data["activationDate"] = this.activationDate ? this.activationDate.toISOString() : <any>undefined;
        data["serialNumber"] = this.serialNumber;
        data["imei"] = this.imei;
        data["simNumber"] = this.simNumber;
        data["productCode"] = this.productCode;
        return data;
    }
}

export interface ICameraVM {
    deviceId: number;
    vendorDeviceId: string;
    vehicleId?: number | undefined;
    vehicleName?: string | undefined;
    deviceTypeId?: DeviceType | undefined;
    deviceVendorId?: number | undefined;
    activationDate?: Date | undefined;
    serialNumber?: string | undefined;
    imei?: string | undefined;
    simNumber?: string | undefined;
    productCode?: string | undefined;
}

export class UiDataResponseOfEnvelopedModelOfCameraMinimalVM extends UiResponse implements IUiDataResponseOfEnvelopedModelOfCameraMinimalVM {
    data?: EnvelopedModelOfCameraMinimalVM | undefined;

    constructor(data?: IUiDataResponseOfEnvelopedModelOfCameraMinimalVM) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? EnvelopedModelOfCameraMinimalVM.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UiDataResponseOfEnvelopedModelOfCameraMinimalVM {
        data = typeof data === 'object' ? data : {};
        let result = new UiDataResponseOfEnvelopedModelOfCameraMinimalVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IUiDataResponseOfEnvelopedModelOfCameraMinimalVM extends IUiResponse {
    data?: EnvelopedModelOfCameraMinimalVM | undefined;
}

export class EnvelopedModelOfCameraMinimalVM implements IEnvelopedModelOfCameraMinimalVM {
    rows?: CameraMinimalVM[];
    totalItems?: number;

    constructor(data?: IEnvelopedModelOfCameraMinimalVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(CameraMinimalVM.fromJS(item));
            }
            this.totalItems = _data["totalItems"];
        }
    }

    static fromJS(data: any): EnvelopedModelOfCameraMinimalVM {
        data = typeof data === 'object' ? data : {};
        let result = new EnvelopedModelOfCameraMinimalVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        data["totalItems"] = this.totalItems;
        return data;
    }
}

export interface IEnvelopedModelOfCameraMinimalVM {
    rows?: CameraMinimalVM[];
    totalItems?: number;
}

export class CameraMinimalVM implements ICameraMinimalVM {
    id!: number;
    serialNumber!: string;
    vehicle?: IdNameVM | undefined;

    constructor(data?: ICameraMinimalVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.serialNumber = _data["serialNumber"];
            this.vehicle = _data["vehicle"] ? IdNameVM.fromJS(_data["vehicle"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CameraMinimalVM {
        data = typeof data === 'object' ? data : {};
        let result = new CameraMinimalVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["serialNumber"] = this.serialNumber;
        data["vehicle"] = this.vehicle ? this.vehicle.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICameraMinimalVM {
    id: number;
    serialNumber: string;
    vehicle?: IdNameVM | undefined;
}

export class UiDataResponseOfEnvelopedModelOfLiveMapTrackedResourceVM extends UiResponse implements IUiDataResponseOfEnvelopedModelOfLiveMapTrackedResourceVM {
    data?: EnvelopedModelOfLiveMapTrackedResourceVM | undefined;

    constructor(data?: IUiDataResponseOfEnvelopedModelOfLiveMapTrackedResourceVM) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? EnvelopedModelOfLiveMapTrackedResourceVM.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UiDataResponseOfEnvelopedModelOfLiveMapTrackedResourceVM {
        data = typeof data === 'object' ? data : {};
        let result = new UiDataResponseOfEnvelopedModelOfLiveMapTrackedResourceVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IUiDataResponseOfEnvelopedModelOfLiveMapTrackedResourceVM extends IUiResponse {
    data?: EnvelopedModelOfLiveMapTrackedResourceVM | undefined;
}

export class EnvelopedModelOfLiveMapTrackedResourceVM implements IEnvelopedModelOfLiveMapTrackedResourceVM {
    rows?: LiveMapTrackedResourceVM[];
    totalItems?: number;

    constructor(data?: IEnvelopedModelOfLiveMapTrackedResourceVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(LiveMapTrackedResourceVM.fromJS(item));
            }
            this.totalItems = _data["totalItems"];
        }
    }

    static fromJS(data: any): EnvelopedModelOfLiveMapTrackedResourceVM {
        data = typeof data === 'object' ? data : {};
        let result = new EnvelopedModelOfLiveMapTrackedResourceVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        data["totalItems"] = this.totalItems;
        return data;
    }
}

export interface IEnvelopedModelOfLiveMapTrackedResourceVM {
    rows?: LiveMapTrackedResourceVM[];
    totalItems?: number;
}

export class LiveMapTrackedResourceVM implements ILiveMapTrackedResourceVM {
    trackedResourceId!: number;
    trackedResourceName!: string;
    trackedResourceType!: TrackedResourceType;
    driverName?: string | undefined;
    driverId?: number | undefined;
    location!: CoordinatesVm;
    time!: Date;
    speed?: Speed | undefined;
    address?: string | undefined;
    groupName!: string;
    eventType!: string;
    geofenceName?: string | undefined;
    jobAssignment?: JobAssignmentVM | undefined;

    constructor(data?: ILiveMapTrackedResourceVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.location = new CoordinatesVm();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.trackedResourceId = _data["trackedResourceId"];
            this.trackedResourceName = _data["trackedResourceName"];
            this.trackedResourceType = _data["trackedResourceType"];
            this.driverName = _data["driverName"];
            this.driverId = _data["driverId"];
            this.location = _data["location"] ? CoordinatesVm.fromJS(_data["location"]) : new CoordinatesVm();
            this.time = _data["time"] ? new Date(_data["time"].toString()) : <any>undefined;
            this.speed = _data["speed"] ? Speed.fromJS(_data["speed"]) : <any>undefined;
            this.address = _data["address"];
            this.groupName = _data["groupName"];
            this.eventType = _data["eventType"];
            this.geofenceName = _data["geofenceName"];
            this.jobAssignment = _data["jobAssignment"] ? JobAssignmentVM.fromJS(_data["jobAssignment"]) : <any>undefined;
        }
    }

    static fromJS(data: any): LiveMapTrackedResourceVM {
        data = typeof data === 'object' ? data : {};
        let result = new LiveMapTrackedResourceVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["trackedResourceId"] = this.trackedResourceId;
        data["trackedResourceName"] = this.trackedResourceName;
        data["trackedResourceType"] = this.trackedResourceType;
        data["driverName"] = this.driverName;
        data["driverId"] = this.driverId;
        data["location"] = this.location ? this.location.toJSON() : <any>undefined;
        data["time"] = this.time ? this.time.toISOString() : <any>undefined;
        data["speed"] = this.speed ? this.speed.toJSON() : <any>undefined;
        data["address"] = this.address;
        data["groupName"] = this.groupName;
        data["eventType"] = this.eventType;
        data["geofenceName"] = this.geofenceName;
        data["jobAssignment"] = this.jobAssignment ? this.jobAssignment.toJSON() : <any>undefined;
        return data;
    }
}

export interface ILiveMapTrackedResourceVM {
    trackedResourceId: number;
    trackedResourceName: string;
    trackedResourceType: TrackedResourceType;
    driverName?: string | undefined;
    driverId?: number | undefined;
    location: CoordinatesVm;
    time: Date;
    speed?: Speed | undefined;
    address?: string | undefined;
    groupName: string;
    eventType: string;
    geofenceName?: string | undefined;
    jobAssignment?: JobAssignmentVM | undefined;
}

export class JobAssignmentVM implements IJobAssignmentVM {
    status!: JobAppointmentAssignmentStatusVm;
    jobTypeName!: string;
    jobId!: string;
    address?: string | undefined;
    location!: CoordinatesVm;
    startDate!: Date;
    technicianName!: string;
    jobNumber!: string;

    constructor(data?: IJobAssignmentVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.location = new CoordinatesVm();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.jobTypeName = _data["jobTypeName"];
            this.jobId = _data["jobId"];
            this.address = _data["address"];
            this.location = _data["location"] ? CoordinatesVm.fromJS(_data["location"]) : new CoordinatesVm();
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.technicianName = _data["technicianName"];
            this.jobNumber = _data["jobNumber"];
        }
    }

    static fromJS(data: any): JobAssignmentVM {
        data = typeof data === 'object' ? data : {};
        let result = new JobAssignmentVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["jobTypeName"] = this.jobTypeName;
        data["jobId"] = this.jobId;
        data["address"] = this.address;
        data["location"] = this.location ? this.location.toJSON() : <any>undefined;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["technicianName"] = this.technicianName;
        data["jobNumber"] = this.jobNumber;
        return data;
    }
}

export interface IJobAssignmentVM {
    status: JobAppointmentAssignmentStatusVm;
    jobTypeName: string;
    jobId: string;
    address?: string | undefined;
    location: CoordinatesVm;
    startDate: Date;
    technicianName: string;
    jobNumber: string;
}

export class WebLogEvent implements IWebLogEvent {
    category?: string | undefined;
    code?: string | undefined;
    message?: string;
    level?: LogLevel | undefined;
    data?: { [key: string]: any; } | undefined;
    exception?: FrontendException | undefined;

    constructor(data?: IWebLogEvent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.category = _data["category"];
            this.code = _data["code"];
            this.message = _data["message"];
            this.level = _data["level"];
            if (_data["data"]) {
                this.data = {} as any;
                for (let key in _data["data"]) {
                    if (_data["data"].hasOwnProperty(key))
                        (<any>this.data)![key] = _data["data"][key];
                }
            }
            this.exception = _data["exception"] ? FrontendException.fromJS(_data["exception"]) : <any>undefined;
        }
    }

    static fromJS(data: any): WebLogEvent {
        data = typeof data === 'object' ? data : {};
        let result = new WebLogEvent();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["category"] = this.category;
        data["code"] = this.code;
        data["message"] = this.message;
        data["level"] = this.level;
        if (this.data) {
            data["data"] = {};
            for (let key in this.data) {
                if (this.data.hasOwnProperty(key))
                    (<any>data["data"])[key] = (<any>this.data)[key];
            }
        }
        data["exception"] = this.exception ? this.exception.toJSON() : <any>undefined;
        return data;
    }
}

export interface IWebLogEvent {
    category?: string | undefined;
    code?: string | undefined;
    message?: string;
    level?: LogLevel | undefined;
    data?: { [key: string]: any; } | undefined;
    exception?: FrontendException | undefined;
}

/** Event log level */
export enum LogLevel {
    Debug = 0,
    Info = 1,
    Warning = 2,
    Error = 3,
}

export class FrontendException implements IFrontendException {
    message?: string;
    stackTrace?: string;

    constructor(data?: IFrontendException) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"];
            this.stackTrace = _data["stackTrace"];
        }
    }

    static fromJS(data: any): FrontendException {
        data = typeof data === 'object' ? data : {};
        let result = new FrontendException();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        data["stackTrace"] = this.stackTrace;
        return data;
    }
}

export interface IFrontendException {
    message?: string;
    stackTrace?: string;
}

export class UiDataResponseOfEnvelopedModelOfMaintenanceServiceEntryGridVm extends UiResponse implements IUiDataResponseOfEnvelopedModelOfMaintenanceServiceEntryGridVm {
    data?: EnvelopedModelOfMaintenanceServiceEntryGridVm | undefined;

    constructor(data?: IUiDataResponseOfEnvelopedModelOfMaintenanceServiceEntryGridVm) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? EnvelopedModelOfMaintenanceServiceEntryGridVm.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UiDataResponseOfEnvelopedModelOfMaintenanceServiceEntryGridVm {
        data = typeof data === 'object' ? data : {};
        let result = new UiDataResponseOfEnvelopedModelOfMaintenanceServiceEntryGridVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IUiDataResponseOfEnvelopedModelOfMaintenanceServiceEntryGridVm extends IUiResponse {
    data?: EnvelopedModelOfMaintenanceServiceEntryGridVm | undefined;
}

export class EnvelopedModelOfMaintenanceServiceEntryGridVm implements IEnvelopedModelOfMaintenanceServiceEntryGridVm {
    rows?: MaintenanceServiceEntryGridVm[];
    totalItems?: number;

    constructor(data?: IEnvelopedModelOfMaintenanceServiceEntryGridVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(MaintenanceServiceEntryGridVm.fromJS(item));
            }
            this.totalItems = _data["totalItems"];
        }
    }

    static fromJS(data: any): EnvelopedModelOfMaintenanceServiceEntryGridVm {
        data = typeof data === 'object' ? data : {};
        let result = new EnvelopedModelOfMaintenanceServiceEntryGridVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        data["totalItems"] = this.totalItems;
        return data;
    }
}

export interface IEnvelopedModelOfMaintenanceServiceEntryGridVm {
    rows?: MaintenanceServiceEntryGridVm[];
    totalItems?: number;
}

export class MaintenanceServiceEntryGridVm implements IMaintenanceServiceEntryGridVm {
    id!: number;
    trackedResourceName?: string | undefined;
    isTrackedResourceRemoved?: boolean | undefined;
    groupName?: string | undefined;
    serviceTypes!: string[];
    serviceDate!: Date;
    category!: ServiceEntryCategory;
    odometerInMiles?: number | undefined;
    engineRunTimeInHours?: number | undefined;
    invoiceNumber?: string | undefined;
    totalCost!: number;
    state!: ServiceEntryState;

    constructor(data?: IMaintenanceServiceEntryGridVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.serviceTypes = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.trackedResourceName = _data["trackedResourceName"];
            this.isTrackedResourceRemoved = _data["isTrackedResourceRemoved"];
            this.groupName = _data["groupName"];
            if (Array.isArray(_data["serviceTypes"])) {
                this.serviceTypes = [] as any;
                for (let item of _data["serviceTypes"])
                    this.serviceTypes!.push(item);
            }
            this.serviceDate = _data["serviceDate"] ? new Date(_data["serviceDate"].toString()) : <any>undefined;
            this.category = _data["category"];
            this.odometerInMiles = _data["odometerInMiles"];
            this.engineRunTimeInHours = _data["engineRunTimeInHours"];
            this.invoiceNumber = _data["invoiceNumber"];
            this.totalCost = _data["totalCost"];
            this.state = _data["state"];
        }
    }

    static fromJS(data: any): MaintenanceServiceEntryGridVm {
        data = typeof data === 'object' ? data : {};
        let result = new MaintenanceServiceEntryGridVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["trackedResourceName"] = this.trackedResourceName;
        data["isTrackedResourceRemoved"] = this.isTrackedResourceRemoved;
        data["groupName"] = this.groupName;
        if (Array.isArray(this.serviceTypes)) {
            data["serviceTypes"] = [];
            for (let item of this.serviceTypes)
                data["serviceTypes"].push(item);
        }
        data["serviceDate"] = this.serviceDate ? formatDate(this.serviceDate) : <any>undefined;
        data["category"] = this.category;
        data["odometerInMiles"] = this.odometerInMiles;
        data["engineRunTimeInHours"] = this.engineRunTimeInHours;
        data["invoiceNumber"] = this.invoiceNumber;
        data["totalCost"] = this.totalCost;
        data["state"] = this.state;
        return data;
    }
}

export interface IMaintenanceServiceEntryGridVm {
    id: number;
    trackedResourceName?: string | undefined;
    isTrackedResourceRemoved?: boolean | undefined;
    groupName?: string | undefined;
    serviceTypes: string[];
    serviceDate: Date;
    category: ServiceEntryCategory;
    odometerInMiles?: number | undefined;
    engineRunTimeInHours?: number | undefined;
    invoiceNumber?: string | undefined;
    totalCost: number;
    state: ServiceEntryState;
}

export enum ServiceEntryCategory {
    Unscheduled = 1,
    Scheduled = 2,
    Repairs = 3,
}

export enum ServiceEntryState {
    Active = 1,
    Archived = 2,
}

export class UiDataResponseOfMaintenanceServiceEntryDetailsVm extends UiResponse implements IUiDataResponseOfMaintenanceServiceEntryDetailsVm {
    data?: MaintenanceServiceEntryDetailsVm | undefined;

    constructor(data?: IUiDataResponseOfMaintenanceServiceEntryDetailsVm) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? MaintenanceServiceEntryDetailsVm.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UiDataResponseOfMaintenanceServiceEntryDetailsVm {
        data = typeof data === 'object' ? data : {};
        let result = new UiDataResponseOfMaintenanceServiceEntryDetailsVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IUiDataResponseOfMaintenanceServiceEntryDetailsVm extends IUiResponse {
    data?: MaintenanceServiceEntryDetailsVm | undefined;
}

export class MaintenanceServiceEntryDetailsVm implements IMaintenanceServiceEntryDetailsVm {
    id!: number;
    serviceTypes!: string[];
    serviceDate!: Date;
    category!: ServiceEntryCategory;
    odometerInMiles?: number | undefined;
    engineRunTimeInHours?: number | undefined;
    invoiceNumber?: string | undefined;
    totalCost!: number;
    state!: ServiceEntryState;
    serviceCenter?: string | undefined;
    notes?: string | undefined;
    serviceRecords!: MaintenanceServiceRecordVm[];
    fileAttachments?: FileAttachmentVm[] | undefined;
    trackedResourceName?: string | undefined;
    isTrackedResourceRemoved?: boolean | undefined;
    groupName?: string | undefined;

    constructor(data?: IMaintenanceServiceEntryDetailsVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.serviceTypes = [];
            this.serviceRecords = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["serviceTypes"])) {
                this.serviceTypes = [] as any;
                for (let item of _data["serviceTypes"])
                    this.serviceTypes!.push(item);
            }
            this.serviceDate = _data["serviceDate"] ? new Date(_data["serviceDate"].toString()) : <any>undefined;
            this.category = _data["category"];
            this.odometerInMiles = _data["odometerInMiles"];
            this.engineRunTimeInHours = _data["engineRunTimeInHours"];
            this.invoiceNumber = _data["invoiceNumber"];
            this.totalCost = _data["totalCost"];
            this.state = _data["state"];
            this.serviceCenter = _data["serviceCenter"];
            this.notes = _data["notes"];
            if (Array.isArray(_data["serviceRecords"])) {
                this.serviceRecords = [] as any;
                for (let item of _data["serviceRecords"])
                    this.serviceRecords!.push(MaintenanceServiceRecordVm.fromJS(item));
            }
            if (Array.isArray(_data["fileAttachments"])) {
                this.fileAttachments = [] as any;
                for (let item of _data["fileAttachments"])
                    this.fileAttachments!.push(FileAttachmentVm.fromJS(item));
            }
            this.trackedResourceName = _data["trackedResourceName"];
            this.isTrackedResourceRemoved = _data["isTrackedResourceRemoved"];
            this.groupName = _data["groupName"];
        }
    }

    static fromJS(data: any): MaintenanceServiceEntryDetailsVm {
        data = typeof data === 'object' ? data : {};
        let result = new MaintenanceServiceEntryDetailsVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.serviceTypes)) {
            data["serviceTypes"] = [];
            for (let item of this.serviceTypes)
                data["serviceTypes"].push(item);
        }
        data["serviceDate"] = this.serviceDate ? formatDate(this.serviceDate) : <any>undefined;
        data["category"] = this.category;
        data["odometerInMiles"] = this.odometerInMiles;
        data["engineRunTimeInHours"] = this.engineRunTimeInHours;
        data["invoiceNumber"] = this.invoiceNumber;
        data["totalCost"] = this.totalCost;
        data["state"] = this.state;
        data["serviceCenter"] = this.serviceCenter;
        data["notes"] = this.notes;
        if (Array.isArray(this.serviceRecords)) {
            data["serviceRecords"] = [];
            for (let item of this.serviceRecords)
                data["serviceRecords"].push(item.toJSON());
        }
        if (Array.isArray(this.fileAttachments)) {
            data["fileAttachments"] = [];
            for (let item of this.fileAttachments)
                data["fileAttachments"].push(item.toJSON());
        }
        data["trackedResourceName"] = this.trackedResourceName;
        data["isTrackedResourceRemoved"] = this.isTrackedResourceRemoved;
        data["groupName"] = this.groupName;
        return data;
    }
}

export interface IMaintenanceServiceEntryDetailsVm {
    id: number;
    serviceTypes: string[];
    serviceDate: Date;
    category: ServiceEntryCategory;
    odometerInMiles?: number | undefined;
    engineRunTimeInHours?: number | undefined;
    invoiceNumber?: string | undefined;
    totalCost: number;
    state: ServiceEntryState;
    serviceCenter?: string | undefined;
    notes?: string | undefined;
    serviceRecords: MaintenanceServiceRecordVm[];
    fileAttachments?: FileAttachmentVm[] | undefined;
    trackedResourceName?: string | undefined;
    isTrackedResourceRemoved?: boolean | undefined;
    groupName?: string | undefined;
}

export class MaintenanceServiceRecordVm implements IMaintenanceServiceRecordVm {
    id!: number;
    serviceTypeId!: number;
    serviceType!: string;
    cost!: number;

    constructor(data?: IMaintenanceServiceRecordVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.serviceTypeId = _data["serviceTypeId"];
            this.serviceType = _data["serviceType"];
            this.cost = _data["cost"];
        }
    }

    static fromJS(data: any): MaintenanceServiceRecordVm {
        data = typeof data === 'object' ? data : {};
        let result = new MaintenanceServiceRecordVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["serviceTypeId"] = this.serviceTypeId;
        data["serviceType"] = this.serviceType;
        data["cost"] = this.cost;
        return data;
    }
}

export interface IMaintenanceServiceRecordVm {
    id: number;
    serviceTypeId: number;
    serviceType: string;
    cost: number;
}

export class FileAttachmentVm implements IFileAttachmentVm {
    id!: number;
    name!: string;

    constructor(data?: IFileAttachmentVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): FileAttachmentVm {
        data = typeof data === 'object' ? data : {};
        let result = new FileAttachmentVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IFileAttachmentVm {
    id: number;
    name: string;
}

export class MaintenanceServiceEntryCreateVm implements IMaintenanceServiceEntryCreateVm {
    serviceDate!: Date;
    category!: ServiceEntryCategory;
    odometerInMiles?: number | undefined;
    engineRunTimeInHours?: number | undefined;
    invoiceNumber?: string | undefined;
    serviceCenter?: string | undefined;
    notes?: string | undefined;
    state!: ServiceEntryState;
    serviceRecords!: MaintenanceServiceRecordUpsertVm[];
    trackedResourceId!: number;
    fileAttachments?: FileAttachmentCreateVm[] | undefined;

    constructor(data?: IMaintenanceServiceEntryCreateVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.serviceRecords = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serviceDate = _data["serviceDate"] ? new Date(_data["serviceDate"].toString()) : <any>undefined;
            this.category = _data["category"];
            this.odometerInMiles = _data["odometerInMiles"];
            this.engineRunTimeInHours = _data["engineRunTimeInHours"];
            this.invoiceNumber = _data["invoiceNumber"];
            this.serviceCenter = _data["serviceCenter"];
            this.notes = _data["notes"];
            this.state = _data["state"];
            if (Array.isArray(_data["serviceRecords"])) {
                this.serviceRecords = [] as any;
                for (let item of _data["serviceRecords"])
                    this.serviceRecords!.push(MaintenanceServiceRecordUpsertVm.fromJS(item));
            }
            this.trackedResourceId = _data["trackedResourceId"];
            if (Array.isArray(_data["fileAttachments"])) {
                this.fileAttachments = [] as any;
                for (let item of _data["fileAttachments"])
                    this.fileAttachments!.push(FileAttachmentCreateVm.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MaintenanceServiceEntryCreateVm {
        data = typeof data === 'object' ? data : {};
        let result = new MaintenanceServiceEntryCreateVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serviceDate"] = this.serviceDate ? formatDate(this.serviceDate) : <any>undefined;
        data["category"] = this.category;
        data["odometerInMiles"] = this.odometerInMiles;
        data["engineRunTimeInHours"] = this.engineRunTimeInHours;
        data["invoiceNumber"] = this.invoiceNumber;
        data["serviceCenter"] = this.serviceCenter;
        data["notes"] = this.notes;
        data["state"] = this.state;
        if (Array.isArray(this.serviceRecords)) {
            data["serviceRecords"] = [];
            for (let item of this.serviceRecords)
                data["serviceRecords"].push(item.toJSON());
        }
        data["trackedResourceId"] = this.trackedResourceId;
        if (Array.isArray(this.fileAttachments)) {
            data["fileAttachments"] = [];
            for (let item of this.fileAttachments)
                data["fileAttachments"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMaintenanceServiceEntryCreateVm {
    serviceDate: Date;
    category: ServiceEntryCategory;
    odometerInMiles?: number | undefined;
    engineRunTimeInHours?: number | undefined;
    invoiceNumber?: string | undefined;
    serviceCenter?: string | undefined;
    notes?: string | undefined;
    state: ServiceEntryState;
    serviceRecords: MaintenanceServiceRecordUpsertVm[];
    trackedResourceId: number;
    fileAttachments?: FileAttachmentCreateVm[] | undefined;
}

export class MaintenanceServiceRecordUpsertVm implements IMaintenanceServiceRecordUpsertVm {
    id?: number | undefined;
    serviceTypeId?: number | undefined;
    serviceType!: string;
    cost!: number;

    constructor(data?: IMaintenanceServiceRecordUpsertVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.serviceTypeId = _data["serviceTypeId"];
            this.serviceType = _data["serviceType"];
            this.cost = _data["cost"];
        }
    }

    static fromJS(data: any): MaintenanceServiceRecordUpsertVm {
        data = typeof data === 'object' ? data : {};
        let result = new MaintenanceServiceRecordUpsertVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["serviceTypeId"] = this.serviceTypeId;
        data["serviceType"] = this.serviceType;
        data["cost"] = this.cost;
        return data;
    }
}

export interface IMaintenanceServiceRecordUpsertVm {
    id?: number | undefined;
    serviceTypeId?: number | undefined;
    serviceType: string;
    cost: number;
}

export class FileAttachmentCreateVm implements IFileAttachmentCreateVm {
    uploadId!: string;
    name!: string;

    constructor(data?: IFileAttachmentCreateVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uploadId = _data["uploadId"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): FileAttachmentCreateVm {
        data = typeof data === 'object' ? data : {};
        let result = new FileAttachmentCreateVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uploadId"] = this.uploadId;
        data["name"] = this.name;
        return data;
    }
}

export interface IFileAttachmentCreateVm {
    uploadId: string;
    name: string;
}

export class MaintenanceServiceEntryUpdateVm implements IMaintenanceServiceEntryUpdateVm {
    serviceDate!: Date;
    category!: ServiceEntryCategory;
    odometerInMiles?: number | undefined;
    engineRunTimeInHours?: number | undefined;
    invoiceNumber?: string | undefined;
    serviceCenter?: string | undefined;
    notes?: string | undefined;
    state!: ServiceEntryState;
    serviceRecords!: MaintenanceServiceRecordUpsertVm[];
    id!: number;
    trackedResourceId!: number;
    fileAttachments?: FileAttachmentUpsertVm[] | undefined;

    constructor(data?: IMaintenanceServiceEntryUpdateVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.serviceRecords = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serviceDate = _data["serviceDate"] ? new Date(_data["serviceDate"].toString()) : <any>undefined;
            this.category = _data["category"];
            this.odometerInMiles = _data["odometerInMiles"];
            this.engineRunTimeInHours = _data["engineRunTimeInHours"];
            this.invoiceNumber = _data["invoiceNumber"];
            this.serviceCenter = _data["serviceCenter"];
            this.notes = _data["notes"];
            this.state = _data["state"];
            if (Array.isArray(_data["serviceRecords"])) {
                this.serviceRecords = [] as any;
                for (let item of _data["serviceRecords"])
                    this.serviceRecords!.push(MaintenanceServiceRecordUpsertVm.fromJS(item));
            }
            this.id = _data["id"];
            this.trackedResourceId = _data["trackedResourceId"];
            if (Array.isArray(_data["fileAttachments"])) {
                this.fileAttachments = [] as any;
                for (let item of _data["fileAttachments"])
                    this.fileAttachments!.push(FileAttachmentUpsertVm.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MaintenanceServiceEntryUpdateVm {
        data = typeof data === 'object' ? data : {};
        let result = new MaintenanceServiceEntryUpdateVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serviceDate"] = this.serviceDate ? formatDate(this.serviceDate) : <any>undefined;
        data["category"] = this.category;
        data["odometerInMiles"] = this.odometerInMiles;
        data["engineRunTimeInHours"] = this.engineRunTimeInHours;
        data["invoiceNumber"] = this.invoiceNumber;
        data["serviceCenter"] = this.serviceCenter;
        data["notes"] = this.notes;
        data["state"] = this.state;
        if (Array.isArray(this.serviceRecords)) {
            data["serviceRecords"] = [];
            for (let item of this.serviceRecords)
                data["serviceRecords"].push(item.toJSON());
        }
        data["id"] = this.id;
        data["trackedResourceId"] = this.trackedResourceId;
        if (Array.isArray(this.fileAttachments)) {
            data["fileAttachments"] = [];
            for (let item of this.fileAttachments)
                data["fileAttachments"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMaintenanceServiceEntryUpdateVm {
    serviceDate: Date;
    category: ServiceEntryCategory;
    odometerInMiles?: number | undefined;
    engineRunTimeInHours?: number | undefined;
    invoiceNumber?: string | undefined;
    serviceCenter?: string | undefined;
    notes?: string | undefined;
    state: ServiceEntryState;
    serviceRecords: MaintenanceServiceRecordUpsertVm[];
    id: number;
    trackedResourceId: number;
    fileAttachments?: FileAttachmentUpsertVm[] | undefined;
}

export class FileAttachmentUpsertVm implements IFileAttachmentUpsertVm {
    id?: number | undefined;
    uploadId?: string | undefined;
    name!: string;

    constructor(data?: IFileAttachmentUpsertVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.uploadId = _data["uploadId"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): FileAttachmentUpsertVm {
        data = typeof data === 'object' ? data : {};
        let result = new FileAttachmentUpsertVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["uploadId"] = this.uploadId;
        data["name"] = this.name;
        return data;
    }
}

export interface IFileAttachmentUpsertVm {
    id?: number | undefined;
    uploadId?: string | undefined;
    name: string;
}

export class UiDataResponseOfEnvelopedModelOfFileUploadResultVm extends UiResponse implements IUiDataResponseOfEnvelopedModelOfFileUploadResultVm {
    data?: EnvelopedModelOfFileUploadResultVm | undefined;

    constructor(data?: IUiDataResponseOfEnvelopedModelOfFileUploadResultVm) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? EnvelopedModelOfFileUploadResultVm.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UiDataResponseOfEnvelopedModelOfFileUploadResultVm {
        data = typeof data === 'object' ? data : {};
        let result = new UiDataResponseOfEnvelopedModelOfFileUploadResultVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IUiDataResponseOfEnvelopedModelOfFileUploadResultVm extends IUiResponse {
    data?: EnvelopedModelOfFileUploadResultVm | undefined;
}

export class EnvelopedModelOfFileUploadResultVm implements IEnvelopedModelOfFileUploadResultVm {
    rows?: FileUploadResultVm[];
    totalItems?: number;

    constructor(data?: IEnvelopedModelOfFileUploadResultVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(FileUploadResultVm.fromJS(item));
            }
            this.totalItems = _data["totalItems"];
        }
    }

    static fromJS(data: any): EnvelopedModelOfFileUploadResultVm {
        data = typeof data === 'object' ? data : {};
        let result = new EnvelopedModelOfFileUploadResultVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        data["totalItems"] = this.totalItems;
        return data;
    }
}

export interface IEnvelopedModelOfFileUploadResultVm {
    rows?: FileUploadResultVm[];
    totalItems?: number;
}

export class FileUploadResultVm implements IFileUploadResultVm {
    uploadId!: string;
    name!: string;

    constructor(data?: IFileUploadResultVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uploadId = _data["uploadId"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): FileUploadResultVm {
        data = typeof data === 'object' ? data : {};
        let result = new FileUploadResultVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uploadId"] = this.uploadId;
        data["name"] = this.name;
        return data;
    }
}

export interface IFileUploadResultVm {
    uploadId: string;
    name: string;
}

export class UiDataResponseOfJobSiteVisitResponseVm extends UiResponse implements IUiDataResponseOfJobSiteVisitResponseVm {
    data?: JobSiteVisitResponseVm | undefined;

    constructor(data?: IUiDataResponseOfJobSiteVisitResponseVm) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? JobSiteVisitResponseVm.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UiDataResponseOfJobSiteVisitResponseVm {
        data = typeof data === 'object' ? data : {};
        let result = new UiDataResponseOfJobSiteVisitResponseVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IUiDataResponseOfJobSiteVisitResponseVm extends IUiResponse {
    data?: JobSiteVisitResponseVm | undefined;
}

export class JobSiteVisitResponseVm implements IJobSiteVisitResponseVm {
    summary!: JobSiteVisitSummaryVm;
    jobSites!: EnvelopedModelOfJobSiteVm;
    jobSiteVisits!: EnvelopedModelOfJobSiteVisitVm;

    constructor(data?: IJobSiteVisitResponseVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.summary = new JobSiteVisitSummaryVm();
            this.jobSites = new EnvelopedModelOfJobSiteVm();
            this.jobSiteVisits = new EnvelopedModelOfJobSiteVisitVm();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.summary = _data["summary"] ? JobSiteVisitSummaryVm.fromJS(_data["summary"]) : new JobSiteVisitSummaryVm();
            this.jobSites = _data["jobSites"] ? EnvelopedModelOfJobSiteVm.fromJS(_data["jobSites"]) : new EnvelopedModelOfJobSiteVm();
            this.jobSiteVisits = _data["jobSiteVisits"] ? EnvelopedModelOfJobSiteVisitVm.fromJS(_data["jobSiteVisits"]) : new EnvelopedModelOfJobSiteVisitVm();
        }
    }

    static fromJS(data: any): JobSiteVisitResponseVm {
        data = typeof data === 'object' ? data : {};
        let result = new JobSiteVisitResponseVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["summary"] = this.summary ? this.summary.toJSON() : <any>undefined;
        data["jobSites"] = this.jobSites ? this.jobSites.toJSON() : <any>undefined;
        data["jobSiteVisits"] = this.jobSiteVisits ? this.jobSiteVisits.toJSON() : <any>undefined;
        return data;
    }
}

export interface IJobSiteVisitResponseVm {
    summary: JobSiteVisitSummaryVm;
    jobSites: EnvelopedModelOfJobSiteVm;
    jobSiteVisits: EnvelopedModelOfJobSiteVisitVm;
}

export class JobSiteVisitSummaryVm implements IJobSiteVisitSummaryVm {
    jobCount!: number;
    jobVisitedCount!: number;
    jobNotVisitedCount!: number;
    averageTimeOnSiteSeconds?: number | undefined;
    totalIdlingOnSiteSeconds?: number | undefined;
    averageVisitsPerJob?: number | undefined;
    multipleVisitsPercentage?: number | undefined;

    constructor(data?: IJobSiteVisitSummaryVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jobCount = _data["jobCount"];
            this.jobVisitedCount = _data["jobVisitedCount"];
            this.jobNotVisitedCount = _data["jobNotVisitedCount"];
            this.averageTimeOnSiteSeconds = _data["averageTimeOnSiteSeconds"];
            this.totalIdlingOnSiteSeconds = _data["totalIdlingOnSiteSeconds"];
            this.averageVisitsPerJob = _data["averageVisitsPerJob"];
            this.multipleVisitsPercentage = _data["multipleVisitsPercentage"];
        }
    }

    static fromJS(data: any): JobSiteVisitSummaryVm {
        data = typeof data === 'object' ? data : {};
        let result = new JobSiteVisitSummaryVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobCount"] = this.jobCount;
        data["jobVisitedCount"] = this.jobVisitedCount;
        data["jobNotVisitedCount"] = this.jobNotVisitedCount;
        data["averageTimeOnSiteSeconds"] = this.averageTimeOnSiteSeconds;
        data["totalIdlingOnSiteSeconds"] = this.totalIdlingOnSiteSeconds;
        data["averageVisitsPerJob"] = this.averageVisitsPerJob;
        data["multipleVisitsPercentage"] = this.multipleVisitsPercentage;
        return data;
    }
}

export interface IJobSiteVisitSummaryVm {
    jobCount: number;
    jobVisitedCount: number;
    jobNotVisitedCount: number;
    averageTimeOnSiteSeconds?: number | undefined;
    totalIdlingOnSiteSeconds?: number | undefined;
    averageVisitsPerJob?: number | undefined;
    multipleVisitsPercentage?: number | undefined;
}

export class EnvelopedModelOfJobSiteVm implements IEnvelopedModelOfJobSiteVm {
    rows?: JobSiteVm[];
    totalItems?: number;

    constructor(data?: IEnvelopedModelOfJobSiteVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(JobSiteVm.fromJS(item));
            }
            this.totalItems = _data["totalItems"];
        }
    }

    static fromJS(data: any): EnvelopedModelOfJobSiteVm {
        data = typeof data === 'object' ? data : {};
        let result = new EnvelopedModelOfJobSiteVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        data["totalItems"] = this.totalItems;
        return data;
    }
}

export interface IEnvelopedModelOfJobSiteVm {
    rows?: JobSiteVm[];
    totalItems?: number;
}

export class JobSiteVm implements IJobSiteVm {
    jobId!: string;
    jobNumber!: string;
    jobAppointmentAddress!: string;
    customerName!: string;
    serviceType!: string;
    visitedVehicleNames!: string[];
    visitedDriverNames!: string[];
    firstArrival?: Date | undefined;
    lastDeparture?: Date | undefined;
    timeOnSiteSeconds!: number;
    idlingTimeSeconds!: number;
    visitCount!: number;
    outcome!: JobSiteVisitOutcomeVm;

    constructor(data?: IJobSiteVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.visitedVehicleNames = [];
            this.visitedDriverNames = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jobId = _data["jobId"];
            this.jobNumber = _data["jobNumber"];
            this.jobAppointmentAddress = _data["jobAppointmentAddress"];
            this.customerName = _data["customerName"];
            this.serviceType = _data["serviceType"];
            if (Array.isArray(_data["visitedVehicleNames"])) {
                this.visitedVehicleNames = [] as any;
                for (let item of _data["visitedVehicleNames"])
                    this.visitedVehicleNames!.push(item);
            }
            if (Array.isArray(_data["visitedDriverNames"])) {
                this.visitedDriverNames = [] as any;
                for (let item of _data["visitedDriverNames"])
                    this.visitedDriverNames!.push(item);
            }
            this.firstArrival = _data["firstArrival"] ? new Date(_data["firstArrival"].toString()) : <any>undefined;
            this.lastDeparture = _data["lastDeparture"] ? new Date(_data["lastDeparture"].toString()) : <any>undefined;
            this.timeOnSiteSeconds = _data["timeOnSiteSeconds"];
            this.idlingTimeSeconds = _data["idlingTimeSeconds"];
            this.visitCount = _data["visitCount"];
            this.outcome = _data["outcome"];
        }
    }

    static fromJS(data: any): JobSiteVm {
        data = typeof data === 'object' ? data : {};
        let result = new JobSiteVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobId"] = this.jobId;
        data["jobNumber"] = this.jobNumber;
        data["jobAppointmentAddress"] = this.jobAppointmentAddress;
        data["customerName"] = this.customerName;
        data["serviceType"] = this.serviceType;
        if (Array.isArray(this.visitedVehicleNames)) {
            data["visitedVehicleNames"] = [];
            for (let item of this.visitedVehicleNames)
                data["visitedVehicleNames"].push(item);
        }
        if (Array.isArray(this.visitedDriverNames)) {
            data["visitedDriverNames"] = [];
            for (let item of this.visitedDriverNames)
                data["visitedDriverNames"].push(item);
        }
        data["firstArrival"] = this.firstArrival ? this.firstArrival.toISOString() : <any>undefined;
        data["lastDeparture"] = this.lastDeparture ? this.lastDeparture.toISOString() : <any>undefined;
        data["timeOnSiteSeconds"] = this.timeOnSiteSeconds;
        data["idlingTimeSeconds"] = this.idlingTimeSeconds;
        data["visitCount"] = this.visitCount;
        data["outcome"] = this.outcome;
        return data;
    }
}

export interface IJobSiteVm {
    jobId: string;
    jobNumber: string;
    jobAppointmentAddress: string;
    customerName: string;
    serviceType: string;
    visitedVehicleNames: string[];
    visitedDriverNames: string[];
    firstArrival?: Date | undefined;
    lastDeparture?: Date | undefined;
    timeOnSiteSeconds: number;
    idlingTimeSeconds: number;
    visitCount: number;
    outcome: JobSiteVisitOutcomeVm;
}

export enum JobSiteVisitOutcomeVm {
    Visited = 1,
    NotVisited = 2,
}

export class EnvelopedModelOfJobSiteVisitVm implements IEnvelopedModelOfJobSiteVisitVm {
    rows?: JobSiteVisitVm[];
    totalItems?: number;

    constructor(data?: IEnvelopedModelOfJobSiteVisitVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(JobSiteVisitVm.fromJS(item));
            }
            this.totalItems = _data["totalItems"];
        }
    }

    static fromJS(data: any): EnvelopedModelOfJobSiteVisitVm {
        data = typeof data === 'object' ? data : {};
        let result = new EnvelopedModelOfJobSiteVisitVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        data["totalItems"] = this.totalItems;
        return data;
    }
}

export interface IEnvelopedModelOfJobSiteVisitVm {
    rows?: JobSiteVisitVm[];
    totalItems?: number;
}

export class JobSiteVisitVm implements IJobSiteVisitVm {
    jobId!: string;
    jobNumber!: string;
    vehicleName!: string;
    driverName?: string | undefined;
    arrival!: Date;
    departure!: Date;
    durationSeconds!: number;
    idlingTimeSeconds!: number;
    visitNumber!: number;

    constructor(data?: IJobSiteVisitVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jobId = _data["jobId"];
            this.jobNumber = _data["jobNumber"];
            this.vehicleName = _data["vehicleName"];
            this.driverName = _data["driverName"];
            this.arrival = _data["arrival"] ? new Date(_data["arrival"].toString()) : <any>undefined;
            this.departure = _data["departure"] ? new Date(_data["departure"].toString()) : <any>undefined;
            this.durationSeconds = _data["durationSeconds"];
            this.idlingTimeSeconds = _data["idlingTimeSeconds"];
            this.visitNumber = _data["visitNumber"];
        }
    }

    static fromJS(data: any): JobSiteVisitVm {
        data = typeof data === 'object' ? data : {};
        let result = new JobSiteVisitVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobId"] = this.jobId;
        data["jobNumber"] = this.jobNumber;
        data["vehicleName"] = this.vehicleName;
        data["driverName"] = this.driverName;
        data["arrival"] = this.arrival ? this.arrival.toISOString() : <any>undefined;
        data["departure"] = this.departure ? this.departure.toISOString() : <any>undefined;
        data["durationSeconds"] = this.durationSeconds;
        data["idlingTimeSeconds"] = this.idlingTimeSeconds;
        data["visitNumber"] = this.visitNumber;
        return data;
    }
}

export interface IJobSiteVisitVm {
    jobId: string;
    jobNumber: string;
    vehicleName: string;
    driverName?: string | undefined;
    arrival: Date;
    departure: Date;
    durationSeconds: number;
    idlingTimeSeconds: number;
    visitNumber: number;
}

export class JobSiteVisitRequestVm implements IJobSiteVisitRequestVm {
    startDate!: Date;
    endDate!: Date;

    constructor(data?: IJobSiteVisitRequestVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): JobSiteVisitRequestVm {
        data = typeof data === 'object' ? data : {};
        let result = new JobSiteVisitRequestVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startDate"] = this.startDate ? formatDate(this.startDate) : <any>undefined;
        data["endDate"] = this.endDate ? formatDate(this.endDate) : <any>undefined;
        return data;
    }
}

export interface IJobSiteVisitRequestVm {
    startDate: Date;
    endDate: Date;
}

export class UiDataResponseOfTrackedResourceStatisticsVM extends UiResponse implements IUiDataResponseOfTrackedResourceStatisticsVM {
    data?: TrackedResourceStatisticsVM | undefined;

    constructor(data?: IUiDataResponseOfTrackedResourceStatisticsVM) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? TrackedResourceStatisticsVM.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UiDataResponseOfTrackedResourceStatisticsVM {
        data = typeof data === 'object' ? data : {};
        let result = new UiDataResponseOfTrackedResourceStatisticsVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IUiDataResponseOfTrackedResourceStatisticsVM extends IUiResponse {
    data?: TrackedResourceStatisticsVM | undefined;
}

export class TrackedResourceStatisticsVM implements ITrackedResourceStatisticsVM {
    id!: number;
    odometerInMiles?: number | undefined;
    engineRunTimeInHours?: number | undefined;

    constructor(data?: ITrackedResourceStatisticsVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.odometerInMiles = _data["odometerInMiles"];
            this.engineRunTimeInHours = _data["engineRunTimeInHours"];
        }
    }

    static fromJS(data: any): TrackedResourceStatisticsVM {
        data = typeof data === 'object' ? data : {};
        let result = new TrackedResourceStatisticsVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["odometerInMiles"] = this.odometerInMiles;
        data["engineRunTimeInHours"] = this.engineRunTimeInHours;
        return data;
    }
}

export interface ITrackedResourceStatisticsVM {
    id: number;
    odometerInMiles?: number | undefined;
    engineRunTimeInHours?: number | undefined;
}

export class UiDataResponseOfUserStatusVM extends UiResponse implements IUiDataResponseOfUserStatusVM {
    data?: UserStatusVM | undefined;

    constructor(data?: IUiDataResponseOfUserStatusVM) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? UserStatusVM.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UiDataResponseOfUserStatusVM {
        data = typeof data === 'object' ? data : {};
        let result = new UiDataResponseOfUserStatusVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IUiDataResponseOfUserStatusVM extends IUiResponse {
    data?: UserStatusVM | undefined;
}

export class UserStatusVM implements IUserStatusVM {
    tenantStatusVm?: TenantStatusVM;
    isUserRegistered?: boolean;

    constructor(data?: IUserStatusVM) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantStatusVm = _data["tenantStatusVm"] ? TenantStatusVM.fromJS(_data["tenantStatusVm"]) : <any>undefined;
            this.isUserRegistered = _data["isUserRegistered"];
        }
    }

    static fromJS(data: any): UserStatusVM {
        data = typeof data === 'object' ? data : {};
        let result = new UserStatusVM();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantStatusVm"] = this.tenantStatusVm ? this.tenantStatusVm.toJSON() : <any>undefined;
        data["isUserRegistered"] = this.isUserRegistered;
        return data;
    }
}

export interface IUserStatusVM {
    tenantStatusVm?: TenantStatusVM;
    isUserRegistered?: boolean;
}

export class UiDataResponseOfFeatureVmOf extends UiResponse implements IUiDataResponseOfFeatureVmOf {
    data?: FeatureVm[] | undefined;

    constructor(data?: IUiDataResponseOfFeatureVmOf) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(FeatureVm.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UiDataResponseOfFeatureVmOf {
        data = typeof data === 'object' ? data : {};
        let result = new UiDataResponseOfFeatureVmOf();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IUiDataResponseOfFeatureVmOf extends IUiResponse {
    data?: FeatureVm[] | undefined;
}

export class UiDataResponseOfEnvelopedModelOfMobileMaintenanceServiceEntryGridVm extends UiResponse implements IUiDataResponseOfEnvelopedModelOfMobileMaintenanceServiceEntryGridVm {
    data?: EnvelopedModelOfMobileMaintenanceServiceEntryGridVm | undefined;

    constructor(data?: IUiDataResponseOfEnvelopedModelOfMobileMaintenanceServiceEntryGridVm) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? EnvelopedModelOfMobileMaintenanceServiceEntryGridVm.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UiDataResponseOfEnvelopedModelOfMobileMaintenanceServiceEntryGridVm {
        data = typeof data === 'object' ? data : {};
        let result = new UiDataResponseOfEnvelopedModelOfMobileMaintenanceServiceEntryGridVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IUiDataResponseOfEnvelopedModelOfMobileMaintenanceServiceEntryGridVm extends IUiResponse {
    data?: EnvelopedModelOfMobileMaintenanceServiceEntryGridVm | undefined;
}

export class EnvelopedModelOfMobileMaintenanceServiceEntryGridVm implements IEnvelopedModelOfMobileMaintenanceServiceEntryGridVm {
    rows?: MobileMaintenanceServiceEntryGridVm[];
    totalItems?: number;

    constructor(data?: IEnvelopedModelOfMobileMaintenanceServiceEntryGridVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(MobileMaintenanceServiceEntryGridVm.fromJS(item));
            }
            this.totalItems = _data["totalItems"];
        }
    }

    static fromJS(data: any): EnvelopedModelOfMobileMaintenanceServiceEntryGridVm {
        data = typeof data === 'object' ? data : {};
        let result = new EnvelopedModelOfMobileMaintenanceServiceEntryGridVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        data["totalItems"] = this.totalItems;
        return data;
    }
}

export interface IEnvelopedModelOfMobileMaintenanceServiceEntryGridVm {
    rows?: MobileMaintenanceServiceEntryGridVm[];
    totalItems?: number;
}

export class MobileMaintenanceServiceEntryGridVm implements IMobileMaintenanceServiceEntryGridVm {
    id!: number;
    serviceTypes!: string[];
    serviceDate!: Date;
    vehicleName?: string | undefined;

    constructor(data?: IMobileMaintenanceServiceEntryGridVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.serviceTypes = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["serviceTypes"])) {
                this.serviceTypes = [] as any;
                for (let item of _data["serviceTypes"])
                    this.serviceTypes!.push(item);
            }
            this.serviceDate = _data["serviceDate"] ? new Date(_data["serviceDate"].toString()) : <any>undefined;
            this.vehicleName = _data["vehicleName"];
        }
    }

    static fromJS(data: any): MobileMaintenanceServiceEntryGridVm {
        data = typeof data === 'object' ? data : {};
        let result = new MobileMaintenanceServiceEntryGridVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.serviceTypes)) {
            data["serviceTypes"] = [];
            for (let item of this.serviceTypes)
                data["serviceTypes"].push(item);
        }
        data["serviceDate"] = this.serviceDate ? formatDate(this.serviceDate) : <any>undefined;
        data["vehicleName"] = this.vehicleName;
        return data;
    }
}

export interface IMobileMaintenanceServiceEntryGridVm {
    id: number;
    serviceTypes: string[];
    serviceDate: Date;
    vehicleName?: string | undefined;
}

export class UiDataResponseOfMobileMaintenanceServiceEntryDetailsVm extends UiResponse implements IUiDataResponseOfMobileMaintenanceServiceEntryDetailsVm {
    data?: MobileMaintenanceServiceEntryDetailsVm | undefined;

    constructor(data?: IUiDataResponseOfMobileMaintenanceServiceEntryDetailsVm) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? MobileMaintenanceServiceEntryDetailsVm.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UiDataResponseOfMobileMaintenanceServiceEntryDetailsVm {
        data = typeof data === 'object' ? data : {};
        let result = new UiDataResponseOfMobileMaintenanceServiceEntryDetailsVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IUiDataResponseOfMobileMaintenanceServiceEntryDetailsVm extends IUiResponse {
    data?: MobileMaintenanceServiceEntryDetailsVm | undefined;
}

export class MobileMaintenanceServiceEntryDetailsVm implements IMobileMaintenanceServiceEntryDetailsVm {
    id!: number;
    serviceTypes!: string[];
    serviceDate!: Date;
    category!: ServiceEntryCategory;
    odometerInMiles?: number | undefined;
    engineRunTimeInHours?: number | undefined;
    invoiceNumber?: string | undefined;
    totalCost!: number;
    state!: ServiceEntryState;
    serviceCenter?: string | undefined;
    notes?: string | undefined;
    serviceRecords!: MaintenanceServiceRecordVm[];
    fileAttachments?: FileAttachmentVm[] | undefined;
    vin!: string;
    vehicleName?: string | undefined;

    constructor(data?: IMobileMaintenanceServiceEntryDetailsVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.serviceTypes = [];
            this.serviceRecords = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["serviceTypes"])) {
                this.serviceTypes = [] as any;
                for (let item of _data["serviceTypes"])
                    this.serviceTypes!.push(item);
            }
            this.serviceDate = _data["serviceDate"] ? new Date(_data["serviceDate"].toString()) : <any>undefined;
            this.category = _data["category"];
            this.odometerInMiles = _data["odometerInMiles"];
            this.engineRunTimeInHours = _data["engineRunTimeInHours"];
            this.invoiceNumber = _data["invoiceNumber"];
            this.totalCost = _data["totalCost"];
            this.state = _data["state"];
            this.serviceCenter = _data["serviceCenter"];
            this.notes = _data["notes"];
            if (Array.isArray(_data["serviceRecords"])) {
                this.serviceRecords = [] as any;
                for (let item of _data["serviceRecords"])
                    this.serviceRecords!.push(MaintenanceServiceRecordVm.fromJS(item));
            }
            if (Array.isArray(_data["fileAttachments"])) {
                this.fileAttachments = [] as any;
                for (let item of _data["fileAttachments"])
                    this.fileAttachments!.push(FileAttachmentVm.fromJS(item));
            }
            this.vin = _data["vin"];
            this.vehicleName = _data["vehicleName"];
        }
    }

    static fromJS(data: any): MobileMaintenanceServiceEntryDetailsVm {
        data = typeof data === 'object' ? data : {};
        let result = new MobileMaintenanceServiceEntryDetailsVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.serviceTypes)) {
            data["serviceTypes"] = [];
            for (let item of this.serviceTypes)
                data["serviceTypes"].push(item);
        }
        data["serviceDate"] = this.serviceDate ? formatDate(this.serviceDate) : <any>undefined;
        data["category"] = this.category;
        data["odometerInMiles"] = this.odometerInMiles;
        data["engineRunTimeInHours"] = this.engineRunTimeInHours;
        data["invoiceNumber"] = this.invoiceNumber;
        data["totalCost"] = this.totalCost;
        data["state"] = this.state;
        data["serviceCenter"] = this.serviceCenter;
        data["notes"] = this.notes;
        if (Array.isArray(this.serviceRecords)) {
            data["serviceRecords"] = [];
            for (let item of this.serviceRecords)
                data["serviceRecords"].push(item.toJSON());
        }
        if (Array.isArray(this.fileAttachments)) {
            data["fileAttachments"] = [];
            for (let item of this.fileAttachments)
                data["fileAttachments"].push(item.toJSON());
        }
        data["vin"] = this.vin;
        data["vehicleName"] = this.vehicleName;
        return data;
    }
}

export interface IMobileMaintenanceServiceEntryDetailsVm {
    id: number;
    serviceTypes: string[];
    serviceDate: Date;
    category: ServiceEntryCategory;
    odometerInMiles?: number | undefined;
    engineRunTimeInHours?: number | undefined;
    invoiceNumber?: string | undefined;
    totalCost: number;
    state: ServiceEntryState;
    serviceCenter?: string | undefined;
    notes?: string | undefined;
    serviceRecords: MaintenanceServiceRecordVm[];
    fileAttachments?: FileAttachmentVm[] | undefined;
    vin: string;
    vehicleName?: string | undefined;
}

export class MobileMaintenanceServiceEntryCreateVm implements IMobileMaintenanceServiceEntryCreateVm {
    serviceDate!: Date;
    category!: ServiceEntryCategory;
    odometerInMiles?: number | undefined;
    engineRunTimeInHours?: number | undefined;
    invoiceNumber?: string | undefined;
    serviceCenter?: string | undefined;
    notes?: string | undefined;
    state!: ServiceEntryState;
    serviceRecords!: MaintenanceServiceRecordUpsertVm[];
    vin!: string;
    fileAttachments?: FileAttachmentCreateVm[] | undefined;

    constructor(data?: IMobileMaintenanceServiceEntryCreateVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.serviceRecords = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serviceDate = _data["serviceDate"] ? new Date(_data["serviceDate"].toString()) : <any>undefined;
            this.category = _data["category"];
            this.odometerInMiles = _data["odometerInMiles"];
            this.engineRunTimeInHours = _data["engineRunTimeInHours"];
            this.invoiceNumber = _data["invoiceNumber"];
            this.serviceCenter = _data["serviceCenter"];
            this.notes = _data["notes"];
            this.state = _data["state"];
            if (Array.isArray(_data["serviceRecords"])) {
                this.serviceRecords = [] as any;
                for (let item of _data["serviceRecords"])
                    this.serviceRecords!.push(MaintenanceServiceRecordUpsertVm.fromJS(item));
            }
            this.vin = _data["vin"];
            if (Array.isArray(_data["fileAttachments"])) {
                this.fileAttachments = [] as any;
                for (let item of _data["fileAttachments"])
                    this.fileAttachments!.push(FileAttachmentCreateVm.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MobileMaintenanceServiceEntryCreateVm {
        data = typeof data === 'object' ? data : {};
        let result = new MobileMaintenanceServiceEntryCreateVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serviceDate"] = this.serviceDate ? formatDate(this.serviceDate) : <any>undefined;
        data["category"] = this.category;
        data["odometerInMiles"] = this.odometerInMiles;
        data["engineRunTimeInHours"] = this.engineRunTimeInHours;
        data["invoiceNumber"] = this.invoiceNumber;
        data["serviceCenter"] = this.serviceCenter;
        data["notes"] = this.notes;
        data["state"] = this.state;
        if (Array.isArray(this.serviceRecords)) {
            data["serviceRecords"] = [];
            for (let item of this.serviceRecords)
                data["serviceRecords"].push(item.toJSON());
        }
        data["vin"] = this.vin;
        if (Array.isArray(this.fileAttachments)) {
            data["fileAttachments"] = [];
            for (let item of this.fileAttachments)
                data["fileAttachments"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMobileMaintenanceServiceEntryCreateVm {
    serviceDate: Date;
    category: ServiceEntryCategory;
    odometerInMiles?: number | undefined;
    engineRunTimeInHours?: number | undefined;
    invoiceNumber?: string | undefined;
    serviceCenter?: string | undefined;
    notes?: string | undefined;
    state: ServiceEntryState;
    serviceRecords: MaintenanceServiceRecordUpsertVm[];
    vin: string;
    fileAttachments?: FileAttachmentCreateVm[] | undefined;
}

export class MobileMaintenanceServiceEntryUpdateVm implements IMobileMaintenanceServiceEntryUpdateVm {
    serviceDate!: Date;
    category!: ServiceEntryCategory;
    odometerInMiles?: number | undefined;
    engineRunTimeInHours?: number | undefined;
    invoiceNumber?: string | undefined;
    serviceCenter?: string | undefined;
    notes?: string | undefined;
    state!: ServiceEntryState;
    serviceRecords!: MaintenanceServiceRecordUpsertVm[];
    id!: number;
    vin!: string;
    fileAttachments?: FileAttachmentUpsertVm[] | undefined;

    constructor(data?: IMobileMaintenanceServiceEntryUpdateVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.serviceRecords = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serviceDate = _data["serviceDate"] ? new Date(_data["serviceDate"].toString()) : <any>undefined;
            this.category = _data["category"];
            this.odometerInMiles = _data["odometerInMiles"];
            this.engineRunTimeInHours = _data["engineRunTimeInHours"];
            this.invoiceNumber = _data["invoiceNumber"];
            this.serviceCenter = _data["serviceCenter"];
            this.notes = _data["notes"];
            this.state = _data["state"];
            if (Array.isArray(_data["serviceRecords"])) {
                this.serviceRecords = [] as any;
                for (let item of _data["serviceRecords"])
                    this.serviceRecords!.push(MaintenanceServiceRecordUpsertVm.fromJS(item));
            }
            this.id = _data["id"];
            this.vin = _data["vin"];
            if (Array.isArray(_data["fileAttachments"])) {
                this.fileAttachments = [] as any;
                for (let item of _data["fileAttachments"])
                    this.fileAttachments!.push(FileAttachmentUpsertVm.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MobileMaintenanceServiceEntryUpdateVm {
        data = typeof data === 'object' ? data : {};
        let result = new MobileMaintenanceServiceEntryUpdateVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serviceDate"] = this.serviceDate ? formatDate(this.serviceDate) : <any>undefined;
        data["category"] = this.category;
        data["odometerInMiles"] = this.odometerInMiles;
        data["engineRunTimeInHours"] = this.engineRunTimeInHours;
        data["invoiceNumber"] = this.invoiceNumber;
        data["serviceCenter"] = this.serviceCenter;
        data["notes"] = this.notes;
        data["state"] = this.state;
        if (Array.isArray(this.serviceRecords)) {
            data["serviceRecords"] = [];
            for (let item of this.serviceRecords)
                data["serviceRecords"].push(item.toJSON());
        }
        data["id"] = this.id;
        data["vin"] = this.vin;
        if (Array.isArray(this.fileAttachments)) {
            data["fileAttachments"] = [];
            for (let item of this.fileAttachments)
                data["fileAttachments"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMobileMaintenanceServiceEntryUpdateVm {
    serviceDate: Date;
    category: ServiceEntryCategory;
    odometerInMiles?: number | undefined;
    engineRunTimeInHours?: number | undefined;
    invoiceNumber?: string | undefined;
    serviceCenter?: string | undefined;
    notes?: string | undefined;
    state: ServiceEntryState;
    serviceRecords: MaintenanceServiceRecordUpsertVm[];
    id: number;
    vin: string;
    fileAttachments?: FileAttachmentUpsertVm[] | undefined;
}

export class UiDataResponseOfEnvelopedModelOfMobileMaintenanceServiceEntryTypeVm extends UiResponse implements IUiDataResponseOfEnvelopedModelOfMobileMaintenanceServiceEntryTypeVm {
    data?: EnvelopedModelOfMobileMaintenanceServiceEntryTypeVm | undefined;

    constructor(data?: IUiDataResponseOfEnvelopedModelOfMobileMaintenanceServiceEntryTypeVm) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? EnvelopedModelOfMobileMaintenanceServiceEntryTypeVm.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UiDataResponseOfEnvelopedModelOfMobileMaintenanceServiceEntryTypeVm {
        data = typeof data === 'object' ? data : {};
        let result = new UiDataResponseOfEnvelopedModelOfMobileMaintenanceServiceEntryTypeVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IUiDataResponseOfEnvelopedModelOfMobileMaintenanceServiceEntryTypeVm extends IUiResponse {
    data?: EnvelopedModelOfMobileMaintenanceServiceEntryTypeVm | undefined;
}

export class EnvelopedModelOfMobileMaintenanceServiceEntryTypeVm implements IEnvelopedModelOfMobileMaintenanceServiceEntryTypeVm {
    rows?: MobileMaintenanceServiceEntryTypeVm[];
    totalItems?: number;

    constructor(data?: IEnvelopedModelOfMobileMaintenanceServiceEntryTypeVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(MobileMaintenanceServiceEntryTypeVm.fromJS(item));
            }
            this.totalItems = _data["totalItems"];
        }
    }

    static fromJS(data: any): EnvelopedModelOfMobileMaintenanceServiceEntryTypeVm {
        data = typeof data === 'object' ? data : {};
        let result = new EnvelopedModelOfMobileMaintenanceServiceEntryTypeVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        data["totalItems"] = this.totalItems;
        return data;
    }
}

export interface IEnvelopedModelOfMobileMaintenanceServiceEntryTypeVm {
    rows?: MobileMaintenanceServiceEntryTypeVm[];
    totalItems?: number;
}

export class MobileMaintenanceServiceEntryTypeVm implements IMobileMaintenanceServiceEntryTypeVm {
    id!: number;
    name!: string;

    constructor(data?: IMobileMaintenanceServiceEntryTypeVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): MobileMaintenanceServiceEntryTypeVm {
        data = typeof data === 'object' ? data : {};
        let result = new MobileMaintenanceServiceEntryTypeVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IMobileMaintenanceServiceEntryTypeVm {
    id: number;
    name: string;
}

export class UiDataResponseOfEnvelopedModelOfMobileVehicleVm extends UiResponse implements IUiDataResponseOfEnvelopedModelOfMobileVehicleVm {
    data?: EnvelopedModelOfMobileVehicleVm | undefined;

    constructor(data?: IUiDataResponseOfEnvelopedModelOfMobileVehicleVm) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? EnvelopedModelOfMobileVehicleVm.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UiDataResponseOfEnvelopedModelOfMobileVehicleVm {
        data = typeof data === 'object' ? data : {};
        let result = new UiDataResponseOfEnvelopedModelOfMobileVehicleVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IUiDataResponseOfEnvelopedModelOfMobileVehicleVm extends IUiResponse {
    data?: EnvelopedModelOfMobileVehicleVm | undefined;
}

export class EnvelopedModelOfMobileVehicleVm implements IEnvelopedModelOfMobileVehicleVm {
    rows?: MobileVehicleVm[];
    totalItems?: number;

    constructor(data?: IEnvelopedModelOfMobileVehicleVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(MobileVehicleVm.fromJS(item));
            }
            this.totalItems = _data["totalItems"];
        }
    }

    static fromJS(data: any): EnvelopedModelOfMobileVehicleVm {
        data = typeof data === 'object' ? data : {};
        let result = new EnvelopedModelOfMobileVehicleVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        data["totalItems"] = this.totalItems;
        return data;
    }
}

export interface IEnvelopedModelOfMobileVehicleVm {
    rows?: MobileVehicleVm[];
    totalItems?: number;
}

export class MobileVehicleVm implements IMobileVehicleVm {
    vin!: string;
    vehicleName?: string | undefined;

    constructor(data?: IMobileVehicleVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vin = _data["vin"];
            this.vehicleName = _data["vehicleName"];
        }
    }

    static fromJS(data: any): MobileVehicleVm {
        data = typeof data === 'object' ? data : {};
        let result = new MobileVehicleVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vin"] = this.vin;
        data["vehicleName"] = this.vehicleName;
        return data;
    }
}

export interface IMobileVehicleVm {
    vin: string;
    vehicleName?: string | undefined;
}

function formatDate(d: Date) {
    return d.getFullYear() + '-' + 
        (d.getMonth() < 9 ? ('0' + (d.getMonth()+1)) : (d.getMonth()+1)) + '-' +
        (d.getDate() < 10 ? ('0' + d.getDate()) : d.getDate());
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}